export default {
  translation: {
    Automation_flow_templates: "Axın şablonları",
    Automation_ai_templates: "Süni intellekt şablonları",
    Automation_sample: "Nümunə",
    Automation_sample_notice: "Əvvəlcədən hazırlanmış şablonlardan istifadə edə və onları dəyişdirə bilərsiniz",
    Automation_template_number: "Şablon #{{number}}",
    Automation_beginner: "Başlanğıc",
    Automation_intermediate: "Orta",
    Automation_advanced: "Qabaqcıl",
    Automation_trending: "Populyar",
    Automation_sample_cart: "Alış-veriş səbətinin bərpası",
    Automation_sample_cart_description:
      "Nümunə fikir: alıcıların səbətə qayıtmasına kömək edin və suallarını cavablandırın.",
    Automation_sample_language: "Çoxdilli söhbətlər",
    Automation_sample_language_description: "Nümunə fikir: ziyarətçiləri seçdikləri dildə söhbətə yönləndirin.",
    Automation_sample_support: "Müştəri dəstək köməkçisi",
    Automation_sample_support_description:
      "Nümunə fikir: tez-tez verilən sualları cavablandırın və növbəti addımı göstərin.",
    Automation_sample_welcome: "Yeni müştəriləri qarşılayın",
    Automation_sample_welcome_description: "Nümunə fikir: yeni ziyarətçiləri qarşılayın və məhsullarınızı təqdim edin.",
    Automation_flow_history: "Axın tarixçəsi",
    Automation_ai_history: "Süni intellekt tarixçəsi",
    Automation_loaded_count: "Yüklənmiş elementlər; + daha çox element olduğunu göstərir.",
    Automation_sort_newest: " əvvəlcə yenilər",
    Automation_sort_oldest: " əvvəlcə köhnələr",
    Automation_sort_title: " başlığa görə",
    Automation_connected_posts: "Bağlı paylaşımlar",
    Automation_not_connected: "Heç bir paylaşıma bağlı deyil.",
    Automation_connections_access: "Şərh icazəsi və Avtomatlaşdırma/Şərh girişi tələb olunur.",
    Automation_checking_connections: "Paylaşım bağlantıları yoxlanılır...",
    Automation_connections_retry: "Bütün bağlantılar yoxlanıla bilmədi. Yenidən cəhd edin.",
    aiSuggestedPrompts_title: "Təklif olunan promptlar",
    aiSuggestedPrompts_openImage: "Şəkli tam ekranda aç",
    aiSuggestedPrompts_explain: "Başlanğıc kimi istifadə etmək üçün prompt seçin.",
    aiSuggestedPrompts_category: "Prompt kateqoriyası",
    aiSuggestedPrompts_subCategory: "Alt kateqoriya",
    aiSuggestedPrompts_allCategories: "Bütün kateqoriyalar",
    aiSuggestedPrompts_loading: "Yüklənir...",
    aiSuggestedPrompts_empty: "Təklif olunan prompt tapılmadı.",
    aiSuggestedPrompts_loadMore: "Daha çox yüklə",
    aiSuggestedPrompts_prompt: "Prompt",
    aiSuggestedPrompts_copy: "Promptu kopyala",
    aiSuggestedPrompts_showMore: "Daha çox göstər",
    aiSuggestedPrompts_showLess: "Daha az göstər",
    unpin: "Pin-i Ləğv Et",
    pin: "Pin Et",
    usethisPrompt: "Prompt daxilində istifadə et",
    AudienceTooltip:
      "Cari qarşılıqlı əlaqəni daha dəqiq ölçmək üçün statistika son 30 gündəki fəaliyyətinizə əsasən göstərilir; Instagram statistikası hesabın bütün fəaliyyət dövrünü əhatə edir və bu məlumatlardan fərqlənə bilər",
    toggleShowAll: "Hamısını Göstər",
    toggleShowmonthly: "Aylıq Göstər",
    Nodetutorial: "Blok İzahı",
    Dublicate: "Dublikat Et",
    zoomout: "Uzaqlaşdır",
    fitscreen: "Ekrana Uyğunlaşdır",
    zoomin: "Yaxınlaşdır",
    shortcuts: "Qısayollar",
    Workflow_Statistics: "İş Axını Statistikası",
    History_saved: "Saxlanılmış Tarixçələr",
    Data_Management_explain:
      "İş axınınınızı saxlaya və lazım gəldikdə digər platformalardan iş axınlarını idxal edə bilərsiniz.",
    flow_shortcuts_explain:
      "İş axınlarının idarə edilməsində sürəti və səmərəliliyi artırmaq üçün klaviatura qısayolları.",
    Nodes: "Nodlar",
    Connections: "Bağlantılar",
    Last_Auto_saved: "Son Avtomatik Yadda Saxlama",
    Canvas_Behavior: "Kanvas Davranışı",
    Canvas_Behavior_explain: "Daha yaxşı idarə üçün tor hizalanmasını və sürüşmə sərhədlərini tənzimləyin",
    Data_Management: "Məlumat İdarəçiliyi",
    importJSON_success: "Fayl uğurla idxal edildi",
    importJSON_error: "Faylı idxal edərkən xəta baş verdi",
    exportJSON: "JSON İxrac Et",
    importJSON: "JSON İdxal Et",

    quantity: "Miqdar",
    allquantity: "Ümumi Miqdar",
    remainingquantity: "Qalan Miqdar",
    Connecting: "Qoşulma",
    Connected: "Qoşuldu",
    EmailNotification: "E-poçt Bildirişləri",
    EmailNotificationExplain: "Sistem bildirişləri bu E-poçt ünvanına göndərilir.",
    MobileNotification: "Mobil Bildirişlər",
    MobileNotificationExplain: "Sistem bildirişləri bu Mobil nömrəyə göndərilir.",
    usersettingexplain:
      "Instagram hesab məlumatları yalnız Instagram daxilində dəyişdirilə bilər və burada avtomatik yenilənəcək.",
    Responded: "Cavab verildi",
    notimelimit: "Vaxt məhdudiyyəti yoxdur",
    loading: "Yüklənir...",
    Beginner: "Başlanğıc",
    Basic: "Əsas",
    Growing: "İnkişaf edir",
    Advanced: "İrəliləmiş",
    Professional: "Peşəkar",
    Special: "Xüsusi",
    Unavailable: "Aktiv deyil",
    menu: "Menyu",
    level: "Səviyyə",
    bestposts: "Ən yaxşı postlar",
    upgradeyouraccount: "Hesabınızı yüksəldin",
    featureNotAvailable: "Bu xüsusiyyət mövcud deyil",
    featureNotAvailableDesc: "Bu xüsusiyyətdən istifadə etmək üçün hesabınızı yüksəldin.",
    likeaprouser: "Həqiqi bir biznes qurun",
    followerrate: "Follower artım dərəcəsi",

    shoppertitle: "Satış üçün hər şey hazırdır👌",
    advertisertitle: "Reklam üçün hər şey hazırdır👌",
    shopperdescription: "Satış performansını dəqiq izləyin.",
    advertiserdescription: "Reklam performansını dəqiq izləyin.",
    syncingAccountTitle: "Məlumatlar Alınır",
    syncingAccountDescription: "Instagram məlumatlarınız Brancy-də yenilənir",
    syncingAccountDescriptiontooltip: "Məlumatlarınızın bəziləri növbəti 24 saat ərzində yenilənəcək.",
    subscriptionExpiringTitle: "Abunəliyiniz Bitmək Üzrədir",
    subscriptionExpiringDescription: "Mövcud funksiyalardan istifadə etməyə davam etmək üçün abunəliyinizi yeniləyin.",
    subscriptionDaysRemaining: "{{days}} gün qalıb",

    daysAgo: "gün əvvəl",
    hoursAgo: "saat əvvəl",
    minutesAgo: "dəqiqə əvvəl",
    justNow: "indi",
    unselect: "Seçimi ləğv et",
    shopper: "Satıcı",
    onlinestore: "Onlayn mağaza",
    onlinestoreExplain: "Daha çox satış üçün lazım olan hər şey, bir yerdə.",
    influencerExplain: "Reklamçılar və influencerlər üçün bütün peşəkar alətlər",
    advertiser: "Reklamçı",
    influencer: "Influencer",
    skip: "Keç",
    skipfornow: "Hələlik keç",
    freedays: "40 gün",
    freedaysExplain:
      "Əgər aktiv və inkişaf edən Instagram səhifəniz varsa, bu plan sizin üçün hazırlanıb. Alətlərə tam giriş, statistik analiz, məzmun idarəsi, mesajlar və rəylər, həmçinin Brancy-də əməkdaş admin yaratmaq aktivdir.",
    instagramerplanactive: "Instagram planınız aktivdir",
    influencerplanactive: "Influencer planınız aktivdir",
    onlinestoreplanactive: "Onlayn mağaza planınız aktivdir",

    SwitchtoUserpanel: "İstifadəçi olaraq daxil olun",
    chooselanguage: "Dil seçin",
    chooselanguageExplain: "İstədiyiniz dili seçin",
    chooseTheme: "Tema seçin",
    chooseThemeExplain: "Sevdiyiniz temanı seçin",
    chooseCalendar: "Təqvim seçin",
    chooseCalendarExplain: "İstədiyiniz təqvim növünü seçin",
    setupchooseexplain: "Bu tənzimləmələri sonra 'Settings' bölməsində dəyişmək olar",

    Lottery: "Lotereya",
    services: "Xidmətlər",
    markets: "Platformalar",
    pricing: "Qiymətləmə",
    page1_text1: "Instagram biznes idarəsi",
    page1_text2: "Yeni nəsillə",
    page1_StartNow: "Peşəkar alətlərə giriş ilə pulsuz başlayın",
    page1_services: "Xidmətlər",
    page1_analytics: "Analitikalar",
    page1_transportation: "Nəqliyyat",
    page1_financial_solutions: "Maliyyə həlləri",
    page1_customer_communication: "Müştəri ilə əlaqə",
    page1_content_management: "Məzmun idarəsi",
    page1_artificial_intelligence: "Süni intellekt",
    page1_tools: "Alətlər",
    page1_advertises: "Reklam idarəsi",
    page2_text1: "Ən tam biznes həlləri və xidmətlər",
    page2_text2:
      "Brancy Instagram hesabınızı idarə etmək üçün güclü bir alətdir və uğur üçün lazım olan vasitələri sizə təqdim edir.",
    page2_ads_statistics_title: "Statistika",
    page2_ads_statistics_description: "İrəliləmiş performans analizi aləti",
    page2_ads_statistics_servicedescription:
      "Bu dəqiq və anlıq alətlə reklam göstəricilərini izləyin və kampaniyaları optimallaşdırın.",
    page2_ads_calendar_title: "İş təqvimi",
    page2_ads_calendar_description: "Ən səmərəli reklam idarəsi",
    page2_ads_calendar_servicedescription:
      "AI tərəfindən təklif olunan reklamları ağıllı təqvimdə idarə edin, sürətli və səhvsiz planlama edin.",
    page2_ads_adlist_title: "Reklam siyahısı",
    page2_ads_adlist_description: "Təsdiq gözləyən reklamların siyahısı",
    page2_ads_adlist_servicedescription:
      "Təsdiq gözləyən reklamların dəqiq siyahısını görün və bir kliklə təsdiqləyin və ya rədd edin; asan və peşəkar idarə.",
    page2_store_addproduct_title: "Məhsul əlavə et",
    page2_store_addproduct_description: "Səhifədən bütün məhsulların tanınması",
    page2_store_addproduct_servicedescription:
      "Ağıllı sistem bütün məhsullarınızı avtomatik tanıyır və əlavə etməyə hazır edir. Sürəti artırır, səhvləri azaldır.",
    page2_store_productlist_title: "Məhsul siyahısı",
    page2_store_productlist_description: "Anbar və məhsul idarəsi",
    page2_store_productlist_servicedescription:
      "Məhsulları və stokları dəqiq və peşəkar idarə edin. Hər şey ağıllı və hesabatlıdır.",
    page2_store_orders_title: "Sifarişlər",
    page2_store_orders_description: "Sifariş, faktura və göndəriş idarəsi",
    page2_store_orders_servicedescription:
      "Sifarişdən tutmuş faktura və göndərişə qədər bütün proseslər avtomatik və dəqiq aparılır. Müştəriyə sürətli və problemsiz təcrübə.",
    page2_store_statistics_title: "Statistika",
    page2_store_statistics_description: "İrəliləmiş performans analizi aləti",
    page2_store_statistics_servicedescription:
      "Satış, gəlir və inkişaf meyillərini təhlil edin, ağıllı qərarlar verin.",
    page2_delivery_smartshipping_title: "Ağıllı göndərmə xərci",
    page2_delivery_smartshipping_description: "Xərclər başlanğıc, təyinat, ölçü və çəkiyə görə",
    page2_delivery_smartshipping_servicedescription:
      "Göndərmə xərclərini başlanğıc, təyinat, ölçü və çəkiyə görə dəqiq və avtomatik hesablayın, insan səhvi olmadan.",
    page2_delivery_postalservice_title: "Poçt xidməti",
    page2_delivery_postalservice_description: "Göndərişlərin toplanması və göndərilməsi",
    page2_delivery_postalservice_servicedescription:
      "Məhsullar ağıllı şəkildə mağazadan toplanır və əl ilə izləməyə ehtiyac olmadan təyinat yerinə göndərilir. Sürətli və nizamlı logistika təcrübəsi.",
    page2_delivery_tracking_title: "Göndəriş izləmə",
    page2_delivery_tracking_description: "Avtomatik izləmə və göstərmə",
    page2_delivery_tracking_servicedescription:
      "Müştərilər üçün dəqiq və anlıq vəziyyət göstərmə ilə avtomatik izləmə, tam şəffaflıq və etibar təmin edir.",
    page2_jobs_subadmin_title: "Əməkdaş admin",
    page2_jobs_subadmin_description: "Əməkdaş admin əlavə etmək imkanı",
    page2_jobs_subadmin_servicedescription:
      "Şifrə paylaşmadan əməkdaş admin əlavə edin və icazələri fərdiləşdirin. Tam nəzarət və təmin edilmiş təhlükəsizlik.",
    page2_ids_store_title: "ID mağazası",
    page2_ids_store_description: "Instagram ID-lərinin alqı-satqısı",
    page2_ids_store_servicedescription:
      "Instagram hesablarını alıb-satın, şəxsiyyət təsdiqi və təhlükəsizlik ilə. Dəqiq analiz, ağıllı qiymətləndirmə, hərrac və statistika yoxlaması—all in one place.",
    page2_publish_contentmanagement_title: "Məzmun idarəsi",
    page2_publish_contentmanagement_description: "Post və story idarəsi",
    page2_publish_contentmanagement_servicedescription:
      "Bütün post və story-ləri inkişaf etmiş və ağıllı platformada idarə edin, zamanlama, kateqoriyalaşdırma və sürətli paylaşım ilə sosial şəbəkəni rahat idarə edin.",
    page2_publish_contentpublishing_title: "Məzmun yayımı",
    page2_publish_contentpublishing_description: "Post və story-lərin zamanlanmış yayımı",
    page2_publish_contentpublishing_servicedescription:
      "Post və story-ləri ağıllı və zamanlanmış şəkildə paylaşın. Sistem follower davranış analizinə əsaslanaraq ən yaxşı vaxtı təklif edir.",
    page2_publish_analytics_title: "Post və story analizi",
    page2_publish_analytics_description: "Tam məzmun analizi",
    page2_publish_analytics_servicedescription:
      "Məzmunun performansı və auditoriya rəyləri haqqında dərindən məlumat əldə edin və məzmun strategiyanızı optimallaşdırın.",
    page2_publish_statistics_title: "Statistika",
    page2_publish_statistics_description: "İrəliləmiş performans analizi aləti",
    page2_publish_statistics_servicedescription:
      "Post və story-lərin performansı, qrafiklər və detallı analiz ilə ən inkişaf etmiş məzmun analiz aləti, daha yaxşı qərar vermək üçün.",
    page2_extension_biolink_title: "Bio link",
    page2_extension_biolink_description: "Bio-da sadə linkdən daha çox",
    page2_extension_biolink_servicedescription:
      "Bütün vacib linklərinizi göstərən xüsusi və gözəl səhifə, reaktiv dizayn və tam fərdiləşdirmə ilə, sadə linkdən daha çox.",
    page2_extension_paymentgateway_title: "Ödəniş qapısı",
    page2_extension_paymentgateway_description: "Xüsusi ödəniş qapısı",
    page2_extension_paymentgateway_servicedescription:
      "Texniki bilik tələb etmədən təhlükəsiz və xüsusi ödəniş qapısı, dəqiq hesabat və əməliyyat idarəsi ilə istifadəçi dostu mühitdə.",
    page2_extension_customwebsite_title: "Xüsusi veb sayt",
    page2_extension_customwebsite_description: "Sizin səhifəyə uyğun xüsusi veb sayt",
    page2_extension_customwebsite_servicedescription:
      "Səhifənin vizual identikliyi ilə uyğun xüsusi sayt, kod yazmadan. Məhsul və xidmətlərinizi peşəkar göstər.",
    page4_menu_instagram_management: "Instagram səhifə idarəsi",
    page4_menu_admin_subadmin: "Admin və əməkdaş admin",
    page4_menu_store_shipping: "Mağaza və göndərmə",
    page4_menu_advertising: "Reklamlar",
    page4_menu_hashtag_management: "Hashtag idarəsi",
    page4_menu_ai_analysis: "Süni intellekt ilə ağıllı analiz",
    page4_menu_ad_scheduling: "Reklamların zamanlanması",
    page4_menu_financial_wallet: "Maliyyə və cüzdan",
    page4_menu_page_statistics: "Səhifə statistikası",
    page4_menu_professional_messaging: "Peşəkar mesajlaşma",

    page4_content_instagram_management_text:
      "Səhifənin bütün hissələrini—məzmunun paylaşımından şərhlərə və DM-lərə cavab verməyə qədər—bir platformada peşəkar idarə et. Bir neçə app lazım deyil!",
    page4_content_admin_subadmin_text:
      "Komanda qur! Rolları təyin et, icazələri məhdudlaşdır və insan səhvlərindən narahat olmadan fəaliyyətləri idarə et.",
    page4_content_store_shipping_text:
      "Həqiqi Instagram mağazası! Stok, sifariş, faktura və göndərişi bir paneldən idarə et. Onlayn satış daha rahat!",
    page4_content_advertising_text:
      "Instagram reklamlarını bir neçə kliklə dizayn, icra və analiz et! Hədəf auditoriya təyin et, effektivliyi ölç və büdcəni israf etmə.",
    page4_content_hashtag_management_text:
      "Hashtag-larını ağıllı seç! Əlaqəli ən yaxşı hashtag-ləri analiz, yadda saxla, kateqoriyalaşdır və hər post üçün təklif al.",
    page4_content_ai_analysis_text:
      "Follower davranışını dəqiq analiz et! Nümunələr, maraqlar və yüksək aktiv saatları süni intellekt ilə aşkar et və strategiyanı yaxşılaşdır.",
    page4_content_ad_scheduling_text:
      "Reklamlar yatanda da işləsin! Kampaniyaları planla, başlama və bitmə vaxtını təyin et və narahat olmadan inkişaf et.",
    page4_content_financial_wallet_text:
      "Bütün əməliyyatları izləyin! Gəlir, xərclər, cüzdan balansı və tam maliyyə hesabatları ilə sərmayəni yaxşı idarə et.",
    page4_content_page_statistics_text:
      "Səhifənin dəqiq və real artım statistikası: qarşılıqlı təsir dərəcəsi, follower artımı, post performansı, baxışlar və dəyərli məlumatlar ağıllı qərar üçün.",
    page4_content_professional_messaging_text:
      "Həqiqi direct marketing təcrübəsi! Qrup mesajı göndər, avtomatik cavab qur və follower-lərlə söhbətləri peşəkar idarə et.",

    shipping: "Poçt xidməti",
    jobs: "İş elanları",
    IDstore: "ID mağazası",
    page3_text1: "Biznesinizin bütün ehtiyaclarına həll yolu",
    page5_whyBrancy: "Niyə Brancy?",
    page5_title1: "Rəsmi və təhlükəsiz Instagram tərəfdaşı",
    page5_title2: "İnteqrasiya olunmuş ekosistem, ağıllı qənaət",
    page5_title3: "Peşəkar ağıllı qarşılıqlı əlaqə",
    page5_title4: "Super inkişaf etmiş və ağıllı dashboard",
    page5_title5: "Ağıllı satış və logistika sistemi",
    page5_title6: "Xüsusi ağıllı veb sayt",
    page5_explain1: "Həssas məlumatlara giriş olmadan ağıllı idarə; təhlükəsiz və Instagram ilə uyğun.",
    page5_explain2: "Bütün alətlər bir yerdə; 70% xərc qənaəti, 80% zaman qənaəti.",
    page5_explain3: "Süni intellekt ilə avtomatik cavab; 40% daha çox qarşılıqlı əlaqə, 90% müştəri qorunması.",
    page5_explain4: "Sürətli interfeys, canlı analiz, adminlər, zamanlama və hesabatlar.",
    page5_explain5: "Direct satış; qapı, mağaza, göndərmə və ağıllı stok.",
    page5_explain6: "Peşəkar sayt və bio link; satış, rezervasiya, SEO və şəbəkələr.",

    page9_planheader: "Peşəkar başlayın və xüsusiyyətlərdən zövq alın!",
    page9_planexplain: "40 gün tam, pulsuz və limitsiz giriş!",
    page9_plantitle: "Instagram səhifənizin follower sayını seçin, uyğun paket göstərilsin",
    page9_freeplan: "Pulsuz",
    page9_basicplan: "Əsas",
    page9_proplan: "Peşəkar",
    page9_adsplan: "Reklam",
    page9_storeplan: "Mağaza",
    page9_monthly: "Aylıq",
    page9_Compare: "Paketlərin tam müqayisəsi",
    page9_content_management: "Post və story idarəsi",
    page9_analize_management: "İrəliləmiş analiz və statistik alətlər",
    page9_message_management: "DM və şərh idarəsi",
    page9_biolink_management: "Bio link və xüsusi sayt",
    page9_subadmin_management: "Admin və əməkdaş admin idarəsi",

    page9_basicoption: "Əsas xüsusiyyətlər",
    page9_ticket_management: "DM və bilet satışları",
    page9_finance_management: "Ödəniş qapısı və cüzdan",
    page9_store_management: "Ağıllı mağaza anbar idarəsi",
    page9_logestic_management: "Avtomatik göndəriş və çatdırılma",
    page9_storeanalize_management: "İrəliləmiş statistika",
    page9_calendar_management: "Reklamların zamanlama təqvimi",
    page9_advertise_management: "Ağıllı reklam idarəsi",
    page9_adsanalize_management: "İrəliləmiş reklam statistikasının izlənməsi",
    page9_campagin_management: "Kampaniyalar yarat və iştirak et",
    page9_adsticket_management: "Reklam geri bildirimlərinin avtomatik göndərilməsi",

    page6_Header: "Minlərlə aktiv biznes",
    page6_Explain: "Əksər uğurlu bizneslər Brancy ailəsinə qoşulub",
    page10_header: "Müştərilərimiz nə deyir",
    page8_HelpCenter: "Kömək Mərkəzi",
    page8_Community: "İstifadəçi icması",
    page8_learn: "Öyrənmək",
    page8_Blog: "Bloq",
    page8_FAQ: "Tez-tez soruşulan suallar",
    Addfaq: "Tez-tez soruşulan suallar əlavə et",
    addfaqexplain: "Ən çox 4 sual əlavə edə bilərsiniz",
    faqEmptyState: "Tez-tez soruşulan suallar burada göstəriləcək",

    page8_Support: "Dəstək",
    support_Online: "Onlayn dəstək",
    support_EnterBlog: "Bloqa daxil ol",
    page8_CommunityExplain:
      "Digər istifadəçilərlə əlaqədə olun, təcrübələr paylaşın və kollektiv məsləhətdən faydalanın.",
    page8_learnExplain:
      "Bu bölümdə Instagram-dan biznesdə istifadə üçün ən yeni strategiyaları öyrənəcəksiniz. Böyümək üçün lazım olan hər şeyi buradan tapın.",
    page8_BlogExplain:
      "Ən son məqalələr və tədris materiallarına çıxış əldə edin. Müxtəlif biznes və rəqəmsal marketinq mövzularında güncel məlumatlar sizi gözləyir.",
    page8_FAQExplain:
      "Tez-tez soruşulan suallarınız buradan cavablandırılır. Xidmətlər və məhsullar haqqında hər hansı bir rəhbərlik üçün buraya baxın.",
    page8_SupportExplain:
      "Dəstək komandamız sizə kömək etməyə hazırdır. Hər hansı problem və ya sualınız varsa, bizimlə əlaqə saxlayın.",
    page8_CommunityBTN: "Birlikdə öyrənək",
    page8_learnBTN: "Tez öyrən",
    page8_BlogBTN: "Ən son xəbərlər",
    page8_FAQBTN: "Tez cavablar",
    page8_SupportBTN: "Biz cavab veririk",
    footer_Brancy: "Brancy",
    footer_AboutUs: "Haqqımızda",
    footer_ContactUs: "Bizimlə əlaqə",
    footer_JoinUs: "Bizə qoşul",
    footer_OrgChart: "Təşkilati qrafik",
    footer_FollowUs: "Bizi izləyin",
    footer_Solutions: "Həllər",
    footer_HelpCenter: "Kömək Mərkəzi",
    footer_Support: "Dəstək",
    footer_FAQ: "Tez-tez soruşulan suallar",
    footer_ReportAnIssue: "Problem bildir",
    footer_TrustLegal: "Sosial məsuliyyət",
    footer_TermsAndConditions: "Şərtlər və qaydalar",
    footer_PrivacyNotice: "Məxfilik bildirişi",
    footer_CookieNotice: "Cookie bildirişi",
    footer_Blog: "Bloq",
    footer_ProductUpdates: "Ən son yeniliklər",
    footer_Articles: "Məqalələr",
    footer_LatestNews: "Ən son xəbərlər",
    installPromptMessage: "Brancy veb tətbiqini quraşdırın",
    install: "Quraşdır",
    installStep1: "Aşağıdaki paylaşım düyməsinə toxunun.",
    installStep2: "Açılan menyunu yuxarı sürüşdürün və Add to Home Screen seçin.",
    installStep3: "Ekranın yuxarısında Add düyməsini seçin.",
    joinUs_subtitle: "Brancy'ə Qoşulun; İnnovasiya Və Davamlı Gələcək Burada Formalaşır.",
    joinUs_whyWorkWithUs: "Niyə Brancy?",
    joinUs_whyWorkWithUsDescription:
      "Brancy Sadəcə İş Yeri Deyil; Peşəkar Və Şəxsi İnkişaf Üçün Strateji Bir Platformadır. Biz İnanırıq Ki, Lider Təşkilatlar Ən Yaxşı İstedadlarla Qurulur. Məqsədimiz Komanda Üzvlərinin Davamlı Təsir Yaradacağı Dinamik, Şəffaf Və Dəstəkləyici Mühit Yaratmaqdır.",
    joinUs_openPositions: "Açıq Vəzifələr",
    joinUs_openPositionsDescription: "Mövcud İmkanları Araşdırın Və İxtisasınıza Və Karyera Yolunuza Uyğun Rolu Seçin.",
    joinUs_frontendDeveloper: "Frontend İnkişaf etdirici",
    joinUs_frontendDeveloperDescription:
      "React Və TypeScript İlə Müasir İstifadəçi Təcrübələri Dizayn Edin Və Həyata Keçirin. Məhsullarımızın Keyfiyyətini Və Səmərəliliyini Artırmaqda Əsas Rol Oynayacaqsınız.",
    joinUs_backendDeveloper: "Backend İnkişaf etdirici",
    joinUs_backendDeveloperDescription:
      "Node.js Və Bulud Texnologiyaları İlə Ölçülən Və Təhlükəsiz Sistemlər Dizayn Edin Və İnkişaf etdirin. Sistem Düşüncəsi Və Çətin Problemlərin Həll Bacarığı Tələb Olunur.",
    joinUs_uiUxDesigner: "UI/UX Dizayner",
    joinUs_uiUxDesignerDescription:
      "İstifadəçi Məmnuniyyətini Və Sadiqliyini Təmin Etmək Üçün Standart İnterfeyslər Və İntuitiv Təcrübələr Yaradın. Detallara Diqqət Və Yaradıcılıq Vacibdir.",
    joinUs_productManager: "Məhsul Meneceri",
    joinUs_productManagerDescription:
      "Məhsul Strategiyasını İdarə Edin Və Rəqabətqabiliyyətli Və Səmərəli Həllər Təqdim Etmək Üçün Komandaları Koordinasiya Edin. Analitik Baxış Və Pay Sahiblərini İdarə Etmək Bacarığı Olanlar Üçün Uyğundur.",
    joinUs_marketingSpecialist: "Marketinq Mütəxəssisi",
    joinUs_marketingSpecialistDescription:
      "Rəqəmsal Kampaniyaları Planlayın Və İcra Edin, Marka Mövqeyini Gücləndirin. Analitik Bacarıqlar Və Yaradıcılığın Birləşməsidir.",
    joinUs_customerSupport: "Müştəri Dəstək Mütəxəssisi",
    joinUs_customerSupportDescription:
      "Peşəkar Dəstək Təmin Edin, Problemləri Həll Edin Və İstifadəçi Təcrübəsini Təkmilləşdirin. Dəqiqlik, Səbr Və Ünsiyyət Bacarıqları Tələb Olunur.",
    joinUs_engineering: "Mühəndislik",
    joinUs_design: "Dizayn",
    joinUs_product: "Məhsul",
    joinUs_marketing: "Marketinq",
    joinUs_support: "Dəstək",
    joinUs_remoteOnsite: "Uzaqdan / Ofisdə",
    joinUs_onsite: "Ofisdə",
    joinUs_remote: "Uzaqdan",
    joinUs_fullTime: "Tam İş Günü",
    joinUs_partTimeFullTime: "Yarı İş / Tam İş",
    joinUs_applyNow: "İndi Müraciət Et",
    joinUs_applicationProcess: "Brancy İşə Qəbul Prosesi",
    joinUs_submitApplication: "Müraciəti Göndər",
    joinUs_submitApplicationDescription: "CV-nizi və bacarıqlarınızı göndərin. Komandamız diqqətlə nəzərdən keçirəcək.",
    joinUs_initialScreening: "İlkin Seçim",
    joinUs_initialScreeningDescription:
      "HR şöbəsi CV-ləri 3–5 iş günü ərzində nəzərdən keçirir və uyğun olduqda əlaqə saxlayır.",
    joinUs_technicalInterview: "Texniki Müsahibə",
    joinUs_technicalInterviewDescription:
      "Komandalarla xüsusi müsahibələr vasitəsilə texniki bilik və təcrübənin qiymətləndirilməsi.",
    joinUs_finalInterview: "Son Müsahibə",
    joinUs_finalInterviewDescription:
      "Məqsəd və dəyərlərin uyğunluğunu təmin etmək üçün rəhbərlər və əsas komandalarla son görüş.",
    joinUs_welcomeAboard: "Xoş Gəlmisiniz",
    joinUs_welcomeAboardDescription:
      "Qəbul edildikdən sonra, təşkilatın mədəniyyəti və məqsədləri ilə tanış olmaq üçün geniş bir onboarding prosesi başlayacaq.",
    joinUs_readyToJoinUs: "İstədiyiniz vəzifəni tapmadınız?",
    joinUs_readyToJoinUsDescription:
      "Biz həmişə bacarıqlı və motivasiyalı fərdləri salamlayırıq. CV-nizi göndərin və Brancy ilə əməkdaşlıq vizyonunuzu açıqlayın.",
    joinUs_sendYourResume: "CV-nizi Göndərin",

    aboutUs_pageTitle: "Brancy Haqqında",
    aboutUs_metaDescription:
      "Sosial şəbəkələri və rəqəmsal biznesləri idarə etmək üçün hərtərəfli və beynəlxalq bir platforma olan Brancy ilə tanış olun; innovasiya, etibar və davamlı inkişafın birlikdə rəqəmsal iqtisadiyyatın gələcəyini formalaşdırdığı yer.",
    aboutUs_subtitle: "Brancy ilə Rəqəmsal İqtisadiyyatın Ağıllı İdarəsi",
    aboutUs_ourStoryTitle: "Bizim Hekayəmiz",
    aboutUs_ourStoryPara1:
      "Brancy onlayn bizneslərin idarəsini yenidən təyin etmək məqsədi ilə yaranıb; qabaqcıl texnologiyaların sahibkarların real ehtiyacları ilə qovuşduğu nöqtə. Biz yalnız bir vasitə təqdim etmirik; bizneslərin böyük və peşəkar bir təşkilat kimi fəaliyyət göstərə biləcəyi bir platforma yaratmışıq.",
    aboutUs_ourStoryPara2:
      "Bu yol bir inanca əsaslanırdı: texnologiya insanın və biznesin inkişafını asanlaşdırmalıdır, qarşısında maneə olmamalıdır.",
    aboutUs_innovationTitle: "Əsas Üstünlük Kimi İnnovasiya",
    aboutUs_innovationPara1:
      "Brancy süni intellektdən, böyük verilərdən və müasir veb texnologiyalardan istifadə edərək istifadəçilər üçün fasiləsiz, təhlükəsiz və səmərəli təcrübə yaradır. Hər bir xüsusiyyət sadəlik və maksimum məhsuldarlıq üzərində qurulub.",
    aboutUs_innovationPara2:
      "Bizim üçün innovasiya yalnız texnologiya ilə məhdudlaşmır; bu, təşkilati mədəniyyətimizdə və gələcəyə baxışımızda kök salmış strateji yanaşmadır.",
    aboutUs_coreValuesTitle: "Əsas Dəyərlərimiz",
    aboutUs_innovationFirstTitle: "İnnovasiyada Öncü",
    aboutUs_innovationFirstDesc: "Həmişə rəqəmsal bizneslərin gələcək ehtiyaclarını ödəyəcək həllər axtarırıq.",
    aboutUs_trustSecurityTitle: "Etibar və Təhlükəsizlik",
    aboutUs_trustSecurityDesc:
      "Məlumatların təhlükəsizliyi və proseslərin şəffaflığı bizim üçün prioritetdir ki, istifadəçilər tam etibar ilə inkişaf edə bilsinlər.",
    aboutUs_globalCommunityTitle: "Qlobal Bir İcma",
    aboutUs_globalCommunityDesc:
      "Brancy sərhədləri aşaraq bizneslərdən və mütəxəssislərdən ibarət qlobal ekosistemi birləşdirir.",
    aboutUs_sustainableGrowthTitle: "Davamlı İnkişaf",
    aboutUs_sustainableGrowthDesc:
      "Etik prinsiplərə və sosial məsuliyyətə uyğun ağıllı və davamlı inkişafı dəstəkləyirik.",
    aboutUs_userEmpowermentTitle: "İstifadəçilərin Gücləndirilməsi",
    aboutUs_userEmpowermentDesc:
      "Sezgisel alətlərimiz və təhsil resurslarımız hər kəs üçün rəqəmsal imkanlara bərabər çıxış təmin edir.",
    aboutUs_continuousEvolutionTitle: "Daimi Təkamül",
    aboutUs_continuousEvolutionDesc:
      "Dinamik bir dünyada dəyişiklik yolumuzun bir hissəsidir. Biz hər zaman öyrənmə və davamlı inkişaf ilə irəliləyirik.",
    aboutUs_globalImpactTitle: "Qlobal Təsir",
    aboutUs_globalImpactPara:
      "Bu gün Brancy milyonlarla sahibkarı və biznesi gücləndirən bir platformadır; rəqəmsal imkanlarla sərhədsiz bir gələcək arasında körpü yaradır.",
    aboutUs_activeUsers: "Aktiv İstifadəçilər",
    aboutUs_countries: "Əhatə Olunan Ölkələr",
    aboutUs_uptime: "Sistemin Mövcudluğu",
    aboutUs_support: "Xüsusi Dəstək",
    aboutUs_teamTitle: "Brancy Komandası",
    aboutUs_teamPara1:
      "Komandamız rəqəmsal iqtisadiyyatı inkişaf etdirmək məqsədi ilə birləşmiş texnologiya mütəxəssisləri, strateqlər və yaradıcı şəxslərdən ibarətdir.",
    aboutUs_teamPara2:
      "Sənaye pionerlərinin təcrübəsindən gənc istedadların enerjisinə qədər Brancy-də yeni bir rəqəmsal ticarət nəslini formalaşdıran qlobal bir hərəkatı idarə edirik.",

    userpanel_yourorders: "Sifarişlərinizin vəziyyəti",
    userpanel_SavedProducts: "Saxlanılan məhsullar",
    userpanel_NoSavedProducts: "Saxlanılan məhsul yoxdur.",
    userpanel_Startexplore: "Milyonlarla məhsul arasında müasir bazar araşdırması",
    userpanel_Startexploreexplain: "Məhsul, mağaza və səhifə",
    userpanel_TicketSupportExplain: "Sifarişin izlənməsi, satıcı ilə söhbət",
    userpanel_TicketSupport: "Bilet vasitəsilə əlaqədə olun",

    userpanel_UseInstagram: "Instagram-ı peşəkar idarə edin.",
    userpanel_FreeProPanel: "Pulsuz Pro panel",
    userpanel_Premiumaccount: "Premium hesab",
    userpanel_daysFreePremium: "40 gün pulsuz premium",
    userpanel_LimitedOffer: "Məhdud fürsət!",
    Dashboard: "Dashboard",
    greeting1: "Günəş də səninlə oyanıb,",
    greeting2: "Enerjili səhəriniz xeyir,",
    greeting3: "Gününüz xeyir,",
    greeting4: "Günorta xeyir,",
    greeting5: "Qızıl axşamınız xeyir,",
    greeting6: "Gecə yaxındır",
    greeting7: "Sakit gecə xeyir,",
    greetingtext1: "Səhər erkən həqiqətən möcüzəlidir🌅",
    greetingtext2: "Dünya sənin addımlarını gözləyir 💪",
    greetingtext3: "Çay və gülümsəmə vaxtıdır ☕😊",
    greetingtext4: "Dadlı yemək nəsibin olsun 🍽️",
    greetingtext5: "Günəş hələ göydədir, irəli get 🌟",
    greetingtext6: "Maraqlı bir son yaradın 🌇",
    greetingtext7: "Böyük xəyallar gör və sabah başla🌙",
    color: "Rəng",
    button: "Düymə",
    Liter: "Litr",
    FrontFace: "Ön görünüş",
    SideFace: "Yan görünüş",
    TopFace: "Yuxarı görünüş",
    Area: "Sahə",
    Perimeter: "Perimetr",
    Volume: "Həcm",
    inSystem: "Sistemdə",
    sending: "Göndərilir",
    uploadsRemaining: "Qalan yükləmələr",
    logoutExplain: "Brancy-dən çıxmağa çalışırsınız",
    welcomeToBrancy: "Brancy-ə xoş gəlmisiniz!",
    notloginexplain: "Brancy xidmətlərindən istifadə etmək üçün Instagram hesabınızı qoşun",
    welcomeToBrancyExplain: "Peşəkar idarəetmə panelinizi qurmaq üçün Instagram ID-nizi daxil edin.",
    welcomeToBrancyExplainPhone: "Peşəkar idarəetmə panelinizi qurmaq üçün telefon nömrənizi daxil edin.",
    loginWithGoogle: "Google giriş",
    loginWithMobile: "SMS giriş",

    or: "və ya",
    InstagramID: "Instagram istifadəçi adı (ID)",
    EmptyNotification: "Hələ heç bir bildiriş yoxdur",
    Notification_NewMessage: "{{sender}} tərəfindən yeni mesajınız var",
    Notification_NewOrder: "{{sender}} tərəfindən yeni sifarişiniz var",
    Notification_ImagesCreatedBy: "Şəkilləriniz {{version}} modeli tərəfindən uğurla yaradıldı.",
    Notification_VideoCreatedBy: "Videonuz {{version}} modeli tərəfindən uğurla yaradıldı.",
    Notification_MediaCreationFailed: "Medianız {{version}} modeli tərəfindən yaradıla bilmədi: {{metadata}}",
    Notification_VideoCreationFailed: "Videonuz {{version}} modeli tərəfindən yaradıla bilmədi: {{metadata}}",
    Notification_NewPost: "Yeni paylaşım",
    Notification_UploadPostFailed: "Paylaşım yüklənmədi",
    Notification_NewStory: "Yeni hekayə",
    Notification_UploadStoryFailed: "Hekayə yüklənmədi",
    Notification_NewVideo: "Yeni video",
    Notification_VideoCreationFailedTitle: "Video yaradıla bilmədi",
    Notification_YouHaveNewMessage: "Yeni mesajınız var",
    Notification_AccountDeauthorized: "Instagram hesabının icazəsi ləğv edildi",
    EnterYourText: "Mətninizi daxil edin",
    EnterYourphonenumber: "Telefon nömrənizi daxil edin",
    CopyText: "Mətni kopyala",
    successfulCopy: "Kopyalandı",
    download: "Yüklə",
    automatic: "Avtomatik",
    manual: "Əl ilə",
    phonenumber: "Telefon nömrəsi",
    SendVerificationCode: "Kod göndər",
    ShowUserDashboard: "Dashboard-a keç",
    VerificationCode: "Təsdiq kodu",
    VerificationCodeExplain: "Zəhmət olmasa telefonunuza göndərilən təsdiq kodunu daxil edin.",
    remainingTime: "Qalan vaxt",
    createtime: "Yaradılma vaxtı",
    ResendVerificationCode: "Təsdiq kodunu yenidən göndər",
    Verify: "Təsdiq et",
    VerifyAddress: "Ünvanı təsdiq et",
    VerifyCode: "Kodu təsdiq et",
    Continue: "Davam et",
    metaRedirect_aiAnalysisNotice: "Nəzərə alın ki, səhifənizin süni intellektlə təhlili bir neçə saat çəkə bilər.",
    Efficiency: "Səmərəlilik",
    max: "Maksimum",
    logout: "Çıxış",
    notallowed: "İcazə verilmir",
    notallowedExplain: "Bu funksiyaya daxil olmaq icazəniz yoxdur",
    notallowedExplainPage: "Bu səhifəyə daxil olmaq icazəniz yoxdur",
    CreateAutomationFlow: "Avtomatlaşdırma Axını Yarat",
    CreateAutomationFlowExplain: "Vizual iş axını qurucusu ilə Instagram qarşılıqlı əlaqələrini avtomatlaşdır.",
    CreateAutomationAI: "AI Avtomatlaşdırması Yarat",
    CreateAutomationAIExplain: "Süni intellekt əsaslı cavablarla Instagram qarşılıqlı əlaqələrini avtomatlaşdır.",
    flowProperties_notworking_privateReply:
      "⚠️ Diqqət: Bu axın dostlarla şəxsi çatlarda işləmir və yalnız şərhlərə və Direct mesajlarına avtomatik cavab vermək üçün istifadə olunur",
    flowProperties_privateReply_requiresFollower:
      'Bu axından şəxsi cavablar üçün istifadə edilə bilməz. Aktivləşdirmək üçün Parametrlərdə "İstifadəçi səhifəni izləməlidir" seçimini aktiv edin.',

    needPass: "Təsdiq və aktivləşdirmə",
    needPassExplain: "Tam giriş üçün Instagram hesabınızın şifrəsi tələb olunur",
    soon: "Tezliklə",
    soonExplain: "Bu funksiya tezliklə mövcud olacaq",
    underdevelop: "Hazırlanma mərhələsində",
    reject: "Rədd et",
    rejected: "Rədd edildi",
    approved: "Təsdiq edildi",
    ExpirationTime: "Bitmə vaxtı",
    send: "Göndər",
    accept: "Qəbul et",
    selectall: "Hamısını seç",
    General: "Ümumi",
    Business: "İş mesajları",
    undo: "Geri al",
    redo: "Təkrar et",
    total: "Cəmi",
    Unknown: "Naməlum",
    close: "Bağla",
    closed: "Bağlandı",
    admin: "Admin",
    user: "İstifadəçi",
    stop: "Dayandır",
    save: "Yadda saxla",
    discard: "Sil",
    all: "Hamısı",
    update: "Yenilə",
    like: "Bəyən",
    dislike: "Bəyənmə",
    next: "Növbəti",
    cancel: "Ləğv et",
    canceled: "Ləğv edildi",
    comment: "Şərh",
    mention: "Mention",
    add: "Əlavə et",
    icon: "İkon",
    copylist: "Siyahını kopyala",
    reply: "Cavab ver",
    replies: "Cavablar",
    PrivateReply: "Şəxsi cavab",
    copy: "Kopyala",
    everywhere: "Hər yerdə",
    UnHide: "Göstər",
    show: "Göstər",
    Hide: "Gizlət",
    pageSummary: "Səhifə Xülasəsi",
    summaryGeneralIntro: "Ümumi Səhifə İcmalı",
    summaryUserEngagement: "İstifadəçi Məşğulluğunun Təhlili",
    summaryContentStrategy: "Məzmun Strategiyasının Nəzərdən Keçirilməsi",
    summaryPostingSchedule: "Dərc Cədvəlinin Qiymətləndirilməsi",
    summaryImprovementSuggestions: "Təkmilləşdirmə və İnkişaf Təklifləri",
    Ignore: "Laqeyd yanaş",
    Orange: "Narıncı",
    Purple: "Bənövşəyi",
    Green: "Yaşıl",
    White: "Ağ",
    DarkGray: "Tünd boz",
    Blue: "Mavi",
    LightGray: "Açıq boz",
    Brown: "Qəhvəyi",
    Pink: "Çəhrayı",
    Yellow: "Sarı",
    Silver: "Gümüşü",
    Black: "Qara",
    Red: "Qırmızı",
    select: "Seç",
    back: "Geri",
    start: "Başla",
    country: "Ölkə",
    device: "Cihaz",
    yourdevice: "Sizin cihazınız",
    otherdevice: "Başqa cihaz",
    SessionID: "Sessiya ID-si",
    header: "Başlıq",
    upload: "Yüklə",
    active: "Aktiv",
    activate: "Aktivləşdir",
    deactive: "Deaktiv",
    activateAll: "Hamısını aktivləşdir",
    DeactivateAll: "Hamısını deaktiv et",
    signout: "Çıxış",
    switchaccount: "Hesabı dəyiş",
    instagramConnect: "Instagram hesabını qoş",
    addnewaccount: "Hesab əlavə et",
    addedaccounts: "Əlavə edilmiş hesablar",
    SwitchtoAccountexplain: "Brancy-də əlavə edilmiş bütün hesablarınız burada göstərilir",
    SwitchtoAccount: "Hesaba daxil ol",
    accountmanagement: "Hesab idarəetməsi",
    subadmininvitation: "Əməkdaş dəvəti",
    subadmininvitationexplain: "Instagram idarəetmə dəvəti əməkdaş olaraq",
    CollaboratorExplain: "Post və ya Reels-i Bir Neçə Instagram Səhifəsi Arasında Birgə Paylaşın",
    Renew_Subscription: "Abunəliyi yenilə",
    upgrade: "Yüksəlt",
    Deactivate: "Deaktiv et",
    done: "Tamamlandı",
    text: "Mətn",
    PlaceHolder: "Yazılır...",
    media: "Video/Şəkil",
    ReplyStory: "Story-ə cavab ver",
    photo: "Şəkil",
    audio: "Səs mesajı",
    Generic: "Ümumi",
    StoryMention: "Story mention",
    FileShare: "Fayl paylaşımı",
    voice: "Səsli",
    abort: "Ləğv et",
    Pending: "Gözləyir",
    Preparing: "Hazırlanır",
    Finished: "Bitdi",
    finish: "Bitir",
    exportJPG: "JPG çıxışı",
    exportPDF: "PDF çıxışı",
    exportXlxs: "Excel çıxışı",
    dismiss: "Bağla",
    empty: "Boş",
    searching: "...Axtarılır",
    searchMessage: "İnsanları və ya açar sözləri axtar",
    searchKeyword: "Açar söz axtar",
    Recommended: "Tövsiyə olunur",
    VERFIED: "Təsdiq edildi",
    SuccessADS: "Reklam uğurla göndərildi",
    SuccessSALES: "Satış uğurla tamamlandı",
    StartOrder: "Sifarişi başlat",
    Startshoping: "Alışa başla",
    question: "Sual",
    Answer: "Cavab",
    shareStory: "Story paylaş",
    search: "Axtar",
    searchLocation: "Məkana görə axtar",
    searchPeople: "İnsanlara görə axtar",
    edit: "Redaktə et",
    delete: "Sil",
    deletecover: "Cover-i sil",
    details: "Təfərrüatlar",
    Insights: "İnsaytlar",
    new: "Yeni",
    comments: "Şərhlər",
    nocomment: "Göstəriləcək şərh yoxdur",
    SimilarProducts: "Oxşar məhsullar",
    QandA: "Suallar",
    caption: "Caption",
    collaborator: "Əməkdaş səhifəsi",
    collaboratorpost: "Əməkdaş postu",
    sidebar_Home: "Ana səhifə",
    sidebar_Page: "Səhifə idarəsi",
    sidebar_Message: "Mesajlar",
    sidebar_Wallet: "Cüzdan",
    sidebar_biolink: "Bio Link",
    sidebar_Advertise: "Reklamlar",
    sidebar_Store: "Mağaza",
    sidebar_Stores: "Mağazalar",
    sidebar_Business: "Biznes",
    sidebar_Setting: "Ayarlar",

    navbar_Post: "Post",
    navbar_Live: "Live",
    navbar_Story: "Story",
    navbar_Feed: "Feed",
    navbar_Reels: "Reels",
    navbar_Statistics: "Statistika",
    navbarTools: "Alətlər",
    navbar_Direct: "Direct",
    navbar_Comments: "Şərhlər",
    navbar_Ticket: "Bilet",
    navbar_AI: "Süni İntellekt",
    navbar_ContentCreator: "Məzmun Yaratıcı",
    navbar_Properties: "Ayarlar",
    navbar_AIAndFlow: "AI və Agent",
    navbar_Payment: "Ödənişlər",
    navbar_Title: "Başlıq",
    priceHistory: "Qiymət tarixi",
    navbar_Home: "Ana səhifə",
    navbar_Biolink: "Mənim linkim",
    navbar_Calendar: "Təqvim",
    navbar_AdList: "Reklam siyahısı",
    navbar_General: "Ümumi",
    navbar_SubAdmin: "Əməkdaş admin",
    navbar_Products: "Məhsullar",
    navbar_Orders: "Sifarişlər",
    navbar_totalOrders: "Sifarişlərin ümumi sayı",
    navbar_HelpCenter: "Kömək və Dəstək",

    countdown_Days: "Gün",
    countdown_Hours: "Saat",
    countdown_Minutes: "Dəqiqə",
    Expired: "Müddəti bitib",
    justnow: "İndi",
    LessThanAMinute: "Bir dəqiqədən az",
    ExpiresIn: "Bitirəcək",
    ExportPDF: "PDF çıxışı",
    ExportJPG: "JPG çıxışı",
    ShareTo: "Paylaş",
    Expand: "Genişləndir",

    home_FollowRequest: "Follow tələbləri",
    home_UnreadNewComments: "Oxunmamış yeni şərhlər",
    home_Last24H: "Son 24 saat",
    home_Last30Days: "Son 30 gün ərzində",
    home_LastLikes: "Yeni bəyənmələr",
    home_LastPost: "Son post",
    home_Followings: "Follow edilənlər",
    home_Followers: "Follower-lar",
    AudienceLocation: "Aktiv auditoriyanın yeri",
    AudienceGender: "Aktiv auditoriyanın cinsi",
    AudienceAge: "Aktiv auditoriyanın yaşı",
    AudienceGenderStats:
      "Qadın izləyicilərinizin sayı {{female}}, kişi izləyicilərinizin sayı {{male}} və {{unknown}} izləyici isə naməlumdur",

    AudienceAgeStats:
      "Ən çox izləyiciləriniz {{ageRange}} yaş aralığındadır ({{percentage}}%), buna görə məzmun {{ageCategory}} yaş qrupuna uyğun və cəlbedici olmalıdır.",

    AgeCategoryYoung: "Gənc",
    AgeCategoryMiddleAged: "Orta yaşlı",
    AgeCategoryOlder: "Yaşlı",

    AudienceLocationStats:
      "Ən çox aktiv izləyiciləriniz {{country}} ölkəsindən {{countryCount, number}} nəfər və {{city}} şəhərindən {{cityCount, number}} nəfərdir",

    lastLike: "Son bəyənmələr",
    lastMessage: "Son mesajlar",
    lastOrder: "Son sifarişlər",
    lastTransaction: "Son əməliyyatlar",
    LastFollowers: "Son izləyicilər",

    CreateNewPost: "Yeni post yarat",
    Postnotvisible: "Post görünmür?",
    Storynotvisible: "Story görünmür?",
    SmartPageAnalysis: "Ağıllı Səhifə Analitikası",
    EducationAndGuidance: "Təlim və Rəhbərlik",
    HowToUseBrancy: "Brancy-dən necə istifadə etməli",
    BrancyKnowsYou: "Brancy sizi tanıyır",
    BrancyKnowsYouExplain:
      "Brancy rəqəmsal kimliyiniz haqqında tam təsəvvür yaratmaq üçün səhifənizi dərindən təhlil edir; şəxsiyyətiniz, biznesiniz və fəaliyyətlərinizdən tutmuş ünsiyyət tonunuza və üslubunuza, məzmun növünüzə, məlumatları təqdim etmə tərzinizə, paylaşım vaxtlarınıza və auditoriyanızla qarşılıqlı əlaqə üsulunuza qədər.\n\nBu təhlil səhifənizdəki bütün kommunikasiya nöqtələrində fəaliyyətinizi də nəzərə alır; şərhlərə və Direct mesajlara cavab verməkdən tutmuş yazı üslubunuza, auditoriyanızla ünsiyyətinizə və müxtəlif vəziyyətlərə reaksiyanıza qədər.\n\nƏl ilə təlimə, tonun tənzimlənməsinə və ya əlavə məlumat daxil etməyə ehtiyac olmadan Brancy sizi tanıyır və süni intellekti real kimliyinizə və üslubunuza uyğunlaşdırır.",
    CreateYourDigitalVersion: "Rəqəmsal versiyanızı yaradın",
    CreateNewStrory: "Yeni story yarat",
    PostDraft: "Post qaralığı",
    StoryDraft: "Story qaralığı",
    publishError: "Yayımlama xətası",
    DeletedPost: "Silinmiş post",
    errorDraft_title: "Post yayımlanarkən xəta baş verdi",
    errorDraft_configFailed: "Post yayımlama parametrləri səhvdir, zəhmət olmasa yoxlayın və düzəldin.",
    errorDraft_invalidTags: "Yanlış tag-lar: ",
    errorDraft_unknown: "Naməlum xəta! Zəhmət olmasa yenidən cəhd edin.",
    errorDraft_uploadError: "Şəkil yükləməsi uğursuz oldu, yenidən cəhd edin.",
    errorDraft_userCancel: "Post yayımlanması istifadəçi tərəfindən ləğv edildi.",
    InvalidAspectRatio: "Yanlış ölçü nisbəti",
    SizeLimitExceed: "Faylın həcmi icazə verilən həddən çoxdur",
    UnSupportMediaType: "Medya tipi dəstəklənmir",
    NotPublishedAtTheTime: "Post seçilən zamanda yayımlanmayıb",
    NotSuccessLogin: "Uğurlu giriş alınmadı",

    NewScheduledPost: "Yeni zamanlanmış post",
    thereAreNoPost: "Hələ zamanlanmış post yaratmamısınız",
    ScheduledPost: "Zamanlanmış post",

    pageStory_CreateNewStory: "Yeni story yarat",
    pageStory_CreateNewStories: "Yeni zamanlanmış story",
    pageStory_thereAreNoStories: "Hələ zamanlanmış story yaratmamısınız",
    pageStory_ScheduledStories: "Zamanlanmış story",

    pageStory_highlightManagement: "Highlight idarəetməsi",
    pageStory_thereAreNoHighlight: "Highlight mövcud deyil",
    pageStory_HighlightTitle: "Highlight-lar / Qovluqlar",

    pageStatistics_YourBestFollowers: "Ən yaxşı izləyiciləriniz",
    pageStatistics_YourBestFollowersExplain:
      "Hesablama səhifədə ümumi qarşılıqlı əlaqə ballarına əsaslanır (bəyənmələr, şərhlər və paylaşmalar daxil olmaqla).",
    pageStatistics_LoadMore: "Daha çox yüklə",
    pageStatistics_UnFollowers: "Unfollow edənlər",
    pageStatistics_Followers: "İzləyicilər",
    pageStatistics_NewFollowers: "Yeni izləyicilər",
    pageStatistics_ActiveFollowers: "Aktiv izləyicilər",
    pageStatistics_MediaFollows: "Məzmundan follow",
    pageStatistics_Reach: "Reach",
    pageStatistics_ProfileVisit: "Profil ziyarətləri",
    pageStatistics_30Days: "30 gün",
    pageStatistics_60Days: "60 gün",
    pageStatistics_90Days: "90 gün",
    pageStatistics_120Days: "120 gün",
    pageStatistics_WorstTime: "Ən pis vaxt",
    pageStatistics_BestTime: "Ən yaxşı vaxt",
    pageStatistics_likes: "Bəyənmələr",
    pageStatistics_Engagements: "İnteraksiya nisbəti",
    pageStatistics_Impression: "Impression",
    pageStatistics_Views: "Baxışlar",
    pageStatistics_RePosts: "Yenidən paylaşmalar",
    pageStatistics_followerViews: "İzləyici baxışları",
    pageStatistics_ghostViewers: "Gizli izləyicilər",
    pageStatistics_Comments: "Şərhlər",
    pageStatistics_Shares: "Paylaşımlar",
    pageStatistics_summary: "Xülasə",
    pageStatistics_EmptyList: "Hələ heç bir məlumat yoxdur!",
    pageStatistics_from: "Nisbətən",
    pageStatistics_post: "Postlar",
    pageStatistics_stories: "Story-lər",
    pageStatistics_MaxView: "Ən çox baxış",
    pageStatistics_MinView: "Ən az baxış",
    pageStatistics_MaxCommentLike: "Ən çox şərh və bəyənmə",
    pageStatistics_MinCommentLike: "Ən az şərh və bəyənmə",
    pageStatistics_PostTimeAnalysis: "Post yerləşdirmə vaxtının analizi",
    pageStatistics_Rate: "Nisbət",
    pageStatistics_RateExplain: "Səhifədə alınan ən yüksək şərh sayına əsaslanır",

    pageStatistics_24HourHeatmap: "24 Saatlik İstilik Xəritəsi",
    pageStatistics_Low: "Aşağı",
    pageStatistics_High: "Yüksək",
    pageStatistics_TopHour: "Ən Yaxşı Saat",
    pageStatistics_WeakHour: "Zəif Saat",
    pageStatistics_AverageHour: "Orta Saat",
    pageStatistics_TopMinute: "Ən Yaxşı Dəqiqə",
    pageStatistics_WeakMinute: "Zəif Dəqiqə",
    pageStatistics_AverageMinute: "Orta Dəqiqə",
    pageStatistics_HourExcellentLevel:
      "Bu saat əla qarşılıqlı əlaqə səviyyəsinə malikdir (80% tutumdan yuxarı). Bu vaxt aralığında qarşılıqlı əlaqə orta göstəricidən {{percentage}}% yüksəkdir və vacib paylaşımlar üçün ideal seçimdir.",
    pageStatistics_HourGoodLevel:
      "Bu saat yaxşı qarşılıqlı əlaqə səviyyəsinə malikdir (60–80% tutum). Bu müddətdə qarşılıqlı əlaqə orta göstəricidən {{percentage}}% daha yüksəkdir və adi paylaşımlar üçün uyğundur.",
    pageStatistics_HourAverageLevel:
      "Bu saat orta qarşılıqlı əlaqə səviyyəsinə malikdir (40–60% tutum). Daha yaxşı nəticə üçün daha yüksək intensivlikli saatları (yaşıl) sınayın. Ən yaxşı vaxtla fərq: {{difference}}}%.",
    pageStatistics_HourWeakLevel:
      "Bu saat zəif qarşılıqlı əlaqə səviyyəsinə malikdir (20–40% tutum). Daha intensiv saatlarda paylaşım tövsiyə olunur.",
    pageStatistics_HourVeryWeakLevel:
      "Bu saat çox zəif qarşılıqlı əlaqə səviyyəsinə malikdir (20%-dən aşağı). Qarşılıqlı əlaqə gözləniləndən aşağıdır və paylaşım tövsiyə olunmur.",
    pageStatistics_MinuteTopDescription:
      "Bu dəqiqə {{hour}}:00 saatının ən yaxşı 10 dəqiqəsi arasındadır. Maksimum qarşılıqlı əlaqə üçün məhz bu dəqiqədə paylaşım məsləhətdir. Ən zəif dəqiqə ilə fərq: {{difference}}%.",
    pageStatistics_MinuteWeakDescription:
      "Bu dəqiqədə qarşılıqlı əlaqə aşağıdır. Saatın ilk və ya orta dəqiqələrində paylaşım daha yaxşı nəticə verə bilər. Ən yaxşı dəqiqə ilə fərq: {{difference}}%.",
    pageStatistics_MinuteAverageDescription:
      "Qarşılıqlı əlaqə normal səviyyədədir. Daha yaxşı optimallaşdırma üçün bu saatın yüksək reytinqli dəqiqələrinə baxın.",
    pageStatistics_PeakEngagement: "Ən Yüksək Əlaqə",
    pageStatistics_StableGrowth: "Sabit Artım",
    pageStatistics_HighEngagementProbability: "Yüksək Əlaqə Ehtimalı",
    pageStatistics_LowestEngagement: "Ən Aşağı Ani Əlaqə",
    pageStatistics_SustainedLowPeriod: "Davamlı Aşağı Dövr",
    pageStatistics_LowEngagementProbability: "Aşağı Əlaqə Ehtimalı",
    pageStatistics_BestTimes: "Ən Yaxşı Zamanlar",
    pageStatistics_WorstTimes: "Ən Pis Zamanlar",
    pageStatistics_EngagementPrediction: "Əlaqə Proqnozu",
    pageStatistics_PeakTimeDescription: "Bu an ən yüksək əlaqə qeydə alınır. Maksimum çatmaq üçün tövsiyə olunur.",
    pageStatistics_StableTimeDescription:
      "Bu vaxtdan etibarən əlaqə artmağa başlayır və orta göstəricidən yuxarı qalır. Sabit əlaqə üçün uyğundur.",
    pageStatistics_SecondaryTimeDescription: "Bu vaxtda paylaşım etmək yaxşı nəticələr verə bilər.",
    pageStatistics_LowestTimeDescription:
      "Bu vaxt ən aşağı ani əlaqəyə malikdir. Bu saatda paylaşım {{percentage}}% potensial əlaqənin itirilməsinə səbəb olur.",
    pageStatistics_SustainedLowTimeDescription:
      "Bu vaxtdan etibarən əlaqə azalır və bir müddət aşağı səviyyədə qalır. Paylaşım məsləhət görülmür.",
    pageStatistics_SecondaryLowTimeDescription: "Aşağı əlaqə ehtimalı olan başqa zəif bir an. Paylaşım məsləhət deyil.",
    pageStatistics_HourEngagementTooltip: "{{hour}}:00 - {{count}} əlaqə ({{percentage}}%)",
    pageStatistics_MinuteEngagementTooltip: "{{hour}}:{{minute}} - {{count}} əlaqə",

    // statistics suggestions box

    Statistics_UnFollowers_up_title: "Unfollower Azalması 💡Artıq saxlama strategiyasını gücləndirməyin vaxtıdır",
    Statistics_UnFollowers_up_summary:
      "Azalma aşağı düşüb, bu da son kontentin işlədiyini göstərir. Bu yolu daha dəqiq davam etdir.",
    Statistics_UnFollowers_up_action1: "Son üç Postu cover, ilk cümlə və CTA baxımından analiz et.",
    Statistics_UnFollowers_up_action2: "Həftəlik bir təqvim hazırla və dəyişiklikləri qeyd et.",
    Statistics_UnFollowers_up_action3: "Yeni Followers üçün xoş gəlmisiniz Story-si və səliqəli Highlight yarat.",
    Statistics_UnFollowers_up_urgency: "Orta",

    Statistics_UnFollowers_neutral_title: "Sabit azalma 💡Hər dəyişiklikdən əvvəl istifadəçidən data topla",
    Statistics_UnFollowers_neutral_summary:
      "İzləyici davranışı dəyişməyib; birbaşa rəylərini ölçməli və qısa testlər etməlisən.",
    Statistics_UnFollowers_neutral_action1: "Story-də sorğu qoy və onlar üçün nə daha cəlbedicidir öyrən.",
    Statistics_UnFollowers_neutral_action2: "Həftədə bir dəfə sabit formatlı Post paylaş və nəticələri müqayisə et.",
    Statistics_UnFollowers_neutral_action3:
      "Comments-də ən çox təkrarlanan üç problemi topla və hər biri üçün bir həll Post-u hazırla.",
    Statistics_UnFollowers_neutral_urgency: "Aşağı",

    Statistics_UnFollowers_down_title: "Unfollow artımı 💡Təcili düzəliş lazımdır",
    Statistics_UnFollowers_down_summary:
      "Unfollow-un artması kontentdə və ya paylaşım ritmində neqativ siqnal deməkdir; sürətli test və reaksiya vacibdir.",
    Statistics_UnFollowers_down_action1:
      "Son 7 günün məlumatlarını yoxla və ən çox unfollow gətirən iki Post-u müəyyən et.",
    Statistics_UnFollowers_down_action2: "Səmimi və ya幕后 bir Post paylaş və səbəbi birbaşa izləyicilərdən soruş.",
    Statistics_UnFollowers_down_action3: "Story-də açıq sual ver: “Niyə Unfollow etdin?” və cavabları qruplaşdır.",
    Statistics_UnFollowers_down_urgency: "Yüksək",

    Statistics_UnFollowers_zero_title: "Heç bir aktivlik yoxdur 💡analiz üçün data mövcud deyil",
    Statistics_UnFollowers_zero_summary:
      "Aktivlik olmadığı üçün analiz siqnalı yaranmayıb; əvvəlcə paylaşım dövrünü yenidən aktivləşdirməlisən.",
    Statistics_UnFollowers_zero_action1: "İlk davranış siqnalı üçün dəyər yönümlü bir Post paylaş.",
    Statistics_UnFollowers_zero_action2: "İlkin reaksiya almaq üçün iki interaktiv Story paylaş (Poll və ya Question).",
    Statistics_UnFollowers_zero_action3: "Təbii baxışların başlaması üçün qısa təqdimat və ya yeniləmə Post-u paylaş.",
    Statistics_UnFollowers_zero_urgency: "Yüksək",

    Statistics_Followers_up_title: "Follower Artımı 💡Yeni Gələnləri Düz Qarşıla",
    Statistics_Followers_up_summary:
      "Artım yüksəlir; daxil olduqları andan etibarən onlara pozitiv təcrübə yaratmalısan ki aktiv Followers olsunlar.",
    Statistics_Followers_up_action1:
      "“Nə tapacaqsan & sənə necə kömək edəcək” formatında qarşılayıcı Highlight hazırla.",
    Statistics_Followers_up_action2:
      "Davamlı və keyfiyyətli artım üçün iki yüngül əməkdaşlıq və ya Mention planlaşdır.",
    Statistics_Followers_up_action3: "Followers keyfiyyətini kampaniya statistikaları və Reels girişləri ilə yoxla.",
    Statistics_Followers_up_urgency: "Orta",

    Statistics_Followers_neutral_title: "Sabit Artım 💡Qısa Testlərin Vaxtıdır",
    Statistics_Followers_neutral_summary:
      "Səhifənin artımı sabitdir; nəyin cəlbetməyə təsir etdiyini bilmək üçün 7 günlük testlər lazımdır.",
    Statistics_Followers_neutral_action1: "Hashtag, paylaşım vaxtı və fərqli cover-lər üzərində 7 günlük test apar.",
    Statistics_Followers_neutral_action2: "Nəticələri qeyd et və ən yaxşı kombinasiyanı sabit formata çevir.",
    Statistics_Followers_neutral_action3:
      "Yeni daxil olanların nə gözlədiyini tez anlaması üçün qısa tanıtım videosu paylaş.",
    Statistics_Followers_neutral_urgency: "Orta",

    Statistics_Followers_down_title: "Cəlbetmədə Azalma 💡Son kontent yəqin ki, persona ilə uyğun deyil",
    Statistics_Followers_down_summary:
      "Cəlbetmənin azalması, mövcud kontentlə hədəf auditoriya arasında uyğunsuzluq siqnalıdır.",
    Statistics_Followers_down_action1: "Persona ilə son kontent arasında üç uyğunsuzluğu tap və düzəlt.",
    Statistics_Followers_down_action2: "Bio, CTA və son bir neçə Post-un cover-lərini tez yenilə və test et.",
    Statistics_Followers_down_action3:
      "Səhifə imicini yenidən aktivləşdirmək üçün kiçik əməkdaşlıq və ya UGC kampaniyası et.",
    Statistics_Followers_down_urgency: "Yüksək",

    Statistics_Followers_zero_title: "Son fəaliyyət yoxdur 💡Cəlbetmə datası yaranmayıb",
    Statistics_Followers_zero_summary:
      "Paylaşım və ya cəlbetmə addımı olmadığı üçün analiz üçün siqnal yoxdur; cəlbetmə dövrünü yenidən aktivləşdirməlisən.",
    Statistics_Followers_zero_action1: "İlk girişləri yaratmaq üçün 3 saniyəlik hook-la beş qısa Reels paylaş.",
    Statistics_Followers_zero_action2: "Təbii görüntülənməni başlatmaq üçün təqdimat və ya yeniləmə Post-u paylaş.",
    Statistics_Followers_zero_action3:
      "Artımı yenidən başlatmaq üçün kiçik cəlbetmə kampaniyası keçir (lokal da ola bilər).",
    Statistics_Followers_zero_urgency: "Yüksək",

    Statistics_MediaFollows_up_title: "Explore Girişi Artıb 💡Serial Format Ən Yaxşı Yoldur",
    Statistics_MediaFollows_up_summary: "Kənar keçidlərin var; uğurlu formatlarını ardıcıl bir seriyaya çevir.",
    Statistics_MediaFollows_up_action1: "Uğurlu formatı 3–5 hissəyə böl və bütün hissələrdə ortaq CTA istifadə et.",
    Statistics_MediaFollows_up_action2: "Sabit cover və müntəzəm vaxt cədvəli seç ki izləyici seriyaya öyrəşsin.",
    Statistics_MediaFollows_up_action3: "İlk günlərin paylanmasını izləy və ən tez nəticə verən mənbəyə fokuslan.",
    Statistics_MediaFollows_up_urgency: "Orta",

    Statistics_MediaFollows_neutral_title: "Orta Referal 💡Cover və Mənbə Üçün A/B Zamanıdır",
    Statistics_MediaFollows_neutral_summary:
      "Explore girişini artırmaq üçün cover və yönləndirmə mənbəyi optimallaşdırılmalıdır.",
    Statistics_MediaFollows_neutral_action1: "İki A/B cover paylaş və 48 saatlıq nəticələrini müqayisə et.",
    Statistics_MediaFollows_neutral_action2: "Ən çox giriş gətirən mənbələri siyahıya al və yenidən hədəflə.",
    Statistics_MediaFollows_neutral_action3: "Uğurlu formatlardan bank yarat ki təkrarı daha asan olsun.",
    Statistics_MediaFollows_neutral_urgency: "Aşağı",

    Statistics_MediaFollows_down_title: "Explore Cəlbi Azalıb 💡Daha Cəlbedici Kontent Lazımdır",
    Statistics_MediaFollows_down_summary:
      "Explore cəlbi üçün daha faydalı və ya yüklənə bilən kontent daha çox nəticə verir.",
    Statistics_MediaFollows_down_action1: "Yüklənə bilən PDF və ya çeklist hazırla və paylaşım üçün link əlavə et.",
    Statistics_MediaFollows_down_action2: "Qısa tədris kontentləri paylaş və hədəfli reklamı test et.",
    Statistics_MediaFollows_down_action3: "Bütün linkləri və yönləndirmə yollarını texniki cəhətdən yoxla.",
    Statistics_MediaFollows_down_urgency: "Yüksək",

    Statistics_MediaFollows_zero_title: "Heç Aktivlik Yoxdur 💡Explore Siqnalı Formalaşmayıb",
    Statistics_MediaFollows_zero_summary:
      "Paylaşım və ya cəlb addımı olmadığına görə analiz üçün məlumat yoxdur; əvvəlcə kontent dövriyyəsini aktivləşdirmək lazımdır.",
    Statistics_MediaFollows_zero_action1:
      "İstifadəçilər üçün cəlbedici kontent yaratmağa və müntəzəm paylaşmağa başla.",
    Statistics_MediaFollows_zero_action2: "İlk yönləndirmə siqnallarını yaratmaq üçün gündə beş qısa kontent paylaş.",
    Statistics_MediaFollows_zero_action3: "Birinci gün gücləndirilmiş Post paylaşaraq ilkin trafik yarat.",
    Statistics_MediaFollows_zero_urgency: "Yüksək",

    Statistics_Reach_up_title: "Reach Artıb 💡Ölçmək Zamanı",
    Statistics_Reach_up_summary: "Erişim artıb; böyümə dalğasını davam etdirmək üçün ən yaxşı formatları təkrarlayın.",
    Statistics_Reach_up_action_1: "Ən yüksək Reach formatlarından ikisini zirvə vaxtlarında yenidən paylaşın.",
    Statistics_Reach_up_action_2: "Effektiv hashtag’ləri sabitləyin və həmişə caption’da yerləşdirin.",
    Statistics_Reach_up_action_3: "Organik Reach’i artırmaq üçün paylaşılabilir Posts yaradın.",
    Statistics_Reach_up_urgency: "Orta",

    Statistics_Reach_neutral_title: "Reach Sabit 💡Test Lazımdır",
    Statistics_Reach_neutral_summary:
      "Durğunluqdan çıxmaq üçün yüngül əməkdaşlıq və ya hashtag testi ən yaxşı yanaşmadır.",
    Statistics_Reach_neutral_action_1: "Eyni sahədə bir səhifə ilə cross-Post koordinasiya edin.",
    Statistics_Reach_neutral_action_2: "İki tədris və ya əyləncəli Reels paylaşın və rəyini qiymətləndirin.",
    Statistics_Reach_neutral_action_3: "Həftəlik hashtag siyahınızı yoxlayın və ən yaxşı kombinasiyanı tapın.",
    Statistics_Reach_neutral_urgency: "Aşağı",

    Statistics_Reach_down_title: "Reach Aşağı Düştü 💡Tez Reaksiya Göstərmək Lazım",
    Statistics_Reach_down_summary: "Əldə etmə azalıb; paylaşılabilir məzmun və qısa müddətli testlər prioritetdir.",
    Statistics_Reach_down_action_1: "Yüksək potensiallı Reels üzərində 7 günlük test aparın.",
    Statistics_Reach_down_action_2: "Paylaşılabilir Posts yaradın və qısa reklamla gücləndirin.",
    Statistics_Reach_down_action_3: "Başlığı, cover və hashtagləri yenidən yazın və Post-u təkrar paylaşın.",
    Statistics_Reach_down_urgency: "Yüksək",

    Statistics_Reach_zero_title: "Reach Qeyd Olunmayıb 💡Aktivlik Azdır",
    Statistics_Reach_zero_summary:
      "Postların və ya kifayət qədər siqnalların olmaması səbəbindən Reach məlumatı yoxdur; məzmun dövrü aktiv edilməlidir.",
    Statistics_Reach_zero_action_1: "Məlumat toplama (API/logs) bağlantısını yoxlayın, düzgün işlədiyindən əmin olun.",
    Statistics_Reach_zero_action_2: "5 trend Reels paylaşın və ikincisini ikinci gündən gücləndirin.",
    Statistics_Reach_zero_action_3: "Yayımlama cədvəli sistemini test edin və lazım olsa sıfırlayın.",
    Statistics_Reach_zero_urgency: "Yüksək",

    Statistics_ProfileVisit_up_title: "Profil Ziyarətləri Yüksək 💡Dönüşümə Diqqət",
    Statistics_ProfileVisit_up_summary:
      "Yaxşı trafik var; Bio və CTA sürətlə optimizə edilməlidir ki, ziyarətlər falo və clicklərə çevrilsin.",
    Statistics_ProfileVisit_up_action_1: "Bio-nu aydın dəyər təklifi və birbaşa CTA ilə yenidən yazın.",
    Statistics_ProfileVisit_up_action_2:
      "İstifadəçinin nə gördüyünü və nə gözlədiyini başa düşməsi üçün əsas Highlights yaradın.",
    Statistics_ProfileVisit_up_action_3: "Link klik nisbətini artırmaq üçün xüsusi təklifli bir Post paylaşın.",
    Statistics_ProfileVisit_up_urgency: "Yüksək",

    Statistics_ProfileVisit_neutral_title: "Ziyarət Var, Dönüşüm Aşağı 💡Lead Yaradın",
    Statistics_ProfileVisit_neutral_summary: "Trafik var amma dönüşüm aşağıdır; cazibədar bir Lead axını dəyişə bilər.",
    Statistics_ProfileVisit_neutral_action_1: "Highlights-ə pulsuz fayl və ya yoxlama siyahısı əlavə edin.",
    Statistics_ProfileVisit_neutral_action_2: "Caption-ları profil ilə əlaqəli CTA ilə gücləndirin.",
    Statistics_ProfileVisit_neutral_action_3: "Profilə yönləndirən və dəvət edən Stories sayını artırın.",
    Statistics_ProfileVisit_neutral_urgency: "Orta",

    Statistics_ProfileVisit_down_title: "Ziyarətlər Aşağı Düştü 💡Daha Güclü Hook Lazımdır",
    Statistics_ProfileVisit_down_summary:
      "Maraq azalıb; caption başlanğıcları və CTA daha cəlbedici və aydın olmalıdır.",
    Statistics_ProfileVisit_down_action_1: "Caption-ları 3–5 sözlü hook ilə yenidən yazın.",
    Statistics_ProfileVisit_down_action_2: "Yönləndirici Stories əlavə edin və linki qalın edin.",
    Statistics_ProfileVisit_down_action_3: "İstifadəçiləri profil ziyarətinə təşviq edən bir Post paylaşın.",
    Statistics_ProfileVisit_down_urgency: "Yüksək",

    Statistics_ProfileVisit_zero_title: "Profil Ziyarəti Qeyd Olunmayıb 💡Aktivlik Kifayət Deyil",
    Statistics_ProfileVisit_zero_summary:
      "Yayın və ya kifayət qədər siqnal olmadığından profil ziyarəti qeydə alınmayıb; cəlb etmə dövrü yenidən aktivləşdirilməlidir.",
    Statistics_ProfileVisit_zero_action_1: "Hesab vəziyyətini yoxlayın ki, public olsun.",
    Statistics_ProfileVisit_zero_action_2: "Aydın CTA ilə dəvət edən bir Post paylaşın.",
    Statistics_ProfileVisit_zero_action_3: "Əsas Highlights-i yeniləyin və ilk ziyarət siqnalını yaradın.",
    Statistics_ProfileVisit_zero_urgency: "Yüksək",

    Statistics_Likes_up_title: "Like-lar Yaxşıdır 💡Vərdiş Yarat",
    Statistics_Likes_up_summary: "İstifadəçilər like edir; indi məqsəd bu davranışı sabit bir vərdişə çevirməkdir.",
    Statistics_Likes_up_action_1: "Uğurlu formatları sənədləşdirin (cover, template, uzunluq).",
    Statistics_Likes_up_action_2: "Post-un sonunda sadə bir like CTA əlavə edin (məsələn 'Razısansa ❤').",
    Statistics_Likes_up_action_3: "Cover və ilk 3 saniyə üçün kiçik bir A/B testi aparın.",
    Statistics_Likes_up_urgency: "Orta",

    Statistics_Likes_neutral_title: "Like-lar Artıla Bilər 💡Hook və Cover-i Təkmilləşdir",
    Statistics_Likes_neutral_summary: "Potensial var; cover və hook-u dəyişdirərək like nisbətini artırmaq olar.",
    Statistics_Likes_neutral_action_1: "Cover və ilk 3 saniyəni optimallaşdırın və test edin.",
    Statistics_Likes_neutral_action_2: "Like dəvəti üçün emosional və ya sual yönümlü CTA istifadə edin.",
    Statistics_Likes_neutral_action_3: "İzləyici vizual üstünlüklərini anlamaq üçün kiçik sorğu keçirin.",
    Statistics_Likes_neutral_urgency: "Aşağı",

    Statistics_Likes_down_title: "Like-lar Azalıb 💡Vizual Kimliyi Yenidən Dizayn Et",
    Statistics_Likes_down_summary: "Mesaj və ya görüntü güclü olmaya bilər; məzmunun ilk anına fokuslanın.",
    Statistics_Likes_down_action_1: "Cover və caption-in ilk cümləsini yenidən yazın.",
    Statistics_Likes_down_action_2: "Cover rəngi/dizaynı üçün A/B testi aparın.",
    Statistics_Likes_down_action_3: "Güclü və uyğun vizual Posts paylaşın.",
    Statistics_Likes_down_urgency: "Yüksək",

    Statistics_Likes_zero_title: "Sıfır Like 💡Ya Məlumat Yoxdur, Ya da Məzmun Yoxdur",
    Statistics_Likes_zero_summary:
      "Əgər məzmun varsa amma like yoxdursa, məlumatı yoxlayın; yoxdursa, istehsala başlayın.",
    Statistics_Likes_zero_action_1: "Məlumat qeydlərinin düzgünlüyünü yoxlayın.",
    Statistics_Likes_zero_action_2: "Əgər məzmun yoxdursa, bir neçə Post güclü cover ilə paylaşın.",
    Statistics_Likes_zero_action_3: "Rəy toplamaq üçün partner şəbəkələrindən istifadə edin.",
    Statistics_Likes_zero_urgency: "Yüksək",

    Statistics_Comments_up_title: "Şərhlər Artıb 💡Dialoqu Ciddi Qəbul Et",
    Statistics_Comments_up_summary:
      "İnsanlar danışır; onlardan istifadə etmək üçün şərhlərə cavab ver və şərhləri məzmuna çevir.",
    Statistics_Comments_up_action1: "Şərhlərə cavab ver və ən yaxşı 3 fikri Post-a çevir.",
    Statistics_Comments_up_action2: "Ən yaxşı şərhlərə işarə et və ya Story-də göstər.",
    Statistics_Comments_up_action3: "Caption-a insanları cavab verməyə təşviq edən bir sual əlavə et.",
    Statistics_Comments_up_urgency: "Orta",

    Statistics_Comments_neutral_title: "Şərhlər Az 💡Stimulus Əlavə Et",
    Statistics_Comments_neutral_summary: "Dialoq yaratmaq üçün sadə və birbaşa suallar verin.",
    Statistics_Comments_neutral_action1: "Post-un sonunda açıq sual qoyun.",
    Statistics_Comments_neutral_action2: "İlk 5 şərhə tez cavab verin ki, digərləri təşviq olunsun.",
    Statistics_Comments_neutral_action3: "Qısa challenge və ya sorğu keçirin.",
    Statistics_Comments_neutral_urgency: "Aşağı",

    Statistics_Comments_down_title: "Şərhlər Azalıb 💡Aydın Stimullar əlavə et",
    Statistics_Comments_down_summary: "Söhbəti başlatmaq üçün birbaşa CTA və dəvətlərə ehtiyac var.",
    Statistics_Comments_down_action1: "Bir challenge paylaş və ya şəxsi təcrübələr istə.",
    Statistics_Comments_down_action2: "Caption-da şərhlər üçün açıq CTA əlavə et (məs: 'Sənin fikrin nədir?').",
    Statistics_Comments_down_action3: "İlkin şərhlərə tez cavab ver.",
    Statistics_Comments_down_urgency: "Yüksək",

    Statistics_Comments_zero_title: "Şərh yoxdur 💡Dəvətçi ol",
    Statistics_Comments_zero_summary: "Məzmun insanlar şərh yazmağa təşviq etmir; formatları daha dəvətkar et.",
    Statistics_Comments_zero_action1: "Sadə və cəlbedici suallar dizayn et (məs: iki seçim arasında seçim).",
    Statistics_Comments_zero_action2: "İlk şərhlərə tez cavab ver ki, digərləri təşviq olunsun.",
    Statistics_Comments_zero_action3: "Şərh üçün birbaşa CTA istifadə et.",
    Statistics_Comments_zero_urgency: "Yüksək",

    Statistics_Views_up_title: "Baxışlar Artıb 💡Trafikdən Yararlan",
    Statistics_Views_up_summary:
      "Video baxışları yaxşıdır; videonun sonunda trafiki yönləndirmək üçün istifadə et (profil/yadda saxla).",
    Statistics_Views_up_action1: "Videonun sonunda aydın CTA əlavə et (məs: 'Daha çox üçün yadda saxla').",
    Statistics_Views_up_action2: "Əlavə məzmun linkini bio və ya highlight-a əlavə et.",
    Statistics_Views_up_action3: "Qısa versiya və ya teaser yarat və paylaş.",
    Statistics_Views_up_urgency: "Orta",

    Statistics_Views_neutral_title: "Baxışlar Sabitdir 💡Hook və Cover-i Gücləndir",
    Statistics_Views_neutral_summary: "Baxış nisbətini artırmaq üçün ilk 3 saniyə və cover üzərində işləyin.",
    Statistics_Views_neutral_action1: "Başlanğıc hook və cover-i yenidən yaz.",
    Statistics_Views_neutral_action2: "Test üçün qısa bir versiya paylaş.",
    Statistics_Views_neutral_action3: "İzləyicidən vizual rəy topla.",
    Statistics_Views_neutral_urgency: "Aşağı",

    Statistics_Views_down_title: "Baxışlar Azalıb 💡Hook-u Gücləndir",
    Statistics_Views_down_summary: "Videonun başlanğıcı zəifdir; qısa və cəlbedici versiyaları test etməyə başla.",
    Statistics_Views_down_action1: "5 güclü 15 saniyəlik video hazırla.",
    Statistics_Views_down_action2: "Videonun başlanğıcını yenidən yaz və A/B test et.",
    Statistics_Views_down_action3: "Diqqəti saxlamaq üçün montaj sürətini artır.",
    Statistics_Views_down_urgency: "Yüksək",

    Statistics_Views_zero_title: "Baxış sıfır? 💡Məzmunu dərhal paylaş",
    Statistics_Views_zero_summary: "İlk fürsətdə məzmun istehsalına başla.",
    Statistics_Views_zero_action1: "Yalnız səhifənin iş axışını analiz etməklə başla.",
    Statistics_Views_zero_action2: "Əgər video paylaşılmayıbsa, 3 qısa reel hazırla.",
    Statistics_Views_zero_action3: "İlkin göstəriciləri yaratmaq üçün bir gücləndirici post paylaş.",
    Statistics_Views_zero_urgency: "Yüksək",

    Statistics_FollowerViews_up_title: "İzləyicilər Baxır 💡Daxili Əlaqə Qur",
    Statistics_FollowerViews_up_summary: "İzləyicilər aktivdir; onları daxili əlaqə üçün istifadə et (AMA, sorğular).",
    Statistics_FollowerViews_up_action1: "Hekayələrdə izləyicilərə sual ver və ya sorğu et.",
    Statistics_FollowerViews_up_action2: "İzləyicilər üçün xüsusi məzmun paylaş (məsələn, AMA).",
    Statistics_FollowerViews_up_action3: "Formatları persona ilə yoxla ki, onların zövqünə daha dəqiq uyğunlaşsın.",
    Statistics_FollowerViews_up_urgency: "Orta",

    Statistics_FollowerViews_neutral_title: "İzləyici Baxışları Normaldır 💡Vaxtlama və Formatı Test Et",
    Statistics_FollowerViews_neutral_summary: "Paylaşım vaxtı və ya məzmun növü dəyişdirilə bilər; sadə testlər apar.",
    Statistics_FollowerViews_neutral_action1: "Paylaşım vaxtını dəyiş və təsirini qeyd et.",
    Statistics_FollowerViews_neutral_action2: "İzləyicilər üçün yeni format test et.",
    Statistics_FollowerViews_neutral_action3: "Məzmunu əvvəlki izləyici davranışına uyğun fərdiləşdir.",
    Statistics_FollowerViews_neutral_urgency: "Aşağı",

    Statistics_FollowerViews_down_title: "İzləyici Baxışları Azalıb 💡Rəy Topla",
    Statistics_FollowerViews_down_summary: "Persona-dan uzaqlaşma ehtimalı var; rəy topla və 3 sürətli dəyişiklik et.",
    Statistics_FollowerViews_down_action1: "Son rəyəri topla və üç sürətli dəyişiklik et.",
    Statistics_FollowerViews_down_action2: "İzləyiciləri yenidən aktiv etmək üçün cəlbedici hekayələr paylaş.",
    Statistics_FollowerViews_down_action3: "Fərdiləşdirilmiş məzmun versiyalarını test et.",
    Statistics_FollowerViews_down_urgency: "Yüksək",

    Statistics_FollowerViews_zero_title: "İzləyici Baxışları Sıfır 💡Əvvəl Aktiv İzləyiciləri Təmin Et",
    Statistics_FollowerViews_zero_summary:
      "Sizdə aktiv izləyici az ola bilər; əvvəl onları oyat, sonra qarşılıqlı əlaqə qur.",
    Statistics_FollowerViews_zero_action1: "İzləyiciləri oyatmaq üçün bir neçə hekayə və post paylaş.",
    Statistics_FollowerViews_zero_action2: "10 aktiv izləyici ilə birbaşa əlaqə saxla.",
    Statistics_FollowerViews_zero_action3: "Əvvəlki maraqlara əsasən məzmun yarat.",
    Statistics_FollowerViews_zero_urgency: "Yüksək",

    Statistics_NonFollowerViews_up_title: "İzləyici Olmayan Baxışlar Artıb 💡Yeni Cəlb İmkanı",
    Statistics_NonFollowerViews_up_summary:
      "Təqibçilərdən kənar insanlar baxır; hər post izləmək üçün güclü səbəb verməlidir.",
    Statistics_NonFollowerViews_up_action1:
      "Başlıqda güclü bir izləmə səbəbi əlavə et (məs. seriyalı məzmun və ya addım-addım dərslər).",
    Statistics_NonFollowerViews_up_action2: "İzləyici olmayanları cəlb etmək üçün trend Reels hazırla.",
    Statistics_NonFollowerViews_up_action3: "Hədəfli hashtaglər və əlaqəli əməkdaşlıqlardan istifadə et.",
    Statistics_NonFollowerViews_up_urgency: "Orta",

    Statistics_NonFollowerViews_neutral_title: "İzləyici Olmayan Baxışlar Sabit 💡Hashtag və Paylamanı Optimallaşdır",
    Statistics_NonFollowerViews_neutral_summary:
      "Hashtag və paylaşılabilir məzmun optimallaşdırması izləyici olmayan trafikini artırır.",
    Statistics_NonFollowerViews_neutral_action1: "Effektiv hashtagləri müəyyən et və bir neçəsini sabit saxla.",
    Statistics_NonFollowerViews_neutral_action2: "Daha çox paylaşılabilir məzmun yarat.",
    Statistics_NonFollowerViews_neutral_action3: "Əlaqəli səhifələrlə qısa əməkdaşlıq et.",
    Statistics_NonFollowerViews_neutral_urgency: "Aşağı",

    Statistics_NonFollowerViews_down_title: "İzləyici Olmayan Baxışlar Azalıb 💡Əməkdaşlıq və Reklam Lazımdır",
    Statistics_NonFollowerViews_down_summary:
      "Explore-a çatım azalıb; əməkdaşlıq və ya kiçik reklamla trafiği geri gətir.",
    Statistics_NonFollowerViews_down_action1: "Əlaqəli bir səhifə ilə sürətli əməkdaşlıq qur.",
    Statistics_NonFollowerViews_down_action2: "Daha çox paylaşılabilir postlar yarat və dəstəkləyici paylaşım et.",
    Statistics_NonFollowerViews_down_action3: "Trafiği geri gətirmək üçün kiçik hədəfli reklam apar.",
    Statistics_NonFollowerViews_down_urgency: "Yüksək",

    Statistics_NonFollowerViews_zero_title: "İzləyici Olmayan Baxışlar Sıfır 💡Explore üçün siqnal yarat",
    Statistics_NonFollowerViews_zero_summary:
      "İlk trafiki yaratmaq üçün trend Reels və əməkdaşlıq ən yaxşı başlanğıcdır.",
    Statistics_NonFollowerViews_zero_action1: "3 trend əsaslı Reels hazırla.",
    Statistics_NonFollowerViews_zero_action2: "İlkin trafiki yaratmaq üçün dəstəkləyici post paylaş.",
    Statistics_NonFollowerViews_zero_action3: "Əlaqəli bir səhifə ilə sürətli əməkdaşlıq başlat.",
    Statistics_NonFollowerViews_zero_urgency: "Yüksək",

    Statistics_Shares_up_title: "Paylaşımlar Yüksəldi 💡Sənin Məzmunun Paylaşmağa Dəyər",
    Statistics_Shares_up_summary:
      "İnsanlar postlarını paylaşırlər; bu, məzmunun dərhal dəyərli olduğunu və dönüşüm yarada biləcəyini göstərir.",
    Statistics_Shares_up_action1: "Paylaşım geri bildirişlərini analiz et və nümunələri tap.",
    Statistics_Shares_up_action2: "Başlığa paylaşmaq üçün aydın səbəb əlavə et ('Dostuna göndər').",
    Statistics_Shares_up_action3: "Paylaşıla bilən təhsil seriyası dizayn et.",
    Statistics_Shares_up_urgency: "Orta",

    Statistics_Shares_neutral_title: "Paylaşımlar Az və ya Sabit 💡Sadə Bir Tetikleyici Lazımdır",
    Statistics_Shares_neutral_summary: "Bəzən sadəcə qısa bir CTA paylaşımı artırmaq üçün kifayətdir.",
    Statistics_Shares_neutral_action1: "Postun sonunda çox qısa bir paylaşım CTA əlavə et.",
    Statistics_Shares_neutral_action2: "Daha çox saxlanıla bilən və paylaşılabilən məzmun yarat.",
    Statistics_Shares_neutral_action3: "'Dostuna göndər' test şablonu tətbiq et.",
    Statistics_Shares_neutral_urgency: "Aşağı",

    Statistics_Shares_down_title: "Paylaşımlar Azalıb 💡Daha Praktik Məzmun Lazımdır",
    Statistics_Shares_down_summary:
      "Məzmun daha az paylaşılabilir olub; insanların başqalarına göndərmək istədiyi bir şey yarat.",
    Statistics_Shares_down_action1: "Yoxlama siyahıları və ya addım-addım məzmun dizayn et.",
    Statistics_Shares_down_action2: "Qısa və yığcam təlimlər paylaş.",
    Statistics_Shares_down_action3: "Paylaşım üçün aydın CTA əlavə et.",
    Statistics_Shares_down_urgency: "Yüksək",

    Statistics_Shares_zero_title: "Heç bir paylaşım yoxdur 💡Başlanğıc nöqtəsi yarat",
    Statistics_Shares_zero_summary:
      "Ya məlumat yoxdur, ya da məzmun paylaşılabilir deyil; tez bir paylama planı hazırla.",
    Statistics_Shares_zero_action1: "Birkaç 5-məsləhət və ya yoxlama siyahısı məzmunu hazırla.",
    Statistics_Shares_zero_action2: "İlk siqnalı almaq üçün kiçik bir dəstək həyata keçir.",
    Statistics_Shares_zero_action3: "Başlıqda paylaşmaq üçün aydın bir səbəb yaz.",
    Statistics_Shares_zero_urgency: "Yüksək",

    Statistics_Engagement_up_title: "Əlaqə artır 💡Formulu möhkəmləndir",
    Statistics_Engagement_up_summary: "Uğurlu bir nümunə tapdın; indi onu təkrarla və böyüt.",
    Statistics_Engagement_up_action1: "Uğurlu formatları və vaxtları dəqiq qeyd et.",
    Statistics_Engagement_up_action2: "Əlaqəni artıran formatları məzmun təqviminə əlavə et.",
    Statistics_Engagement_up_action3: "Hər həftə bir yeni saxlama yönümlü format sınayın.",
    Statistics_Engagement_up_urgency: "Orta",

    Statistics_Engagement_neutral_title: "Əlaqə orta 💡Yeni bir tetikleyici lazımdır",
    Statistics_Engagement_neutral_summary:
      "Böyümək üçün yeni tetikleyicilər əlavə et; məsələn, suallar, çağırışlar və ya şərh dəvətləri.",
    Statistics_Engagement_neutral_action1: "Həftədə bir dəfə şərh dəvət edən post paylaş.",
    Statistics_Engagement_neutral_action2: "Əlaqəni kanallaşdır və fərqli formatların nəticələrini müqayisə et.",
    Statistics_Engagement_neutral_action3: "Sürətli qarşılıqlı əlaqə üçün bir neçə şablon dizayn et.",
    Statistics_Engagement_neutral_urgency: "Aşağı",

    Statistics_Engagement_down_title: "Əlaqə azalır 💡Tezliklə yenidən dizayn vacibdir",
    Statistics_Engagement_down_summary: "Yeni testlər dərhal başlamalıdır; 14 günlük plan ən yaxşı başlanğıcdır.",
    Statistics_Engagement_down_action1: "3 fərqli formatla 14 günlük planı həyata keçir.",
    Statistics_Engagement_down_action2: "Hər gün məlumatları qeyd et və sürətlə pivot et.",
    Statistics_Engagement_down_action3: "Auditoriyadan birbaşa hansı məzmunun maraqlı olduğunu soruş.",
    Statistics_Engagement_down_urgency: "Yüksək",

    Statistics_Engagement_zero_title: "Sıfır Əlaqə 💡7 Günlük Sıx Plan Lazımdır",
    Statistics_Engagement_zero_summary:
      "Əlaqə siqnallarını tez yaratmalısan; gündəlik interaktiv post paylaş və məlumatları izləyin.",
    Statistics_Engagement_zero_action1: "Sorğular, açıq suallar və kiçik çağırışlar paylaş.",
    Statistics_Engagement_zero_action2: "Hər formatı 3 gün test et.",
    Statistics_Engagement_zero_action3: "Şərhlərə və mesajlara tez cavab ver.",
    Statistics_Engagement_zero_urgency: "Yüksək",

    Statistics_Replies_up_title: "Story Cavabları çox 💡onları məzmuna çevir",
    Statistics_Replies_up_summary: "İzləyicilər yazır; onlar interaktivlik istəyir. Bu, məzmun üçün qızıl fürsətdir.",
    Statistics_Replies_up_action_1: "Ən yaxşı 3 cavabı seç və post və ya Reel-ə çevir.",
    Statistics_Replies_up_action_2: "Ən çox verilən cavablarla Q&A və ya FAQ yarat.",
    Statistics_Replies_up_action_3: "Növbəti story-də bir neçə cavabı göstər, digərlərini motivasiya et.",
    Statistics_Replies_up_urgency: "Orta",

    Statistics_Replies_neutral_title: "Cavablar az 💡Tetikleyici əlavə et",
    Statistics_Replies_neutral_summary: "Bəzən sadə bir sual daha çox cavab almaq üçün kifayətdir.",
    Statistics_Replies_neutral_action_1: "Sual sticker-i, sorğu və ya Quiz əlavə et.",
    Statistics_Replies_neutral_action_2: "Qısa və maraqlı suallar soruş.",
    Statistics_Replies_neutral_action_3: "Cavablara tez reaksiya ver, qarşılıqlı əlaqəni artır.",
    Statistics_Replies_neutral_urgency: "Aşağı",

    Statistics_TotalTime_up_title: "Baxış Vaxtı Artıb 💡Daha Dərin Məzmun Ver",
    Statistics_TotalTime_up_summary: "İzləyici vaxt sərf edir; bölümlü və uzun məzmunlara hazırdır.",
    Statistics_TotalTime_up_action_1: "Giriş/orta/son strukturu ilə daha uzun videolar hazırla.",
    Statistics_TotalTime_up_action_2: "Əlavə məzmun linklərini bio və ya highlight-da paylaş.",
    Statistics_TotalTime_up_action_3: "Videonu aydın bölümlərə ayır, saxlanmanı artır.",
    Statistics_TotalTime_up_urgency: "Orta",

    Statistics_TotalTime_neutral_title: "Baxış Vaxtı Normal 💡Struktur Gücləndir",
    Statistics_TotalTime_neutral_summary: "İzləyici qalır, amma tam bağlanmır; saxlanma üçün strukturu yaxşılaşdır.",
    Statistics_TotalTime_neutral_action_1: "Videolar üçün üç qatlı struktur tətbiq et.",
    Statistics_TotalTime_neutral_action_2: "Əsas məqamları vurğula ki, izləyicilər nə gözləyəcəklərini bilsin.",
    Statistics_TotalTime_neutral_action_3: "Test və müqayisə üçün xülasə versiya hazırla.",
    Statistics_TotalTime_neutral_urgency: "Aşağı",

    Statistics_TotalTime_down_title: "Baxış Müddəti Azalıb 💡İlk Hook Zəifdir",
    Statistics_TotalTime_down_summary: "İlk 3 saniyə güclü olmalıdır; daha sürətli, təsirli və cəlbedici et.",
    Statistics_TotalTime_down_action_1: "İlk 3 saniyəyi yenidən yaz və bir neçə versiyanı test et.",
    Statistics_TotalTime_down_action_2: "15–30 saniyəlik çox qısa versiyalar hazırla.",
    Statistics_TotalTime_down_action_3: "Redaktə ritmi, kəsimlər və musiqini daha kəskin et.",
    Statistics_TotalTime_down_urgency: "Yüksək",

    Statistics_TotalTime_zero_title: "Baxış Müddəti Sıfır 💡Hələ Yayınlamamısan?",
    Statistics_TotalTime_zero_summary: "Video varsa amma vaxt qeydə alınmayıbsa, əvvəlcə texniki problemi yoxla.",
    Statistics_TotalTime_zero_action_1: "Məzmunun həqiqətən yayımlandığından əmin ol.",
    Statistics_TotalTime_zero_action_2: "Əgər yayımlanmayıbsa, ardıcıl 3 qısa reel paylaş.",
    Statistics_TotalTime_zero_action_3: "Məlumat toplamaq üçün boost və ya ilkin göstərim həyata keçir.",
    Statistics_TotalTime_zero_urgency: "Yüksək",

    Statistics_ReachMonth_up_title: "Aylıq Reach Artıb 💡Nümunələri Kilidlə",
    Statistics_ReachMonth_up_summary: "Uğurlu aylar aydındır; nümunələri qeyd edin və gələn ay üçün plan qurun.",
    Statistics_ReachMonth_up_action_1: "Yüksək performanslı ayları analiz edin və nümunələri qeyd edin.",
    Statistics_ReachMonth_up_action_2: "Kontent təqviminizi bu nümunələrlə yeniləyin.",
    Statistics_ReachMonth_up_action_3: "Qalib formatları gələn ay üçün yenidən paylaşın.",
    Statistics_ReachMonth_up_urgency: "Orta",

    Statistics_ReachMonth_neutral_title: "Aylıq Reach Sabit 💡Test və Böyümə Zamanı",
    Statistics_ReachMonth_neutral_summary: "Aylıq reach artırmaq üçün qısa kampaniya və ya məhdud reklam aparın.",
    Statistics_ReachMonth_neutral_action_1: "Ortaq kampaniya və ya məhdud reklam başlat.",
    Statistics_ReachMonth_neutral_action_2: "Nəticələri qeyd et, müqayisə et və optimallaşdır.",
    Statistics_ReachMonth_neutral_action_3: "Əvvəlki uğurlu postları yenidən gücləndir.",
    Statistics_ReachMonth_neutral_urgency: "Aşağı",

    Statistics_ReachMonth_down_title: "Aylıq Reach Azalıb 💡Məzmunu Yenidən Yarat",
    Statistics_ReachMonth_down_summary:
      "Reach-i bərpa etmək üçün əsas postları yenidən paylaşın və ya yenidən yaradın.",
    Statistics_ReachMonth_down_action_1: "Əsas postları yenidən paylaşın və ya yenidən yaradın.",
    Statistics_ReachMonth_down_action_2: "14 günlük məzmun istehsalı və təbliğ kampaniyası həyata keçirin.",
    Statistics_ReachMonth_down_action_3: "Hashtag və etiketləri yenidən yoxlayın.",
    Statistics_ReachMonth_down_urgency: "Yüksək",

    Statistics_ReachMonth_zero_title: "Aylıq Reach Sıfır 💡Əvvəl Verini Yoxla",
    Statistics_ReachMonth_zero_summary:
      "Data yoxdur və ya natamamdır; əvvəl texniki yoxlayın, sonra 14 günlük plan həyata keçirin.",
    Statistics_ReachMonth_zero_action_1: "Data bağlantılarını və qeydləri yoxlayın.",
    Statistics_ReachMonth_zero_action_2: "14 günlük məzmun istehsalı planını həyata keçirin.",
    Statistics_ReachMonth_zero_action_3: "Gündəlik nəticələri izləyin.",
    Statistics_ReachMonth_zero_urgency: "Yüksək",

    Statistics_MonthEngagement_up_title: "Aylıq Etkileşim Artır 💡Ölçüləndir",
    Statistics_MonthEngagement_up_summary: "Müsbət aylıq nümunələri qeyd edin və təkrarlayın.",
    Statistics_MonthEngagement_up_action_1: "Uğurlu şablonları və formatları sənədləşdirin.",
    Statistics_MonthEngagement_up_action_2: "Növbəti ay üçün aydın KPI və planlar müəyyən edin.",
    Statistics_MonthEngagement_up_action_3: "Etkileşimi artırmaq üçün kiçik həftəlik testlər aparın.",
    Statistics_MonthEngagement_up_urgency: "Orta",

    Statistics_MonthEngagement_neutral_title: "Aylıq Etkileşim Normal 💡Çağırış Elementi Əlavə Et",
    Statistics_MonthEngagement_neutral_summary: "Həftəlik bir çağırış və ya sual etkileşimi artıra bilər.",
    Statistics_MonthEngagement_neutral_action_1: "Hər həftə bir çağırış və ya sual yönümlü məzmun paylaşın.",
    Statistics_MonthEngagement_neutral_action_2: "Nəticələri qeyd edin və müqayisə edin.",
    Statistics_MonthEngagement_neutral_action_3: "Həftəlik etkileşim seriyası yaradın.",
    Statistics_MonthEngagement_neutral_urgency: "Aşağı",

    Statistics_MonthEngagement_down_title: "Aylıq Etkileşim Azalıb 💡14 Günlük Plan Başlat",
    Statistics_MonthEngagement_down_summary: "Formatları yenidən nəzərdən keçirin və 14 günlük planı icra edin.",
    Statistics_MonthEngagement_down_action_1: "3 müxtəlif formatla 14 günlük planı tətbiq edin.",
    Statistics_MonthEngagement_down_action_2: "Nəticələri gündəlik analiz edin.",
    Statistics_MonthEngagement_down_action_3: "İzləyicilərdən birbaşa rəy toplayın.",
    Statistics_MonthEngagement_down_urgency: "Yüksək",

    Statistics_MonthEngagement_zero_title: "Aylıq Etkileşim Sıfır 💡Təcili 7 Günlük Proqram",
    Statistics_MonthEngagement_zero_summary: "7 sürətli interaktiv post yayımlayın və gündəlik izləyin.",
    Statistics_MonthEngagement_zero_action_1: "7 interaktiv post yaradın.",
    Statistics_MonthEngagement_zero_action_2: "Nəticələri gündəlik yoxlayın.",
    Statistics_MonthEngagement_zero_action_3: "DM və şərhlər vasitəsilə izləyicilərlə əlaqə qurun.",
    Statistics_MonthEngagement_zero_urgency: "Yüksək",

    Statistics_MonthView_up_title: "Aylıq Baxışlar Artıb 💡Struktur Qorun",
    Statistics_MonthView_up_summary: "Video strategiyası işləyir; bu formatları davamlı olaraq paylaşın.",
    Statistics_MonthView_up_action_1: "Video strategiyanızı sənədləşdirin.",
    Statistics_MonthView_up_action_2: "Daimi istehsalı standart formata çevirin.",
    Statistics_MonthView_up_action_3: "Aylıq əsas metrikləri yoxlayın və qeyd edin.",
    Statistics_MonthView_up_urgency: "Orta",

    Statistics_MonthView_neutral_title: "Aylıq Baxışlar Sabit 💡Format Qarışığını Sına",
    Statistics_MonthView_neutral_summary: "Reels və Stories qarışığı yeni trafik kanalları yarada bilər.",
    Statistics_MonthView_neutral_action_1: "Qarışıq Reels+Stories məzmunu yaradın.",
    Statistics_MonthView_neutral_action_2: "Performansı qeyd edin və müqayisə edin.",
    Statistics_MonthView_neutral_action_3: "Videoya yönəldən altyazılar əlavə edin.",
    Statistics_MonthView_neutral_urgency: "Aşağı",

    Statistics_MonthView_down_title: "Aylıq Baxışlar Azalıb 💡Reels-ə Fokuslan",
    Statistics_MonthView_down_summary:
      "Qısa Reels və cazibədar kapaklar baxışları geri qaytarmanın ən sürətli yoludur.",
    Statistics_MonthView_down_action_1: "15–30 saniyəlik Reels yaradın.",
    Statistics_MonthView_down_action_2: "Cazibədar kapaklar dizayn edin.",
    Statistics_MonthView_down_action_3: "Zamanlama testləri aparın.",
    Statistics_MonthView_down_urgency: "Yüksək",

    Statistics_MonthView_zero_title: "Aylıq Baxış Sıfır 💡Əvvəl Texniki Yoxla",
    Statistics_MonthView_zero_summary:
      "Verilərdə və ya paylaşımda problem ola bilər; əvvəl texniki yoxlayın, sonra 14 günlük plan başlatın.",
    Statistics_MonthView_zero_action_1: "Video məlumatlarını texniki baxımdan yoxlayın.",
    Statistics_MonthView_zero_action_2: "14 günlük məzmun istehsalı planı həyata keçirin.",
    Statistics_MonthView_zero_action_3: "Nəticələri gündəlik izləyin.",
    Statistics_MonthView_zero_urgency: "Yüksək",
    Statistics_RePosts_up_title: "Repost-lar Artır 💡 Ondan İstifadə Et",
    Statistics_RePosts_up_summary:
      "Auditoriyanız post-larınızı paylaşır; bu da məzmununuzun yayılmağa dəyər olduğunu göstərir.",
    Statistics_RePosts_up_action_1: "Caption-da repost üçün aydın səbəb əlavə edin («Dostuna göndər»).",
    Statistics_RePosts_up_action_2: "Paylaşıla bilən tədris seriyası hazırlayın.",
    Statistics_RePosts_up_action_3: "Repost geri bildirişlərini analiz edin və nümunələri tapın.",
    Statistics_RePosts_up_urgency: "Orta",
    Statistics_RePosts_neutral_title: "Repost-lar Az və ya Sabitdir 💡 Sadəcə Sadə Bir Tətikləyici Lazımdır",
    Statistics_RePosts_neutral_summary: "Bəzən repost-ları artırmaq üçün qısa bir CTA kifayətdir.",
    Statistics_RePosts_neutral_action_1: "Post-un sonunda repost üçün çox qısa CTA əlavə edin.",
    Statistics_RePosts_neutral_action_2: "Daha çox saxlanıla və göndərilə bilən məzmun istehsal edin.",
    Statistics_RePosts_neutral_action_3: "«Dostuna göndər» kimi test formatı tətbiq edin.",
    Statistics_RePosts_neutral_urgency: "Aşağı",
    Statistics_RePosts_down_title: "Repost-lar Azalıb 💡 Daha Faydalı Məzmun Lazımdır",
    Statistics_RePosts_down_summary:
      "Məzmun daha az paylaşılandır; insanların başqalarına göndərmək istəyəcəyi şeylər yaratmalısınız.",
    Statistics_RePosts_down_action_1: "Checklist və ya mərhələli məzmun hazırlayın.",
    Statistics_RePosts_down_action_2: "Qısa və yığcam təlimlər paylaşın.",
    Statistics_RePosts_down_action_3: "Repost üçün aydın CTA əlavə edin.",
    Statistics_RePosts_down_urgency: "Yüksək",
    Statistics_RePosts_zero_title: "Heç Bir Repost Qeyd Olunmayıb 💡 Başlanğıc Nöqtəsi Yaratmalısınız",
    Statistics_RePosts_zero_summary:
      "Ya məlumat yoxdur, ya da məzmun repost üçün uyğun deyil; tez bir paylama planı hazırlayın.",
    Statistics_RePosts_zero_action_1: "5 maddəli və ya checklist formatında bir neçə məzmun yaradın.",
    Statistics_RePosts_zero_action_2: "İlk siqnalı almaq üçün kiçik bir boost tətbiq edin.",
    Statistics_RePosts_zero_action_3: "Caption-da repost üçün aydın səbəb yazın.",
    Statistics_RePosts_zero_urgency: "Yüksək",

    // statistics suggestions box
    pageTools_hashtags: "Hashtag-lar",
    pageTools_MyList: "Hashtag siyahısı",
    pageTools_CreateNewListexplain: "Post yaratmaq üçün # siyahısı yaradın",
    Analyzer: "Analiz (AI)",
    pageTools_CreateNewList: "Yeni siyahı yarat",
    pageTools_CustomFont: "Xüsusi font",
    pageTools_CustomFontExplain: "Instagram postlarınız üçün xüsusi fontlardan istifadə edin!",
    pageToolspopup_CreateNewListexplain:
      "<Enter> və <Space> düyməsi ilə yeni hashtag yaradılacaq, hər hashtag üzərinə klikləyərək onu silə bilərsiniz.",
    pageToolspopup_Listname: "Siyahı adı",
    pageToolspopup_hashtags: "Hashtag-lar",
    pageToolspopup_typehere: "Buraya yazın",
    pageTools_hashtagList: "Hashtag siyahısı",
    pageTools_CreateNewListpic: "Şəkil analizi",
    pageTools_CreateNewListpicexplain: "Şəkillə əlaqəli hashtag-lar yaradın",
    pageTools_CreateNewListpage: "Səhifə analizi",
    pageTools_CreateNewListpageexplain: "Instagram ünvanına uyğun hashtag-lar yaradın",
    pageToolspopup_pageURL: "Instagram ID",
    pageToolspopup_HideLikeandViewCounts: "Bəyənmə və baxış sayını gizlət",
    pageToolspopup_TurnoffCommenting: "Şərhləri deaktiv et",
    pageToolspopup_TurnoffCommentingExplain: "Post üçün şərhləri deaktiv edin",
    pageToolspopup_TurnoffCommentingexplainforlottery:
      "Bu Post üçün şərh yazmaq Lottery keçirilən zaman deaktiv ediləcək",

    pageToolspopup_TopHashtag: "Ən yaxşı hashtag",
    pageToolspopup_TopHashtagexplain: "Siz bu hashtag-dan səhifədə neçə dəfə istifadə etmisiniz",
    pageToolspopup_allRepliedcomments: "Bütün cavablanmış şərhlər",
    noresult: "Nəticə tapılmadı",
    viewreplies: "Cavabları gör",
    allRepliedcomments: "Bütün cavablanmış şərhlər",
    Followers: "İzləyicilər",
    NonFollowers: "İzləyici olmayanlar",
    pageToolspopup_ViewersLikes: "Baxışlar və bəyənmələr",
    supportedformat: "Dəstəklənən format",
    limitsize: "Maksimal ölçü",
    TagMention: "Tag və mention",
    cover: "Cover",
    Pleaseselect: "Zəhmət olmasa seçin",
    replace: "Əvəz et",
    Album: "Albom",
    SavedHashtagList: "Saxlanılmış hashtag siyahısı",
    SavedHashtagListexplain: "Hashtagi caption sonuna əlavə etmək üçün seçin",
    FirstComment: "İlk şərh",
    PinFirstComment: "İlk şərhi pin et",
    areyousure: "Əminsiniz?",
    shouldFollower: "İstifadəçi səhifəni mütləq izləməlidir",
    draftexplain: "Siz postu qaralama kimi saxlamağa çalışırsınız",
    deletedraftexplain: "Siz qaralamanı silməyə çalışırsınız",
    deleteorderexplain: "Siz sifarişi silməyə çalışırsınız",

    Addpeopleexplain: "*İnsanları tag etdikdən sonra tag-i tənzimləyin və ya iki dəfə klikləyərək silin",
    AdvanceSettings: "Ətraflı parametrlər",
    sharepreviewtofeed: "Preview-i feed-də paylaş",
    Videocopyrightbypass: "Videonun müəllif hüquqlarını keç",
    SetScheduledPost: "Postu planla",
    SetScheduledPostexplain: "Bu post seçilmiş vaxtda yayımlanacaq",
    SetScheduledStoryexplain: "Bu story seçilmiş vaxtda yayımlanacaq",
    addtoproduct: "Məhsullara əlavə et",
    addtoproductexplain: "Bu post məhsul kimi məhsullar siyahısına əlavə olunacaq",
    TurnoffCommentingexplain: "Bu post üçün şərhlər deaktiv ediləcək",
    RecommendedDateTime: "Tövsiyə olunan tarix və vaxt",
    RecommendedDateTimeexplain: "Tövsiyə olunan vaxtlar səhifəniz analizinə əsaslanır",
    publish: "Yayımla",
    pageTools_global: "Qlobal",
    pageTools_FA_AR: "Fars / Ərəb",
    pageTools_Overall: "Ümumi",
    pageTools_year: "İl",
    pageTools_Month: "Ay",
    pageTools_Week: "Həftə",
    pageTools_Day: "Gün",
    pageTools_hashtag: "Hashtag",
    pageTools_USED: "İstifadə olunub",
    pageTools_SearchedHashtag: "Axtarılan hashtag",
    pageTools_TrendHashtags: "Trend hashtag-lar",
    pageTools_AutoInterAction: "İzləyicilərlə avtomatik qarşılıqlı əlaqə",
    pageTools_AcceptPendingRequests: "Gözləyən izləmə sorğularını avtomatik qəbul et",
    pageTools_LikeAllNewComments: "Yeni şərhləri bəyən",
    pageTools_LikeNewFollowersPosts: "Yeni izləyicilərin son postlarını bəyən",
    pageTools_RemoveAllFollowings: "Bütün follow-ları sil",
    pageTools_WinnerPicker: "Çəkiliş (Qalib seçimi)",
    pageTools_DayEvents: "Günün Hadisələri",
    pageTools_EventDateRange: "Tarix Aralığı",
    pageTools_EventLanguage: "Dil",
    pageTools_EventSelectDate: "Tarix Aralığını Seçin",
    pageTools_EventSearch: "Hadisələri Axtar",
    pageTools_EventEmpty: "Seçilmiş aralıq üçün hadisə tapılmadı",
    pageTools_EventReligious: "Dini",
    pageTools_EventIdeas: "Hadisə İdeyaları",
    pageTools_IdeaCreate: "Hadisə İdeyaları Yarat",
    pageTools_IdeaExplain: "Gələcək hadisə və münasibətlərə əsaslanan AI-dəstəkli məzmun ideyaları əldə edin",
    pageTools_CreateEventIdea: "Hadisə İdeyaları Yarat",
    pageTools_CreateEventIdeaPrompt: "Mövzu / İstek",
    pageTools_CreateEventIdeaPromptPlaceholder: "məs: ayaqqabı, idman, səyahət... (bütün mövzular üçün boş buraxın)",
    pageTools_CreateEventIdeaOptional: "isteğe bağlı",
    pageTools_CreateEventIdeaSubmit: "Yarat",
    pageTools_CreateEventIdeaCancel: "Ləğv et",
    pageTools_EventIdeasLanguage: "Dil",
    pageTools_EventIdeasFetch: "İdeyaları Yüklə",
    pageTools_EventIdeasEmpty: "Hadisə ideyası tapılmadı",
    pageTools_EventIdeasLoadMore: "Daha Çox",
    pageTools_EventIdeasIdea: "İdeya",
    pageTools_EventIdeasCountry: "Ölkə",
    pageTools_EventIdeasPrompt: "Mövzu",
    pageTools_EventIdeasCreatedTime: "Yaradılma Tarixi",
    pageTools_CustomEvent: "Xüsusi Hadisə",
    pageTools_exportcomments: "Bütün comment-lər Excel faylı kimi ixrac olunur və yüklənə, həmçinin paylaşıla bilər",

    pageTools_Lottery: "Bal Lotereyası Yarat",
    pageTools_emptylotteryList: "Hələ heç bir lotereya yaratmamısınız",

    pageTools_LotteryExplain: "Postdakı istifadəçi xallarına əsaslanır",
    pageTools_fromFollowers: "İzləyicilərdən",
    pageTools_FromFollowersExplain: "Bütün izləyicilər arasından təsadüfi seçim",
    pageTools_Result: "Nəticə",
    pageTools_ResultExplain: "Əvvəlki çəkilişlərin tarixçəsi",
    pageTools_popup_detail: "Təfərrüat",
    pageTools_popup_history: "Tarixçə",
    pageTools_LikeAllNewCommentsExplain: "İzləyici hər hansı posta şərh yazdıqda, avtomatik bəyəniləcək.",
    pageTools_AcceptType: "Aktivləşdirmə növü",
    pageTools_popup_AlwaysActive: "Həmişə aktiv",
    pageTools_popup_JustOnce: "Yalnız bir dəfə",
    pageTools_AcceptPendingRequestsexplain: "Bütün izləmə sorğuları avtomatik qəbul ediləcək.",
    pageTools_onlyprivate: "*Yalnız xüsusi səhifələrlə işləyir.",
    pageTools_MaxLike: "Bəyəniləcək post sayı",
    pageTools_Reacceptfollower: "Unfollow-dan sonra yenidən follow",
    pageTools_Reacceptfollowerexplain:
      "Əgər istifadəçi əvvəl follow edib, sonra unfollow etsə və yenidən follow sorğusu göndərsə, sistem qəbul edəcək.",
    waitday: "Gözləmə müddəti",
    waitdayexplain:
      "İstifadəçi sizin və ya sistem tərəfindən follow edildikdən sonra müəyyən edilmiş müddət keçdikdən sonra silinəcək.",
    waitdayexplain2: "Gözləmə sayı günlərlədir. Əgər sıfırdırsa, əməliyyat dərhal baş verir.",
    pageTools_LikeNewFollowersPostsexplain: "Yeni izləyici sizi follow etdikdə, onun son postu avtomatik bəyəniləcək.",
    pageTools_RemoveAllFollowingsexplain: "Bu seçim avtomatik olaraq bütün follow-larınızı siləcək.",
    pageTools_progress: "İzləyici sayınıza görə bu proses bir neçə gün çəkə bilər",
    pageTools_JustUnfollowwho: "Yalnız mənə follow back etməyən follow-ları unfollow et",
    pageTools_AllmyFollowings: "Bütün follow-larım",
    pageTools_pageanAnalyzer: "Səhifə analizi",
    pageTools_pictureanAnalyzer: "Şəkil analizi",
    pageTools_StartAnalysis: "Analizi başlat",

    pageLottery_Step: "Addım",
    pageLottery_Specifications: "Xüsusiyyətlər",
    pageLottery_SelectaPost: "Post seç",
    pageLottery_SetDateTime: "Tarix və vaxt seç",
    pageLottery_WinnersTasks: "İştirakçı tapşırıqları",
    pageLottery_WinnersTasksexplain: "Hər iştirakçının çəkilişə daxil olmaq üçün etməli olduğu tapşırıqlar.",
    pageLottery_NumberofWinners: "Qalib sayı",
    pageLottery_SetScoreForLottery: "İnsanları Qeyd Et",
    pageLottery_SetScoreForLotteryexplain: "İstifadəçilər Püşkatmada iştirak etmək üçün başqalarını qeyd etməlidirlər",

    pageLottery_MinimumMention: "Minimum mention",
    pageLottery_MinimumMentionexplain: "Mention edilməli olan insan sayı",
    pageLottery_FollowedPage: "Follow edilmiş səhifə",
    pageLottery_FollowedPageexplain:
      "İstifadəçilər sizin və/və ya seçdiyiniz səhifələri follow etməlidir ki, çəkilişdə iştirak etsinlər",
    pageLottery_FollowmyPage: "Səhifəmi follow et",
    pageLottery_FollowalternativePages: "Əvəzləyici səhifələri follow et",
    pageLottery_Termsconditions: "Şərtlər və qaydalar",
    pageLottery_publishTermsconditions: "Şərtləri və qaydaları yayımla",
    pageLottery_previewTermsconditionsexplain: "Bu story iştirakçılara story kimi göstəriləcək.",
    pageLottery_Termsconditionsbanner: "Şərtlər və qaydalar banneri",
    pageLottery_Termsconditionsbannerexplain: "Çəkiliş şərtlərini izləyicilərə bildirmək üçün banner seçin.",
    pageLottery_model: "Model",
    pageLottery_Solid: "Bərabər",
    pageLottery_Radial: "Radial",
    pageLottery_Linear: "Xətti",
    pageLottery_Background: "Fon",
    pageLottery_Color: "Rəng",
    pageLottery_Position: "Mövqe",
    pageLottery_Degree: "Dərəcə",
    pageLottery_TextBox: "Mətn qutusu",
    pageLottery_Opacity: "Şəffaflıq",
    pageLottery_Blur: "Bulandırma",
    pageLottery_Font: "Font",
    pageLottery_Winnerannouncement: "Qalib elanı",
    pageLottery_participants1: "🎉 999,999 iştirakçı arasından 🎉",
    pageLottery_participants2: "🥳 Bunlar şanslı qaliblərdir: 🥳",
    pageLottery_participantsexplain:
      "*Sistem avtomatik olaraq iştirakçı və qalib sayını təyin edir və onların ID-lərini hər @ işarəsindən sonra göstərir.",
    pageLottery_Addtocaption: "Çəkiliş başa çatdıqdan sonra caption-a əlavə et",
    pageLottery_Publishasstory: "Qaliblər siyahısı story kimi yayımlansın",
    pageLottery_deleteexplain: "Bu çəkiliş daimi olaraq silinəcək və geri qaytarmaq mümkün deyil.",
    pageLottery_Winnerpickersstatus: "Çəkiliş vəziyyəti",
    pageLottery_scoreLotteryWinners: "Lotereya Qalibləri",
    pageLottery_NoWinners: "Qalib yoxdur",
    pageLottery_RandomFollowersWinners: "Təsadüfi izləyici qalibləri",
    pageLottery_specifickeywordexplain:
      "İstifadəçilər Lottery-də iştirak etmək üçün Şərhlərində xüsusi bir açar sözü yazmalıdırlar",
    pageLottery_FollowmyPageexplain: "İstifadəçilər Lottery-də iştirak etmək üçün səhifəni Follow etməlidirlər",

    pageLottery_ShareRemainingTime: "Qalan vaxtı paylaş",
    ShareTermsAndCondition: "Şərtlər və qaydaları paylaş",
    pageLottery_LotteryRemainingTime: "Çəkilişin qalan vaxtı",
    pageLottery_Winnerpickerisrunning: "Çəkiliş davam edir",
    pageLottery_ViewandEditDetails: "Təfərrüatları gör və redaktə et",
    pageLottery_ActiveWinnerpickers: "Aktiv çəkiliş",
    pageTools_WinnerPickertooltip24hour: "Çəkiliş hər 24 saata bir dəfə mümkündür",
    specifickeywordstooltip: "Sistem avtomatik olaraq emoji və ədədləri fars, ərəb və ingilis dilində tanıyır",
    pageLottery_FilterKeywords: "Sistem təsadüfi olaraq seçilmiş sözə malik şərhlər arasından seçim edir və göstərir",
    pageLottery_NumberofWinnersexplain: "Çəkiliş qaliblərinin sayını təyin edin. Maksimum 100 nəfər qalib ola bilər",
    pageLottery_permanentlinktooltip: "Bu link daimi olsa da, yeni çəkiliş aparıldıqda əvvəlki link silinəcək",
    pageLottery_permanentlinkexplain:
      "Bu linki istifadəçilərə çəkilişin sağlamlığını və orijinallığını təsdiqləmək üçün təqdim edə bilərsiniz",
    pageTools_randomly: "Təsadüfi şəkildə",
    pageTools_BestEngagement: "Ən yaxşı engagement",
    pageTools_BestEngagementexplain: "Ən çox like və şərh almış izləyicilər arasından seçim",
    message_youareattemptingto: "Siz cəhd edirsiniz",
    message_blockexplain:
      "Bu istifadəçi sizin profilinizi, postlarınızı və story-lərinizi tapmayacaq. Instagram ona bildirilməyəcək ki, onu blok etmisiniz",
    message_deleteexplain: "Bu chat daimi olaraq silinəcək və geri qaytarmaq mümkün deyil",
    message_block: "Blok et",
    notactivemessage: "Bu chat müvəqqəti deaktiv edilib. Zəhmət olmasa Instagram tətbiqi vasitəsilə cavab göndərin",
    notactivemessageexplain:
      "Əgər 24 saat ərzində cavab göndərilməzsə, chat əlçatmaz olacaq. Yenidən aktivləşdirmək üçün ya Instagram tətbiqi vasitəsilə cavab verin, ya da qarşı tərəfin yeni mesaj göndərməsini gözləyin.",
    waitingforconnection: "Bağlantı gözlənilir...",
    message_unblock: "Bloku aç",
    messagesetting_goodbye: "Vida mesajı",
    messagesetting_welcome: "Xoş gəldiniz",
    messagesetting_welcomingmessage: "Xoş gəlmisiniz mesajı",
    messagesetting_Activewelcomemessageexplain:
      "Bu mesaj <Xoş gəldiniz mesajı> olaraq Instagram Direct-də sizi follow edənlərə göndəriləcək.",
    messagesetting_Sentmessages: "Göndərilmiş mesajlar",
    message: "Mesaj",
    receivedmessage: "Alınan mesaj",
    Messageresponse: "Mesaj cavabı",
    receivedcomment: "Alınan şərh",
    commentresponse: "Şərh cavabı",
    Likethereceivedcomment: "Alınan şərhi bəyən",
    unreadmessage: "Oxunmamış mesajlar",
    specifickeywords: "Xüsusi açar söz",
    unreadcomment: "Oxunmamış şərhlər",
    hiddencommenttooltip: "Bu şərh istifadəçilərdən gizlidir. Yalnız adminlər görə bilər",
    vanishmode: "Gizli rejim",
    vanishmodeexplain: "Gizli rejimdə cavablandırılmamış, nəzərə alınmamış və ya gizlədilməmiş mesajlar göstəriləcək.",
    totalcomments: "Ümumi şərhlər",
    unansweredcomments: "Cavabsız şərhlər",
    totalcommenters: "Ümumi şərhçilər",
    commentmanagement: "Şərhlərin idarə olunmasına xoş gəlmisiniz",
    ticketmanagement: "Müştəri tike-lərinin idarə olunmasına xoş gəlmisiniz",

    flowmanagement: "Flow yaradın və Instagram cavablarınızı ağıllı və avtomatik edin",
    QuickReplyexplain: "Bütün alınan şərhlər avtomatik olaraq cavablandırılır.",
    autocommentReply: "Şərhlərə avtomatik cavab",
    Sendresponseifthepageisfollowed: "Səhifə follow olunubsa cavab göndər",
    Likethereceivedmessage: "Alınan mesajı bəyən",
    messagesetting_Activewelcomingmessage: "Xoş gəlmisiniz mesajı",
    messagesetting_welcometext:
      "Salam! 🌟\nDünyamıza xoş gəldiniz! 🎉 Sizi izləyicilərimiz arasında görməkdən çox şadıq. 🤗\nÜmid edirik ki, səhifəmizdən maraqlı və faydalı məzmun əldə edəcəksiniz. Əgər sualınız və ya təklifiniz varsa, bizimlə paylaşın. 😊\nSizi heyrətamiz dünyamızda qarşılayacağımızı səbirsizliklə gözləyirik.✨\nHörmətlə 💫",
    messagesetting_goodbyetext:
      "Salam! 👋\nTəəssüf ki, səhifəmizi tərk etdiniz. 😢 Biz hər izləyicimizə dəyər veririk. Əgər xüsusi səbəb varsa, bizimlə bölüşə bilərsiniz. 🫡\nHər halda, sizə ən yaxşılarını arzu edirik və gələcəkdə yenidən bizimlə olmağınızı ümid edirik. 💫",
    messagesetting_ActiveFarewellmessage: "Vida mesajı",
    messagesetting_ActiveFarewellmessageexplain:
      "Bu mesaj <Vida mesajı> olaraq Instagram Direct-də sizi unfollow edənlərə göndəriləcək.",
    messagesetting_businessmessagefilter: "Biznes mesaj filtr",
    messagesetting_businessmessagefiltering: "Biznes mesajlarını filtrlə",
    messagesetting_businessmessagefilteringexplain:
      "Seçilmiş chat avtomatik olaraq Direct-də <Biznes mesajları> bölməsinə göndəriləcək.",
    messagesetting_specificwords: "Xüsusi sözlər",
    messagesetting_autofiltering: "Avtomatik filter (AI)",
    messagesetting_specificwordsexplain: "Bir neçə söz əlavə edə bilərsiniz, hər birini <Enter> ilə ayırın.",
    messagesetting_Createanewsupportticket: "Yeni dəstək tiketi yarat",
    messagesetting_CreateanewsupportticketExplain:
      "İstifadəçilər bu seçimi istifadə edərək Direct-də dəstək tiketi yarada bilərlər. Siz Brancy paneli vasitəsilə və ya birbaşa cavab verə bilərsiniz.",
    messagesetting_Changeapplicationlanguage: "Direct seçimlərinin dilini dəyiş",
    messagesetting_ChangeapplicationlanguageExplain:
      "Bu seçimi aktivləşdirdikdə, istifadəçilər Direct funksiyalarını 7 dildə (EN, FA, AR, FR, RU, TR, DE) görə biləcəklər. Sistem lazımi tərcümələri avtomatik təmin edəcək.",
    messagesetting_ViewStoreandproducts: "Mağaza məhsullarını gör",
    messagesetting_ViewStoreandproductsExplain:
      "İstifadəçilər məhsulları siyahı və ya albom şəklində, mövcudluq, qiymət və digər xüsusiyyətlərlə görə biləcəklər.",
    messagesetting_Visityourwebsite: "Veb-saytı göstər",
    messagesetting_VisityourwebsiteExplain:
      "İstifadəçilər bu seçimi istifadə edərək saytınızı görə və lazım gələrsə birbaşa keçid edə bilərlər. (Səhifə yüksək sürətlə yüklənəcək.)",
    messagesetting_Viewuserrolesandpermissions: "Biznes qaydaları və tənzimləmələr",
    messagesetting_ViewuserrolesandpermissionsExplain:
      "Bu seçimi aktivləşdirdikdə, istifadəçilər Brancy-də təyin etdiyiniz biznes qaydalarını və məhdudiyyətləri görə biləcəklər.",
    messagesetting_Viewbusinesshourschart: "Biznes iş saatları",
    messagesetting_ViewbusinesshourschartExplain:
      "İstifadəçilər sizin iş saatlarınızı görə biləcəklər və bu mesajları xaricdən gələn sorğular azaldacaq.",
    messagesetting_Viewpricinginformation: "Reklam xidmətlərinin qiymətləri",
    messagesetting_ViewpricinginformationExplain:
      "Bu seçimi aktiv etdikdə, istifadəçilər xidmətlərin ən son qiymətlərini görə biləcəklər.",
    messagesetting_Searchforproducts: "Məhsulları axtar",
    messagesetting_SearchforproductsExplain:
      "İstifadəçilər məhsul adını, post nömrəsini və ya caption hissəsini göndərərək məhsul haqqında məlumat əldə edib birbaşa ala bilərlər. Bu satışları artıracaq.",
    messagesetting_addautomaticreplysystemsystem: "Bütün səhifə üçün vahid sistem cavabı",
    messagesetting_HideRobotReply: "Avtomatik və Bot Mesajlarını Gizlət",
    messagesetting_HideRobotReplyExplain:
      "Avtomatik bot mesajları gizlədilir və Direct-də yalnız real mesajlar göstərilir",
    messagesetting_LikeRobotReply: "Story Comment-lərini Avtomatik Bəyən",
    messagesetting_HideRobotReplytooltip:
      "Mesajlar silinmir, yalnız Direct idarəetməsini asanlaşdırmaq üçün gizlədilir",
    messagesetting_LikeRobotReplyExplain:
      "Story comment-ləri daha çox qarşılıqlı əlaqə yaratmaq üçün avtomatik bəyənilir",
    messagesetting_automaticreplysystem: "Avtomatik Cavabların İdarə Edilməsi",
    messagesetting_automaticreplysystemforallpost:
      "Bütün Post-lar üçün avtomatik comment cavablarını aktiv və ya deaktiv et",
    messagesetting_automaticreplysystemforallposttooltip:
      "Əgər müxtəlif Post-lar üçün avtomatik comment cavabları təyin etmisinizsə, bu seçimlə onların hamısını eyni anda aktiv və ya deaktiv edə bilərsiniz. Cavabları tənzimləmək üçün hər Post-un səhifəsinə ayrıca daxil olmalısınız",

    messagesetting_messagePanellanguage: "Default Direct dili",
    messagesetting_messagePanellanguageExplain: "Direct robotunun mesajlara cavab üçün default dili",
    messagesetting_AutoReplyPerFollow: "Fərdi izləmə şablonu",
    messagesetting_AutoReplyPerFollowExplain:
      "İstifadəçidən səhifəni izləməsi tələb olunduqda bu şablondan istifadə edilir.",
    messagesetting_AutoReplyPerFollowtooltip:
      "Sizi follow etməyən istifadəçilər əvvəlcə follow sorğusu alacaqlar. Səhifənizi follow etdikdən sonra avtomatik mesaj göndəriləcək",
    messagesetting_AutoReplyPerFollowtitle: "Mesaj Mətni",
    messagesetting_AutoReplyPerFollowtitlesample: "Nümunə: Mesajı almaq üçün əvvəlcə səhifəmizi follow edin",
    messagesetting_AutoReplyPerFollowbtn: "Düymə Mətni",
    messagesetting_AutoReplyPerFollowbtnsample: "Nümunə: Follow etdim, Mesajı Göndərin",
    messagesetting_automaticreplysystemexplain:
      "Hər mesaj və ya şərh alındıqda, səhifənin hər yerində (feed, story, reels, live və s.) sistem avtomatik olaraq təyin etdiyiniz mətnlə cavab verir.",

    messagesetting_KeywordSensitive: "Sözə həssas",
    messagesetting_KeywordsSensitive: "Sözlərə həssas",
    sendreplydirectedsuccessfully: "Direct-dən sonra comment daxilində təsdiq mesajı göndərildi",

    autoReplyFor: "Avtomatik cavab üçün",
    messagesetting_selectedwords: "Seçilmiş maddələr",
    autocommentReplyExplain: "Şərh və ya mesaj alındıqda sistem avtomatik cavab verir.",
    selectnewmessage: "Cavab göndərmək üçün, zəhmət olmasa bir mesaj seçin",
    sendreplyticket: "Cavabları göndər",
    emptyticketdirect: "Hələ Direct-dən heç bir müştəri tike-i almadınız",
    emptysystemticket: "Hələ Brancy sistemindən heç bir müştəri tike-i almadınız",
    emptycomment: "Hələ göstəriləcək şərh yoxdur",
    emptydirect: "Hələ göstəriləcək Direct yoxdur",

    respondToAllComments: "Bütün şərhlərə cavab ver",
    sensitiveToSpecificKeywords: "Xüsusi açar sözlərə həssas cavab",
    sensitiveToSpecificKeywordsExplain:
      "Əgər bu sözlər şərhdə varsa, sistem avtomatik olaraq həmin şərhə cavab verəcək",
    contain: "Açar söz daxil olsun",
    containExplain:
      "Aktiv olduqda, şərhdə açar söz keçərsə cavab göndərilir. Söndürüləndə yalnız şərhin hamısı açar sözlə eyni olduqda cavab göndərilir.",
    replyMethod: "Cavab üsulu",
    respondInSameComment: "Eyni şərhdə cavab ver",
    respondDirectly: "Birbaşa Direct ilə cavab ver",
    ticketID: "Tike ID",
    noNewAnsweredTickets: "Yeni cavablandırılmış tiketiniz yoxdur",
    noNewPendingTickets: "Yeni davam edən tiketiniz yoxdur",
    noNewClosedTickets: "Bağlanmış tiketiniz yoxdur",

    Ticketclosedby: "Tike-i bağlayan",
    waitingforuserresponse: "İstifadəçi cavabını gözləyir",
    inactiveticketexpired: "Bu tike son 24 saat ərzində aktiv olmadığı üçün deaktiv edilib",
    automaticreply: "Avtomatik cavab",
    autodirectexplain: "Xüsusi açar söz Direct-də alındıqda, öncədən təyin edilmiş cavab avtomatik olaraq göndəriləcək",
    adddirectexplain: "Direct-ə avtomatik cavab əlavə et",
    autocommentexplain:
      "Xüsusi açar söz şərhdə alındıqda, öncədən təyin edilmiş cavab avtomatik olaraq həmin şərhdə göndəriləcək",
    addcommentexplain: "Şərhlərə avtomatik cavab əlavə et",
    messagesetting_icebreaker: "Sürətli söhbət düyməsi",
    messagesetting_addNewButton: "Yeni düymə əlavə et",
    messagesetting_icebreakerexplain:
      "İstifadəçi Direct-ə ilk dəfə daxil olduqda, 4 düymə göstərilir və seçilən düyməyə uyğun cavab göndərilir.",
    messagesetting_addicebreakerexplain: "Maksimum 4 sürətli söhbət düyməsi əlavə edə bilərsiniz",
    messagesetting_PersistentMenu: "Daimi Direct menyusu",
    messagesetting_PersistentMenuexplain:
      "Həmişə əlçatan olan menyu, müştərilərinizin brendlə əlaqəsini sürətli və rahat edir.",
    messagesetting_addPersistentMenuexplain: "Maksimum 3 daimi menyu düyməsi əlavə edə bilərsiniz",
    Welcometodirectmessages: "Instagram Direct mesajlarına xoş gəldiniz!",
    messagesetting_UseSystemButtonsExplain:
      "Mağazaya Bax, Dəstək Bileti və Dil Dəyişdirilməsi kimi standart məlumatları təqdim etmək üçün hazır sistem düymələrindən istifadə edin",
    messagesetting_UseAIPromptsExplain:
      "Süni intellekt prompt-larından istifadə edərək istifadəçilərə öz üslubunuz və tonunuzla ağıllı və fərdiləşdirilmiş cavablar təqdim edin",
    messagesetting_ButtonTitle: "Düymə Başlığı",
    messagesetting_NoPromptsFound:
      "Heç bir prompt tapılmadı. Yeni prompt yaratmaq üçün yaratma səhifəsinə yönləndiriləcəksiniz.",
    messagesetting_CreateNewPrompt: "Yeni Prompt Yarat",
    messagesetting_SelectYourPrompt: "Prompt-unuzu Seçin",
    messagesetting_DefineCustomResponseExplain:
      "İstədiyiniz cavab mətnini müəyyən edin ki, istifadəçilərə avtomatik göndərilsin",
    messagesetting_SelectPredefinedFlowExplain:
      "İstifadəçi ilə ağıllı və avtomatik danışıq başlatmaq üçün əvvəlcədən təyin edilmiş bir flow seçin",
    messagesetting_NoFlowsFound:
      "Heç bir flow tapılmadı. Yeni flow yaratmaq üçün yaratma səhifəsinə yönləndiriləcəksiniz.",
    messagesetting_CreateNewFlow: "Yeni Flow Yarat",
    messagesetting_SelectFlow: "Flow Seç",
    messagesetting_ViewFlow: "Flow-a Bax",
    messagesetting_UseGeneralAIExplain:
      "İstifadəçilərlə sərbəst və limitsiz qarşılıqlı əlaqə üçün ümumi süni intellektdən istifadə edin",
    tool_token_usage_guide: "Bu alət işlədilərkən təxmini token istifadəsi",
    tool_how_use: "Alətdən istifadə qaydası",
    tool_how_work: "Alətin işləmə prinsipi",
    send_sms_ir_code_description: "SMS.ir platformu vasitəsilə istifadəçiyə SMS göndərmək",
    send_sms_ir_code_completeDescription:
      "Bu alət istifadəçilərə təsdiq kodu, qeydiyyat və bildiriş SMS-ləri göndərmək üçün istifadə olunur. Telefon nömrələri SMS xidmətində istifadə edilir.",
    send_sms_ir_code_howUse: `1- SMS.ir-dən ApiKey alın və daxil edin.
2- SMS şablonunu TemplateId bölməsinə yazın.
3- {CODE} olan yerlər avtomatik OTP ilə əvəz olunur.
`,
    send_sms_ir_code_howWork: `1- İstifadəçi Direct-də nömrəsini göndərir.
2- SMS göndərilir. {CODE} varsa OTP ilə əvəz olunur.
3- İstifadəçi kodu AI-yə göndərir.
4- AI kodu yoxlayır və nömrəni təsdiqləyir.
`,

    send_to_telegram_description: "Bot vasitəsilə Telegram-a mesaj göndərmək",
    send_to_telegram_completeDescription:
      "Bu alət Telegram bot Token-i ilə kanal və ya çatlara mesaj göndərmək üçün istifadə olunur.",
    send_to_telegram_howUse: "1- Bot Token daxil edin.\n2- Chat ID və ya Channel ID daxil edin.\n3- Aləti işə salın.",
    send_to_telegram_howWork:
      "1- İstifadəçi Token və Channel daxil edir.\n2- Sistem Telegram API sorğusu hazırlayır.\n3- Mesaj göndərilir.",

    sender_username_description: "Göndərənin istifadəçi adını prompt daxilində istifadə etmək",
    sender_username_completeDescription:
      "Bu alət AI prompt-larında {SENDER_USERNAME} istifadə edərək göndərənin adını avtomatik əvəz edir.",
    sender_username_howUse:
      "1- Prompt-a {SENDER_USERNAME} əlavə edin.\n2- Avtomatik olaraq istifadəçi adı ilə əvəz olunur.",
    sender_username_howWork:
      "1- İstifadəçi {SENDER_USERNAME} əlavə edir.\n2- Sistem istifadəçi adı ilə əvəz edir.\n3- AI cavab yaradır.",
    filter_most_expensive: "Ən bahalı",
    filter_cheapest: "Ən ucuz",
    filter_newest: "Ən yeni",
    filter_highest_discount: "Ən yüksək endirim",
    filter_all_products: "Bütün məhsullar",
    filter_only_available: "Yalnız mövcud məhsullar",
    filter_reset: "Filtrləri sıfırla",
    filter_sortby: "Təsnif et",
    filter_category: "Kateqoriya",
    filter_price: "Qiymət",
    Pricerange: "Qiymət aralığı",
    from: "dən",
    to: "ədək",
    filter_rating: "Reytinq",
    filter_followers: "İzləyicilər",
    default: "Default",
    lowtohigh: "Azdan çoxa",
    hightolow: "Çoxdan aza",
    biolinkHomerating: "Reytinq",
    biolinkHomefollower: "İzləyici",
    biolinkHomepost: "Post",
    biolinkHomeAllMarkets: "Hamısı",
    biolinkHomeAdvertise: "Reklam verən",
    biolinkHomeStore: "Mağaza",
    biolinkStatisticsAllLinkclicks: "Bütün link klikləri",
    biolinkStatisticsMarketviews: "Market baxışları",
    biolinkStatisticsmostview: "Ən çox baxılan",
    biolinkStatisticscouponcodeused: "Endirim kodundan istifadə",
    biolinkStatisticslastupdate: "Son yeniləmə",
    biolinkStatisticsAllsearches: "Bütün axtarışlar",
    biolinkStatisticsfeatures: "Parametrlər",

    biolinkStatisticsVisits: "Baxışlar",
    biolinkStatisticsClicksAndInteractions: "Kliklər və qarşılıqlı əlaqələr",
    biolinkStatisticsVisitsConverted: "Klikə çevrilmiş baxışlar",
    biolinkStatisticsQuickUserExitAfterEntry: "Daxil olduqdan sonra sürətli çıxış",
    biolinkStatisticsNoInteractionExit: "Qarşılıqlı əlaqəsiz çıxış",
    biolinkStatisticsMaxClicksPerVisit: "Bir istifadəçinin bir baxışda ən çox klik sayı",
    biolinkStatisticsAvgClicksAndInteractionsPerVisitor: "Bir ziyarətçi üçün orta klik və əlaqə sayı",
    biolinkStatisticsTotalVisitTime: "Ümumi baxış vaxtı",
    biolinkStatisticsAvgVisitTime: "Ziyarətçinin orta qalma müddəti",
    biolinkStatisticsVideoPlatformsComparison: "Video platformalarının müqayisəsi",
    biolinkStatisticsYoutube: "YouTube",
    biolinkStatisticsAparat: "Aparat",
    biolinkStatisticsTwitch: "Twitch",
    biolinkStatisticsPlatformEntry: "Platformaya giriş",
    biolinkStatisticsRedirectEvent: "Yönləndirmə hadisəsi",
    biolinkStatisticsPlayVideo: "Video oynatma",
    biolinkStatisticsPlayEvent: "Oynatma hadisəsi",
    biolinkStatisticsUniqueVisit: "Unikal baxış",
    biolinkStatisticsDedicatedLinkVisits: "Xüsusi link baxışları",
    biolinkStatisticsCombinedLinkVisits: "Birləşdirilmiş link baxışları",

    biolinkPropertiesfeatures: "Parametrlər",
    biolinkPropertiesProfileInfoBanner: "Profil məlumatları və banner",
    biolinkPropertiesFeaturebox: "Xüsusiyyətlər qutusu",
    biolinkPropertiesTermsAndActiveTime: "Qaydalar və iş saatları",
    biolinkPropertiesFeatureboxexplain:
      "Hər funksiyanı aktivləşdirərək link səhifənizin ziyarətçilərinə vacib məlumatları göstərə bilərsiniz",
    biolinkPropertiesBanner: "Banner",
    biolinkPropertiesFeaturesBox: "Xüsusiyyətlər qutusu",
    biolinkPropertiesReviews: "Rəylər",
    biolinkPropertiesAnnouncements: "Elanlar",
    biolinkPropertiesAnnouncementsexplain:
      "Bu bölmədə izahlar yazaraq link səhifənizin ziyarətçilərinə vacib məlumatları çatdıra bilərsiniz",

    biolinkPropertiesOnlineStream: "Canlı yayım",
    biolinkPropertiesOnlineStreamexplain:
      "Bu seçimi aktivləşdirdikdə, kanalınızda canlı yayına başladığınız anda o, avtomatik olaraq xüsusi linkinizdə göstəriləcək",

    biolinkPropertiesLastVideo: "Son video",
    biolinkPropertiesLastVideoexplain:
      "Bu seçimi aktivləşdirdikdə, kanalınıza yeni video yüklədiyiniz zaman son video avtomatik olaraq xüsusi linkinizdə görüntülənəcək və daim yenilənəcək",

    biolinkPropertiesProducts: "Məhsullar",
    biolinkPropertiesProduct: "Məhsul",
    biolinkProperties_showLast10Products: "Son 10 məhsulu göstər",
    biolinkProperties_showBestSellingProducts: "Ən çox satılan məhsulları göstər",
    biolinkPropertiesAdsTimeline: "Reklam cədvəli",
    biolinkPropertiesQandABox: "Sual-cavab qutusu",
    biolinkPropertiesLinkShortcut: "Qısa link",
    biolinkPropertiesContactAndMap: "Əlaqə və xəritə",
    biolinkPropertieslinks: "Linklər",
    clickonstreamvideo: "Canlı yayımı izləmək üçün videoya klikləyin",
    livestarted: "Canlı Yayım Davam Edir",
    live: "Canlı",
    biolinkPropertiesaddnew: "Yeni link əlavə et",
    biolinkProperties_DomainManager: "Domen idarəetməsi",
    biolinkProperties_DomainManagerexplain: "Sizə məxsus xüsusi veb-sayt",
    biolinkProperties_DomainManagerexplain2:
      "Bu linki Instagram Bio bölməsində yerləşdirə və ya digər istifadəçilərlə paylaşa bilərsiniz",

    biolinkProperties_explain: "Instagram istifadəçi adı dəyişsə, link avtomatik yenilənəcək",
    biolinkProperties_rejected: "Domeniniz rədd edildi (Zəhmət olmasa bizimlə əlaqə saxlayın)",
    customDomain_inactive_title: "Xüsusi domen aktiv deyil",
    customDomain_inactive_desc: "Domeniniz hal-hazırda aktiv deyil. Aktivləşdirmək üçün dəstək biletini göndərin.",
    customDomain_noPackage_title: "Xüsusi domen paketi tapılmadı",
    customDomain_noPackage_desc:
      "Cari paketiniz xüsusi domen dəstəyini əhatə etmir. Bu xüsusiyyətdən istifadə etmək üçün paketinizi yüksəldin.",
    customDomain_rule_validChars: "Yalnız hərflər və rəqəmlərə icazə verilir",
    customDomain_rule_noUnderscore: "(_) və (-) simvollarına icazə verilmir",
    customDomain_rule_noSubdomain: "Alt domenlərə (Subdomain) icazə verilmir",
    biolinkProperties_Request: "Tələb",
    biolinkProperties_Requested: "Tələb edildi",
    biolinkProperties_Checking: "Yoxlanılır",
    biolinkProperties_yourstore: "Mağaza (Sizin link)",
    biolinkProperties_yourads: "Reklam sifariş linki",
    biolinkProperties_yourlottery: "Keçirdiyiniz lotereyalar",
    biolinkProperties_yourtariff: "Qiymət cədvəli",
    biolinkProperties_yourBusinesshours: "Fəal iş saatlarınız",
    biolinkProperties_yourBusinessTerms: "Biznes şərtləri",
    biolinkProperties_defaultAddress: "Default domen ünvanı",
    biolinkProperties_CustomAddress: "Xüsusi domen ünvanınız",
    biolinkPropertiespopup_GeneralCustom: "Ümumi",
    biolinkPropertiespopup_socialmedia: "Sosial şəbəkələr",
    biolinkPropertiespopup_mediastream: "Media və stream",
    biolinkPropertiespopup_clouddrivecontent: "Cloud drive məzmunu",
    biolinkPropertiespopup_Finance: "Maliyyə",
    biolinkProperties_followersrate: "İzləyici sayı",
    biolinkProperties_followersrateExplain: "Instagram səhifənizin izləyici sayını göstərir",
    biolinkProperties_successRating: "Uğur reytinqi",
    biolinkProperties_successRatingExplain: "Sifarişlərin icra olunma uğur göstəricisini göstərir",
    biolinkProperties_bussinessHours: "Aktiv iş saatları",
    biolinkProperties_bussinessHoursExplain: "Biznesinizin iş saatlarını göstərir",
    biolinkProperties_Enamadverified: "E-Namad təsdiqi",
    biolinkProperties_EnamadverifiedExplain: "E-Namad etibar nişanınızın təsdiq statusunu göstərir",
    biolinkProperties_BusinessTerms: "Biznes şərtləri",
    biolinkProperties_BusinessTermsExplain: "Biznesinizin qayda və şərtlərini göstərir",
    biolinkProperties_tariff: "Tarif",
    biolinkProperties_TariffExplain: "Xidmət qiymətlərini göstərir",
    biolinkProperties_StartADS: "Reklam sorğusu başlat",
    biolinkProperties_StartADSExplain: "İstifadəçi sizin tariflərinizə əsasən reklam başlada bilər",
    biolinkProperties_StartSALES: "Satınalma başlat",
    biolinkProperties_StartSALESExplain: "İstifadəçi məhsullarınıza əsasən satınalma başlada bilər",
    biolinkProperties_NameServers: "Domen Name Server-ləri",
    biolinkProperties_NameServersExplain: "Name Server-ləri domen provayderinizin idarəetmə panelində qeyd edin",
    customDomain_dnsError:
      "Domenin Name Server-ləri hələ domen provayderinizdə qeydiyyatdan keçməyib. Zəhmət olmasa yenidən cəhd edin",
    customDomain_active_desc:
      "Bu domeni dəyişdirmək və ya silmək üçün sorğunuzu Ayarlar bölməsindəki Dəstək Bileti vasitəsilə göndərin",
    biolinkProperties_NameServerstooltip:
      "Sorğunuzun internetdə Name Server-lərin yayılması və domeninizin aktivləşməsi 12 saata qədər çəkə bilər.",
    linkURL: "Link ünvanı",
    searchID: "Kanal əlavə et",
    searchIDexplain: "İstifadəçi ID və ya kanal adını yazın",

    Browse: "Gözat",
    biolinkPropertiespopup_yourcustomIcon: "Sizin xüsusi ikon",
    Boldit: "Diqqət cəlb et!",

    Scheduletime: "Avtomatik silmə vaxtı",
    biolinkPropertiespopup_ProfileInfo: "Profil məlumatları",
    biolinkPropertiespopup_Banner: "Banner",
    biolinkPropertiespopup_Personal: "Şəxsi",
    biolinkPropertiespopup_SameasInstagramProfile: "Instagram profil ilə eyni",

    marketpropertise_aboutus: "Bu sayt Brancy platforması ilə yaradılıb",
    marketpropertise_copyright: "Bütün hüquqlar qorunur",
    marketpropertise_aboutusslogan:
      "Brancy, ağıllı bio link yaratmaq və Instagram səhifəsini idarə etmək üçün ən yaxşı seçimdir",
    marketpropertise_madeby: "🤍 tərəfindən yaradılıb",
    custom: "Fərdi",
    advertiseProperties_biography: "Bioqrafiya",
    uploadbannerexplain: "Bir neçə şəkil yükləmək yükləmə sürətinə təsir göstərə bilər.",
    Embed: "Video yerləşdir",
    Embedexplain:
      "Bu seçimi aktivləşdirdikdə, video birbaşa xüsusi linkinizdə göstərilir və oxudulur və istifadəçi səhifəni tərk etmədən və ya başqa bir platformaya yönəldilmədən videoya baxa bilər",
    notfound: "Tapılmadı",
    showsavecontactbutton: "Əlaqə yadda saxla düyməsini göstər",
    Map: "Xəritə",
    Contact: "Əlaqə",
    Showmap: "Xəritəni göstər",
    location: "Məkan",
    phone: "Telefon",
    invalidphone: "Yanlış telefon nömrəsi",
    email: "Email",
    invalidemail: "Yanlış email",
    Address: "Ünvan",

    advertise_ADDetail: "Reklam detalları",
    content: "Məzmun",
    advertise_orderdate: "Sifariş tarixi",
    advertise_duration: "Müddət",
    Remaining: "Qalıq",
    ago: "əvvəl",

    advertisecalendar_calendar: "Təqvim",
    advertisecalendar_nextday: "Bu günün növbəti reklamları",
    advertisecalendar_TODAY: "Bugün",
    advertisecalendar_BookaTime: "Bir vaxt rezerv et",
    advertisecalendar_TIMELINEZOOM: "Vaxt xəttini böyüt",
    advertisecalendar_Timeline: "Vaxt cədvəli",

    advertisestatistics_lasttwomonth: "Son iki ay",
    advertisestatistics_lastmonth: "Keçən ay",
    advertisestatistics_thismonth: "Bu ay",
    advertisestatistics_ads: "Reklam",
    advertisestatistics_fromlast: "Keçən aydan %",
    advertisestatistics_totalADSstatistics: "Ümumi reklam statistikası",
    advertisestatistics_TotalAds: "Ümumi reklamlar",
    advertisestatistics_TotalIncome: "Ümumi gəlir",
    advertisestatistics_totaladsreport: "Ümumi reklam hesabatı",
    advertisestatistics_adno: "Reklam nömrəsi",
    advertisestatistics_advertiser: "Reklam verən",
    advertisestatistics_type: "Növ",
    advertisestatistics_status: "Vəziyyət",
    advertisestatistics_price: "Qiymət",
    advertisestatistics_date: "Tarix",
    advertisestatistics_share: "Paylaş",

    advertiseadlist_activeAd: "Yayımlanan reklamlar",
    advertiseadlist_AwaitingApproval: "Təsdiq gözləyən reklamlar",
    advertiseadlist_AwaitingPublication: "Planlaşdırılan reklamlar",
    advertiseadlist_rejectedlist: "Rədd edilmiş reklamlar",

    advertiseProperties_Concurrentads: "Eyni vaxtlı reklamlar",
    advertiseProperties_Concurrentadsexplain: "Müəyyən vaxt ərzində aktiv reklamların sayı",
    advertiseProperties_numberofads: "Səhifədə reklam sayı",
    advertiseProperties_numberofadsexplain: "Gündə aktiv reklam sayı",
    advertiseProperties_campaign: "Kampaniya",
    advertiseProperties_campaignexplain: "Brancy vasitəsilə reklam kampaniyalarında iştirak imkanı",
    advertiseProperties_adsoptions: "Reklam seçimləri",
    advertiseProperties_rejectreasonheader1: "Səbəb 1 (Əlaqəsiz məzmun)",
    advertiseProperties_rejectreasonheader2: "Səbəb 2 (Sağlam olmayan məzmun)",
    advertiseProperties_rejectreasonheader3: "Səbəb 3 (Siyasət pozuntusu)",
    advertiseProperties_rejectreasonheader4: "Səbəb 4 (Mənfi rəy)",
    advertiseProperties_rejectreason1:
      "Təəssüf ki, təqdim olunan məzmun səhifəmizin dəyərləri və məqsədləri ilə uyğun deyil, auditoriyamız üçün əlaqəsizdir və ya vacib məlumatlardan məhrumdur, buna görə bu reklamı qəbul edə bilmirik.",
    advertiseProperties_rejectreason2:
      "Təəssüf ki, təqdim olunan məzmun auditoriyamız üçün sağlam olmayan, yanıltıcı və ya mürəkkəb məlumatlar ehtiva edə bilər və geniş dəyişikliklər tələb edir, buna görə bu reklamı qəbul edə bilmirik.",
    advertiseProperties_rejectreason3:
      "Təəssüf ki, təqdim olunan məzmun qaydalarımıza və ya Instagram qaydalarına uyğun deyil və ağlabatan olmayan, təhqiredici, müzakirə doğuran və ya cinayət hesab edilə biləcək xüsusiyyətlərə sahib ola bilər. Buna görə bu reklamı qəbul edə bilmirik.",
    advertiseProperties_rejectreason4:
      "Təəssüf ki, oxşar reklamların çoxluğu, zaman uyğunsuzluğu, əvvəlki istifadəçi rəylərinin mənfi olması və ya təqdim olunan məzmunun aşağı keyfiyyəti səbəbindən bu reklamı qəbul edə bilmirik.",

    advertiseProperties_AdvertisingTerms: "Reklam şərtləri",
    advertiseProperties_AdvertisingTermsexplain:
      "Reklam verənlər bu qaydaları qəbul etməlidirlər ki, səhifənizdə reklam edə bilsinlər.",
    advertiseProperties_AdvertisingTerm1: "Şərt 1 səhifəniz",
    advertiseProperties_AdvertisingTerm2: "Şərt 2 səhifəniz",
    advertiseProperties_AdvertisingTerm3: "Şərt 3 səhifəniz",
    advertiseProperties_AdvertisingTerm4: "Şərt 4 səhifəniz",
    advertiseProperties_AdvertisingTermsave: "Yadda saxla",

    advertiseProperties_businesshours: "Admin iş saatları",
    advertiseProperties_24hours: "24 saat aktiv",
    advertiseProperties_close: "24 saat qeyri-aktiv",
    advertiseProperties_notifications: "Bildirişlər",
    advertiseProperties_notificationsSMS: "SMS",
    advertiseProperties_notificationsEmail: "Email",
    advertiseProperties_notificationssystem: "Sistem bildirişi",
    advertiseProperties_notificationsinstagramdirect: "Instagram Direct",
    advertiseProperties_notificationssystemticket: "Bilet",

    advertiseProperties_advertisetariff: "Reklam tarifləri",
    advertiseProperties_onlyToday: "Yalnız bu gün",
    advertiseProperties_onlyTodayexplain: "Reklam qiymətləri yalnız bu gün üçün keçərlidir",
    advertiseProperties_tariff12hours: "12 saat",
    advertiseProperties_tariff24hours: "24 saat",
    advertiseProperties_otherdays: "Əsas (digər günlər)",
    advertiseProperties_otherdaysexplain: "Digər günlər üçün reklam qiymətləri",
    advertiseProperties_Campaign: "Kampaniya",
    advertiseProperties_Campaignexplain: "Kampaniya üçün reklam qiymətləri",
    advertiseProperties_lastModified: "Son dəyişikliklər",
    advertiseProperties_userreport: "İstifadəçi hesabatı",
    advertiseProperties_userID: "İstifadəçi ID",
    advertiseProperties_reportexplain: "Hesabatınız Brancy dəstəyinə göndəriləcək.",
    advertiseProperties_reportsubmit: "Göndər",
    Apply: "Tətbiq et",
    signinyouradvertise: "Reklamları Aktiv Et",
    signinyouradvertiseExplain: "Reklamlarını cəmi bir neçə kliklə aktiv et",

    Storeproduct_activatestore: "Mağazanı aktiv et",
    signinyourstore: "Mağaza yarat",
    signinyourstoreExplain: "Bir neçə klik ilə mağazanızı yaradın",
    Storeproduct_needyourID: "Şəxsiyyəti təsdiqlə",
    Storeproduct_needyourIDExplain: "Şəxsiyyət vəsiqənizi yükləyin",
    Storeproduct_successyourID: "Şəxsiyyətiniz uğurla təsdiqləndi",
    Storeproduct_NationalCardexplain: "Bu kart Brancy-də qeydiyyatdan keçən mobil nömrəyə aid olmalıdır.",
    Storeproduct_addcreditnumber: "Maliyyə məlumatları",
    Storeproduct_addcreditnumberExplain: "Bank kartınızı daxil edin",
    Storeproduct_successnumber: "Bank məlumatlarınız uğurla təsdiqləndi",
    Storeproduct_shippingmethod: "Göndərmə üsulu",
    Storeproduct_shippingmethodExplain: "Göndərmə üsulunu seçin",
    Storeproduct_shippingmethodsuccess: "Seçilmiş göndərmə üsulu uğurla qeyd edildi",
    Storeproduct_shippingmethodtooltip:
      "Tövsiyə olunan üsullar mövqeyinizə əsaslanır. Sonradan mağaza ayarlarında dəyişdirilə bilər.",

    Storeproduct_uploadimagefirst: "Zəhmət olmasa əvvəlcə şəxsiyyət vəsiqənizin şəklini yükləyin",
    Storeproduct_creditcardsameidcard: "Bank kart nömrəsi şəxsiyyət vəsiqəsinin sahibinə aid olmalıdır",
    Storeproduct_postalcode: "Biznes ünvanı",
    Storeproduct_postalcodeExplain: "Poçt kodunu daxil edin",
    Storeproduct_postalcodesuccess: "Ünvan və mövqe uğurla qeyd edildi",
    Storeproduct_postalcodeinputExplain: "Göndərmə haqqı bu ünvana əsasən hesablanacaq, dəqiq poçt kodu daxil edin.",

    Storeproduct_TermsAndCondition: "Şərtlər və qaydalar",
    Storeproduct_TermsAndConditionExplain: "Qaydaları oxuyun və təsdiqləyin",
    Storeproduct_TermsAndConditionesuccess: "Qaydaların qəbul edilməsi uğurla qeyd edildi",
    Storeproduct_AcceptTermsAndCondition: "Brancy-də mağaza yaratmaqla bağlı bütün qaydaları oxudum və qəbul edirəm",

    Storeproduct_notyet: "Hələ heç bir məhsul əlavə etməmisiniz!",
    Storeproduct_addnow: "İndi məhsullar əlavə et",
    Storeproduct_addexplain: "Məhsullar avtomatik olaraq Instagram səhifənizdən əlavə ediləcək.",
    Storeproduct_productlist: "Məhsul siyahısı",
    Storeproduct_search: "'PID' axtarışı 'Məhsul adı' və ya ",
    Storeproduct_importproduct: "Məhsul əlavə et",
    Storeproduct_importfrominsta: "Instagram-dan əlavə et",
    Storeproduct_newproduct: "Yeni məhsul",
    Storeproduct_addnewproduct: "Yeni məhsul əlavə et",
    Storeproduct_name: "Məhsul adı",
    Storeproduct_weight: "Çəki",
    Storeproduct_size: "Ölçü",
    Storeproduct_color: "Rəng",
    Storeproduct_stock: "Stok",
    Storeproduct_price: "Qiymət",
    Storeproduct_active: "Aktiv",
    Storeproduct_gram: "qram",
    bulkProduct: {
      title: "Seçilmiş məhsulları idarə et",
      selectedCount: "{{count}} məhsul seçilib",
      priceChange: "Qiyməti dəyiş",
      valueType: "Dəyər növü",
      amount: "Məbləğ",
      increase: "Artır",
      decrease: "Azalt",
      applyAll: "Eyni dəyişikliyi hamısına tətbiq et",
      applyIndividual: "Hər məhsulu ayrıca tənzimlə",
      allProducts: "{{count}} məhsulun hamısına tətbiq et",
      discountAllHint: "Bütün seçilmiş məhsullar üçün faiz və ya sabit endirim təyin edin.",
      priceAllHint: "Bütün məhsulların qiymətini faiz və ya sabit məbləğlə artırın və ya azaldın.",
      currentDiscount: "Cari endirim",
      saving: "Yadda saxlanılır...",
    },
    loadingmoreproducts: "Daha çox məhsul yüklənir...",
    noMoreProducts: "Daha çox məhsul yoxdur",

    storestatistics_lasttwomonth: "Son İki Ay",
    storestatistics_lastmonth: "Keçən Ay",
    storestatistics_thismonth: "Bu Ay",
    storestatistics_sales: "Satışlar",
    storestatistics_fromlast: "Keçən Aya Nisbətən %",
    storestatistics_totalSalesstatistics: "Ümumi Satış Statistikası",
    storestatistics_TotalSales: "Ümumi Satışlar",
    storestatistics_TotalIncome: "Ümumi Gəlir",
    storestatistics_totalsalesreport: "Ən Yaxşı Alıcılar",
    storestatistics_buyer: "Alıcı Məlumatları",
    storestatistics_totalPurchases: "Ümumi Alış Sayı",
    storestatistics_totalAmount: "Ümumi Alış Məbləği",
    storestatistics_lastPurchase: "Son Alış Tarixi",
    storestatistics_saleno: "Satış Nömrəsi",
    storestatistics_seller: "Satıcı",
    storestatistics_type: "Növ",
    storestatistics_status: "Status",
    storestatistics_price: "Qiymət",
    storestatistics_date: "Tarix",
    storestatistics_share: "Paylaş",
    storestatistics_couponTitle: "Endirimlər",
    storestatistics_addCoupon: "Endirim kodu əlavə et",
    storestatistics_noCoupons: "Hələ endirim kodu yaradılmayıb.",
    storestatistics_couponCode: "Endirim kodu",
    storestatistics_discountPercent: "Endirim faizi",
    storestatistics_maxUses: "Maksimum istifadə sayı",
    storestatistics_phoneNumber: "Telefon nömrəsi",
    storestatistics_maxDiscountOptional: "Maksimum endirim (istəyə bağlı)",
    storestatistics_couponExpiry: "Bitmə vaxtı (ən azı 1 saat sonrakı vaxt olmalıdır)",
    storestatistics_showInBio: "Bio-da göstər",
    storestatistics_couponDeleted: "Silinib",
    storestatistics_couponExpired: "Müddəti bitib",
    storestatistics_couponExhausted: "İstifadə limiti bitib",
    storestatistics_couponActive: "Aktiv",
    storestatistics_unlimited: "Limitsiz",
    storestatistics_couponUsage: "{{max}} istifadədən {{used}} istifadə olunub",
    storestatistics_discountValue: "{{discount}}% endirim",
    storestatistics_maxDiscountValue: "Maksimum: {{value}}",
    storestatistics_expiryValue: "Bitmə tarixi: {{date}}",
    storestatistics_private: "Private",
    storestatistics_public: "Public",

    incartcount: "Səbətdə",
    addtocart: "Səbətə əlavə et",
    AllProducts: "Bütün məhsullar",
    Storeproduct_inQueue: "Təsdiq gözləyir",
    Storeproduct_inprogress: "Emal olunur",
    Storeproduct_pickingup: "Toplanır",
    Storeproduct_sent: "Göndərildi",
    Storeproduct_delivered: "Çatdırıldı",
    Storeproduct_failed: "Uğursuz",
    Storeproduct_canceledbyuser: "Alıcı tərəfindən ləğv edildi",
    Storeproduct_canceledbyadmin: "Admin tərəfindən ləğv edildi",
    Storeproduct_returned: "Qaytarıldı",
    Storeproduct_yourcartisempty: "Səbətiniz boşdur",
    Storeproduct_noitemfounded: "Heç bir məhsul tapılmadı",
    Storeproduct_incart: "Səbət",
    ShowUnprocessedItemsOnly: "Yalnız işlənməmiş məhsullar",
    pageStatistics_fromstore: "Mağazadan",
    ordernumber: "Sifariş nömrəsi",
    order_addressSubject: "Ev, iş yeri",
    order_addressReceiver: "Bu ünvandakı alıcının adı",
    order_addressNote: "Ünvan qeydi",

    Storeorder_all: "Hamısı",
    Storeorder_ORDERID: "Sifariş nömrəsi",
    Storeorder_CUSTOMER: "Müştəri",
    Storeorder_ITEMS: "Məhsullar",
    Storeorder_ITEM: "Məhsul",
    Storeorder_PRICE: "Qiymət",
    Storeorder_OrderDATE: "Sifariş tarixi",
    copytrackingcode: "İzləmə kodunu kopyala",
    Storeorder_SentDATE: "Göndərilmə tarixi",
    Storeorder_deliverdate: "Çatdırılma tarixi",
    Storeorder_DELIVERY: "Göndərən",
    Storeorder_Destination: "Təyinat",
    Storeorder_STATUS: "Status",
    Storeorder_DETAILS: "Ətraflı",
    Storeorder_PickupRequest: "Toplanma tələbı",
    Storeorder_PrintWaybill: "Yol vərəqəsini çap et",
    Storeorder_Waybill: "Yol vərəqəsi",
    Storeorder_WaybillExplain:
      "Zəhmət olmasa toplama tələbindən əvvəl yol vərəqəsini çap edib paket üzərinə düzgün və möhkəm yapışdırın.",
    Storeorder_noneSendExplain:
      "Bu paket Brancy göndərmə sistemi ilə göndərilmədiyindən və siz şəxsi məsuliyyətinizlə göndərdiyiniz üçün bu mərhələni təsdiqləməlisiniz. Təsdiqləmə ilə alıcıya paket göndərildiyi barədə məlumat veriləcək.",
    Storeorder_ManualTrackingExplain:
      "Paket birbaşa siz tərəfindən göndərildiyi üçün izləmə kodunu aldıqdan sonra müvafiq sahəyə daxil edin və mərhələni təsdiqləyin. Bu əməl ilə Brancy izləmə kodunu və göndərmə məlumatlarını avtomatik olaraq alıcıya xəbər verəcək.",
    Storeorder_SendExplain: "Bu bölmə avtomatik olaraq yenilənəcək",

    Storeorder_requestedpickup: "Toplanma gözləyir",
    Storeorder_TrackingCode: "İzləmə kodu",
    Storeorder_IssuingTrackingCode: "İzləmə kodu hazırlanır",
    Storeorder_bymyself: "Özüm tərəfindən",
    Storeorder_Envelope: "Zərf",
    Storeorder_Invoice: "Faktura",

    Storeorder_PostMan: "Poçtçu",
    Storeorder_from: "Göndərən",
    Storeorder_currentLocation: "Cari mövqe",
    Storeorder_lastUpdateTime: "Son yenilənmə vaxtı",
    Storeorder_sender: "Göndərən",

    Storeorder_DeliveryAmount: "Göndərmə haqqı",
    Storeorder_InsuranceAmount: "Sığorta haqqı",
    Storeorder_Coupon: "Endirim kodu",
    Storeorder_RemoveCoupon: "Endirim kodunu sil",
    Storeorder_Productsinyourshoppingcart: "Səbətinizdəki məhsullar",
    Storeorder_SendtotheAddress: "Bu ünvana göndər",
    Storeorder_changeofaddress: "Ünvanı dəyiş",

    Storeorder_postparselbox: "Poçt qutusu",
    Storeorder_pocketenveloptitle: "Hər zərfdə məhsul sayı",
    Storeorder_pocketenveloptitleExplain:
      "Zəhmət olmasa bu məhsuldan hər zərfdə neçə ədəd yerləşəcəyini qeyd edin. Bu məlumat anbar, paketləmə və göndərmə hesablamalarında kömək edir.",
    Storeorder_orderDetailsStep: "Sifariş məlumatları",
    Storeorder_orderconfirmStep: "Paket ölçüsü və yol vərəqəsi",
    Storeorder_orderlist: "Sifariş siyahısı",
    Storeorder_singleorder: "Sifariş",
    Storeorder_quantityorder: "Miqdar",
    Showmore: "Daha çox göstər",
    totalprice: "Ümumi qiymət",
    note: "Qeyd",
    navbar_PaymentNumber: "Ödəniş izləmə kodu",
    Storeorder_receiver: "Alıcı",
    Storeorder_AcceptthisOrder: "Bu sifarişi təsdiqlə",
    Storeorder_ParselisConfirmed: "Daxil edilmiş məlumatların düzgün olduğunu təsdiqləyirəm",
    Storeorder_ParselisConfirmedExplain:
      "Ölçü və çəki səhv daxil edilərsə cərimə və paket geri qaytarılmasına səbəb olacaq",
    Storeorder_CancelOrder: "Sifarişi ləğv et",
    Storeorder_nextWaybill: "Davam et (Yol vərəqəsini al)",
    Storeorder_Pickedup: "Toplanıldı",
    SelectProduct: "Məhsul seç",
    SelectedPosts: "Seçilmiş postlar:",
    BacktoProductList: "Məhsul siyahısına qayıt",
    Backtocart: "Səbətə qayıt",
    product_BasicDetail: "Əsas məlumat",
    product_ProductID: "Məhsul ID",
    product_Producttitle: "Məhsul başlığı",
    product_Product: "Məhsullar",
    product_Categories: "Kateqoriyalar",
    product_MainCategory: "Əsas kateqoriya",
    product_Subcategory: "Alt kateqoriya",
    product_Subset: "Alt dəst",
    product_Group: "Qrup",
    product_Branch: "Şöbə",
    product_Subbranch: "Alt şöbə",
    product_Dependency: "Asılılıq",
    product_Brand: "Brend",
    product_instagramcaption: "Instagram caption",
    product_productDescription: "Məhsul təsviri",
    product_Informationplaceholder:
      "Buraya məhsulunuzun təsvirini yaza bilərsiniz.\n\nBu təsvir məhsulun xüsusiyyətləri, üstünlükləri, əsas detalları və ya istifadə qaydası, tərkibi kimi məlumatları qısa və aydın şəkildə əks etdirə bilər.\n\nMüştərilər bu məlumatlar sayəsində məhsulla daha yaxşı tanış olar və satış şansı artır.",
    product_General: "Ümumi",
    product_Specifications: "Xüsusiyyətlər",
    product_Information: "Təsvirlər",
    product_addNewTable: "Yeni cədvəl əlavə et",
    product_EditTable: "Cədvəli redaktə et",
    product_PreviewTable: "Cədvəl",
    product_addtable: "Cədvəl yarat",
    product_tabletitle: "Cədvəl başlığı (istəyə bağlı)",
    product_tabletitleExplain: "Məsələn: Ölçü cədvəli",
    product_tableheaderoption: "Birinci sətir başlıq olsun",
    product_AddColumn: "Bu sütunun yanına sütun əlavə et",
    product_DeleteColumn: "Bu sütunu sil",
    product_AddRow: "Bu sətirin altına sətir əlavə et",
    product_DeleteRow: "Bu sətiri sil",
    rowheader: "Başlıq",
    cell: "Hüceyrə",
    product_Media: "Məzmun",
    Nodescriptionavailable: "Təsvir mövcud deyil",
    NoSpecificationsavailable: "Xüsusiyyət mövcud deyil",
    product_Properties: "Xüsusiyyətlər",
    product_Setting: "Tənzimləmələr",
    product_productdeleted: "Məhsul silindi",
    product_SetProperties: "Xüsusiyyətləri təyin et",
    product_SetPropertiesexplain: "1-dən 3-ə qədər xüsusiyyət seçə bilərsiniz və onlardan biri xüsusi ola bilər",
    product_AddNewproperty: "Yeni xüsusiyyət əlavə et",
    product_Nopropertyisset: "Heç bir xüsusiyyət təyin edilməyib",
    product_Variation: "Model",
    product_Discount: "Endirim",
    product_PricewithDiscount: "Endirimli qiymət",
    product_AddNewVariation: "Yeni model əlavə et",
    product_Definenew: "Yeni təyin et (xüsusi)",
    product_systemlist: "Ağıllı standart siyahı",
    product_itemlist: "Element siyahısı",
    product_Available: "Mövcuddur",
    product_supplying: "Təchiz olunur",
    product_OutOfStock: "Mövcud deyil",
    product_Stoppedsale: "Satış dayandırıldı",
    product_draft: "Qaralama",
    product_Amount: "Miqdar",
    product_NUMBEROFUSES: "İstifadə sayı",
    product_UNLIMITED: "Məhdudiyyətsiz",
    product_LIMITED: "Məhdud",
    product_USINGTIMES: "İstifadə müddəti",
    product_UNLIMITEDTIME: "Müddətsiz",
    permanent: "Daimi",
    product_LIMITEDTIME: "Məhdud müddət",
    product_mediatitle: "Məhsul şəkil və videolarını idarə et",
    product_clicktoupload: "Yükləmək üçün klik et",
    product_SuggestedImages: "Tövsiyə edilən şəkillər",
    product_SuggestedImagesExplain:
      "Tövsiyə edilən şəkillərdən istifadə edərək məhsul qalereyanızı yaxşılaşdırın və ya istədiyiniz şəkilləri yükləyin",
    product_ordragdrop: "və ya sürükləyib burax",
    product_productspecifications: "Məhsul xüsusiyyətləri",
    product_choosesystemlist: "Siyahıdan seç",
    product_choosesystemlistexplain: "Lazım olan xüsusiyyətləri axtarıb seçin",
    product_Definenewexplain: "Tapmadığınız xüsusiyyət varsa, yaradın",
    product_importbatch: "Köməkçi idxal et",
    product_importbatchexplain: "Bütün xüsusiyyətləri əvvəlki məhsuldan əlavə et",
    Value: "Dəyər",
    Undefined: "Təyin edilməyib",
    product_original: "Əsas",
    product_HighCopy: "Yüksək keyfiyyətli surət",
    product_notoriginal: "Əsas deyil",
    product_Corporate: "Şirkət",
    product_Miscellaneous: "Müxtəlif",
    product_fake: "Saxta",
    tomorrow: "Sabah",
    NotSet: "Təyin edilməyib",
    Yes: "Bəli",
    No: "Xeyr",
    "Video generation request sent.": "Video yaratma sorğusu göndərildi.",
    "Image generation request sent.": "Şəkil yaratma sorğusu göndərildi.",
    ", Image generation failed.": ", şəkil yaratmaq mümkün olmadı.",
    "Create and manage AI-generated images and videos.":
      "Süni intellektlə yaradılmış şəkil və videolar yaradın və idarə edin.",
    Storeproduct_OutOfStandardSize: "Standart ölçüdən kənar",
    product_box: "Qutunun ölçüsü",
    Product_Availablity: "Mövcudluq",
    Product_maxincart: "Səbətdə maksimum",
    Product_originality: "Əslilik",
    Product_preperingforship: "Göndərilməyə hazır",
    Product_Evat: "ƏDV",
    Product_Evatcount: "Vergi miqdarı",
    Product_Guarantee: "Zəmanət",
    Product_Guaranteelength: "Zəmanət müddəti",
    Product_packageshipping: "Qablaşdırma və göndərmə",
    Product_packageshippingexplain:
      "Bu seçimi deaktiv etsəniz, məhsulun göndərilməsi və digər xidmətlər sizin öhdənizə olacaq",
    Product_titleExplain:
      "Tövsiyə olunan başlıqlar məhsul xüsusiyyətlərinə və bazardakı oxşar məhsulların orta başlıqlarına əsaslanır. Axtarışlarda və oxşar məhsullarda görünüşü artırır. (Bu başlıqlar səhv ola bilər)",
    Product_Breakable: "Qırılabilir",
    Product_Luquid: "Maye",
    Product_sack: "Çuval / Torba",
    Product_sackExplain:
      "Əgər məhsul torba, çuval, yumşaq və elastik qablaşdırmada göndərilirsə, bu seçimi seçin. Bu, qablaşdırma və göndərməni daha yaxşı idarə etməyə kömək edir.",
    Product_Productweights: "Məhsul çəkisi",
    Product_Productweightsexplian: "Məhsulun xalis çəkisi, qablaşdırma daxil deyil",
    Product_packaging: "Qablaşdırma",
    Product_packagingexplian:
      "Məhsulun içliksiz qablaşdırma çəkisi, karton, yapışqan və yol vərəqəsi daxildir və sistem hesablayır",
    Product_shippingSize: "Qablaşdırma ölçüləri",
    product_SuggestedPrice: "Məhsulun bazardakı qiymət analizi",
    product_MinimumPrice: "Minimum qiymət",
    product_AveragePrice: "Orta qiymət",
    product_MaximumPrice: "Maksimum qiymət",
    length: "Uzunluq",
    width: "En",
    height: "Hündürlük",
    Weight: "Çəki",
    finalWeight: "Son çəki",
    product_deleteproductexplain: "Bu məhsulu silməyə çalışırsınız",
    SettingGeneralSystemTitle: "Sistem",
    SettingGeneralSystemlanguage: "Dil",
    SettingGeneralSystemcalendar: "Təqvim",
    SettingGeneralSystemGregorian: "Qriqorian",
    SettingGeneralSystemshamsi: "Şəmsi",
    SettingGeneralSystemHijri: "Hicri",
    SettingGeneralSystemHindi: "Hind",
    SettingGeneralSystemStartWeek: "Həftənin başlanğıcı",
    SettingGeneralSystemsaturday: "Şənbə",
    SettingGeneralSystemmonday: "Bazar ertəsi",
    SettingGeneralSystemtuesday: " Çərşənbə axşamı",
    SettingGeneralSystemwednesday: " Çərşənbə",
    SettingGeneralSystemthursday: "Cümə axşamı",
    SettingGeneralSystemfriday: " Cümə",
    SettingGeneralSystemsunday: "Bazar",
    SettingGeneralSystemtheme: "Tema",
    SettingGeneralSystemDarkmode: "Qaranlıq rejim",
    SettingGeneralSystemlightmode: "İşıqlı rejim",
    SettingGeneralSystemPrice: "Qiymət modeli",
    SettingGeneralSystemDollar: "Dollar",
    SettingGeneralSystemeuro: "Avro",
    SettingGeneralSystempound: "Funt",
    SettingGeneralSystemrial: "Rial",
    SettingGeneralSystemtoman: "Toman",
    SettingGeneralAiModelsTitle: "AI Modelləri",
    SettingGeneralAiModelsTextModels: "Mətn Modelləri",
    SettingGeneralAiModelsVoiceModels: "Səsdən Mətnə Modellər",
    SettingGeneralAiModelsDirectVoiceSupport: "Birbaşa Səs Dəstəyi",

    SettingGeneralProfileTitle: "Profil",
    SettingGeneral_activedevice: "Aktiv cihazlar",
    SettingGeneral_leatestentery: "İstifadəçi fəaliyyət tarixi",
    SettingGeneral_cantdeletesession: "24 saatdan az olan sessiyalar silinə bilməz.",
    SettingGeneral_deletesession: "Bu sessiyanı silməyə çalışırsınız.",
    SettingGeneral_addSubAdmin: "Köməkçi admin əlavə et",
    SettingGeneral_addSubAdminExplain: "Məhdud giriş hüququ ilə köməkçi admin əlavə edin",
    SettingGeneral_addSubAdminExplain2: "Instagrama Daxil Olmadan, Məhdud və Təhlükəsiz İcazələrlə Admin Dəvət Et.",

    SettingGeneral_addSubAdmintitleExplain:
      "Yeni admin nömrəsini daxil edin, dəvət göndərilsin və təsdiqləndikdən sonra giriş aktiv olsun.",
    SettingGeneral_accesslevel: "Giriş səviyyəsi",
    SettingGeneral_partnertitle: "Əməkdaş Admin Başlığı",
    SettingGeneral_partnernumberexplain:
      "Dəvət bu nömrəyə göndəriləcək və əməkdaş admin onu öz panelində təsdiqləməlidir (dəvəti qəbul etmək üçün admin Brancy-də qeydiyyatdan keçməlidir).",
    SettingGeneral_contentTooltip: "Paylaşımlar, hekayələr, Reels, IGTV və karusellər.",
    SettingGeneral_publishTooltip: "Paylaşım, hekayə və məzmun yaratmaq. Bunun üçün məzmun girişi tələb olunur.",
    SettingGeneral_automaticsTooltip:
      "Süni intellekt, axınlar və avtomatlaşdırılmış proses və tapşırıqlar. Bunun üçün məzmun girişi tələb olunur.",
    SettingGeneral_messageTooltip: "Instagram Direct, daxili mesajlar və əlaqəli alətlər.",
    SettingGeneral_commentTooltip: "Şərhlər, cavablar və əlaqəli alətlər.",
    SettingGeneral_transactionTooltip: "Ödəniş hesabının idarəsi, əməliyyatlar, cüzdan və əlaqəli alətlər.",
    SettingGeneral_adsTooltip:
      "Təqvim, reklamverənlərin idarəsi, reklamların təsdiqi, qiymətləndirmə və əlaqəli alətlər.",
    SettingGeneral_ordersTooltip: "Məhsullar, qiymətlər, anbar ehtiyatı, sifarişlər, qaimələr və əlaqəli alətlər.",
    SettingGeneral_bioTooltip: "Bio məzmunu və düzülüşü, keçidlər və üçüncü tərəf məzmun qısayolları.",
    SettingGeneral_ticketTooltip: "CRM, sistem biletləri və dəstək.",
    SettingGeneral_productsTooltip: "Məhsul idarəetmə alətləri.",

    SettingGeneral_access: "Giriş",
    SettingGeneral_GeneralSupport: "Ümumi dəstək",
    SettingGeneral_Customerservices: "Müştəri xidməti",
    SettingGeneral_ReportBug: "Səhv hesabatı",
    SettingGeneral_Advertise: "Reklam",
    SettingGeneral_Store: "Mağaza",
    SettingGeneral_biolink: "Bio Link",
    SettingGeneral_Walletandfinance: "Cüzdan və maliyyə",
    SettingGeneral_MessageingandComment: "Mesajlar və şərhlərin idarəsi",
    SettingGeneral_Support: "Dəstək",
    SettingGeneral_Department: "Şöbə",
    SettingGeneral_Title: "Başlıq",
    SettingGeneral_Description: "Təsvir",
    SettingGeneral_Send: "Göndər",

    SharedRemainingTimeBefore: "Story üçün 24 saat qalıb",

    userpanel_market: "Bazar",
    userpanel_order: "Sifariş",
    userpanel_Messages: "Mesajlar",
    userpanel_Settings: "Parametrlər",
    userpanel_PersonalInfo: "Şəxsi məlumatlar",
    userpanel_UploadNewPicture: "Yeni şəkil yüklə",
    userpanel_Instagramid: "Instagram ID",
    userpanel_Nameandfamily: "Ad və soyad",
    userpanel_NationalCode: "Şəxsiyyət kodu",
    userpanel_BirthDay: "Doğum tarixi",
    userpanel_MobileNumber: "Mobil nömrə",
    userpanel_Email: "Email",
    userpanel_CreditNumber: "Kredit kartı nömrəsi",
    userpanel_Addresses: "Ünvanlar",
    userpanel_AddNewAddress: "Yeni ünvan əlavə et",
    userpanel_ZipCode: "Poçt kodu",
    userpanel_Address: "Ünvan",
    userpanel_EditAddress: "Ünvanı redaktə et",
    userpanel_AddNewAddressexplain: "Paketiniz bu ünvana və şəxsə çatdırılacaq",

    startbusiness: "Biznes yarat",
    AI: "Süni intellekt",
    ExtraTokens: "Əlavə tokenlər",
    TokenUsage: "Token istifadəsi",
    AdvancedAnalytics: "Təkmil analiz",
    AIResponse: "Instagram ağıllı cavab",
    CustomSupport: "Xüsusi dəstək",
    CustomDomain: "Xüsusi domen",
    WinnerPicker: "Çəkiliş",
    WinnerPickerReserve: "Ehtiyat Püşkatma",

    dataTable1_feature1: "Peşəkar post və statistika idarəsi",
    dataTable1_tooltip1:
      "Postların asan paylaşım zamanlaması. Hər post üçün ətraflı qrafik və statistika: (like, paylaşım, şərh, yadda saxla, qarşılıqlı əlaqə nisbəti, çatım, göstərilmə, baxış sayı, saxlanma, follow/unfollow, profil fəaliyyəti, istifadə olunan hashtaglar), və daha çox imkanlar...",

    dataTable1_feature2: "Yeni post yarat",
    dataTable1_tooltip2:
      "Sizin səhifəyə əsasən ən yaxşı zaman və tarix təklifi. Postların zamanlaması. Təkrar istifadə üçün hashtag-ları yadda saxla. Şərhlərə avtomatik cavab imkanı. Postu layihə olaraq yadda saxla, və s.",

    dataTable1_feature3: "Story idarəsi və detallı statistika",
    dataTable1_tooltip3:
      "Story-lərin zamanlaması. Hər story üçün tam və qrafikli statistika: (like, paylaşım, şərh, yadda saxla, qarşılıqlı əlaqə nisbəti, çatım, göstərilmə, baxış sayı, saxlanma, follow/unfollow, profil fəaliyyəti, DM, screenshot), və s...",

    dataTable1_feature4: "Yeni story yarat",
    dataTable1_tooltip4:
      "Səhifənizə əsasən ən yaxşı zaman və tarix təklifi. Story-lərin zamanlaması. Şərhlərə avtomatik cavab imkanı. Story-ni layihə olaraq yadda saxla, və s.",

    dataTable1_feature5: "Səhifə ümumi statistika",
    dataTable1_tooltip5:
      "Post və story sayı. Ən çox və ən az baxış, şərh və like əsasında sıralama. Ən yaxşı və ən pis post zamanını təyin et (qrafiklə birlikdə). Like, follow/unfollow, baxışlar, şərhlər, ghost visitor-ların tarixi. Ən yaxşı izləyicilərin müəyyən edilməsi. Əvvəlki statistika ilə müqayisə, və daha çox imkanlar...",

    dataTable1_feature6: "Hashtag idarəsi",
    dataTable1_tooltip6:
      "Limitsiz hashtag siyahısı yarat. Şəkil analizi ilə ağıllı hashtag yaradılması (AI). Səhifə analizi ilə ağıllı hashtag yaradılması (AI). Səhifədə istifadə olunan hashtag-ları görmək. Trend hashtag siyahısı (gün, həftə, ay və dil: İngilis, Fars, Ərəb və s.), və əlavə imkanlar...",

    dataTable1_feature7: "Yeni şərhlərin avtomatik like-lanması",
    dataTable1_tooltip7: "İzləyicilərin yeni şərhlərini avtomatik like et. Tarixi qrafik və siyahı şəklində göstər.",

    dataTable1_feature8: "İzləyicilər arasında təsadüfi çəkiliş",
    dataTable1_tooltip8:
      "Like və şərhlərə əsasən ən yaxşı izləyicini seç. Təsadüfi qalibi təyin et. Qalib sayını müəyyənləşdir. Nəticələr üçün story avtomatik yaradıb paylaş. Çəkiliş tarixçəsini xüsusi kodla izləyin, və digər imkanlar...",

    dataTable1_feature9: "İzləyicilər arasında xallı çəkiliş",
    dataTable1_tooltip9:
      "Çəkilişə qatılmaq üçün tapşırıqları təyin et (like, şərh, mention, follow). Qalib sayını təyin et. Çəkiliş şərtləri üçün story avtomatik yaradıb paylaş. Avtomatik xatırlatma. Nəticələr üçün story avtomatik yaradıb paylaş. Çəkiliş tarixçəsini xüsusi kodla izləyin, və daha çox imkanlar...",

    WithStrongCallToAction: "Güclü call-to-action ilə",
    WithProsAndCons: "Üstünlüklər və mənfi cəhətlər ilə",
    ForComparison: "Müqayisə üçün",
    WithKeyPoints: "Əsas məqamlar ilə",
    ForPromotionalPost: "Reklam postları üçün",
    WithDetailedExplanation: "Ətraflı izah ilə",
    PersuasiveStyle: "İnandırıcı üslub ilə",
    ForProductIntroduction: "Məhsul təqdimatı üçün",
    LongText: "Uzun mətn şəklində",
    Aipromptexplain: "Brancy, səhifənizin məzmununu analiz edir, yazı tərzinizi tanıyır; əlavə izah lazım deyil!",
    ImagineSomething: "Bir şey təsəvvür et... ✦",
    Generating: "Yaradılır...",
    AccessAndManageComments: "Şərhləri idarə etmək üçün giriş",
    AccessAndManageMessages: "Mesajları idarə etmək üçün giriş",
    AccessAndPublishContent: "Məzmun yayımlamaq üçün giriş",
    AccessAndManageInsights: "Statistika və hesabatları idarə etmək üçün giriş",
    AccessAndManageCommentsExplain:
      "Instagram şərhlərini idarə etmək üçün əvvəlcə 'İcazəni aktiv et' düyməsini basın və açılan səhifədə aktivləşdirib təsdiqləyin.",
    AccessAndManageMessagesExplain:
      "Instagram mesajlarını idarə etmək üçün əvvəlcə 'İcazəni aktiv et' düyməsini basın və açılan səhifədə aktivləşdirib təsdiqləyin.",
    AccessAndPublishContentExplain:
      "Instagram məzmununu izləmək və paylaşmaq üçün əvvəlcə 'İcazəni aktiv et' düyməsini basın və açılan səhifədə aktivləşdirib təsdiqləyin.",
    AccessAndManageInsightsExplain:
      "Instagram statistikasını idarə etmək üçün əvvəlcə 'İcazəni aktiv et' düyməsini basın və açılan səhifədə aktivləşdirib təsdiqləyin.",

    EnablePermission: "İcazəni aktiv et",
    instagramTutorialTitle: "Instagram-a qoşulma təlimatı",
    instagramTutorialStep1Title: "Addım 1: Təhlükəsiz Instagram girişi",
    instagramTutorialStep1Text:
      "'Instagram hesabını qoş' düyməsini basın, instagram.com saytına yönləndiriləcəksiniz və hesabınıza daxil olun. Bu, təhlükəsizliyi və etibarlı əlaqəni təmin edir.",
    instagramTutorialStep2Title: "Addım 2: İcazələrin təsdiqi",
    instagramTutorialStep2Text:
      "Girişdən sonra Instagram sizin ümumi məlumatlara giriş icazəsi istəyəcək. Hər şeyi təsdiqləyin ki, sistem düzgün işləsin.",
    instagramremoveStep1Title: "Addım 3: İcazələrin yoxlanması",
    instagramremoveStep1text: "Parametrlər bölməsində hesabınızdakı bütün aktiv icazələri görə bilərsiniz.",
    instagramremoveStep2Title: "Addım 4: Lazımsız icazələrin idarəsi və silinməsi",
    instagramremoveStep2text:
      "Brancy Instagram-ın rəsmi tərəfdaşıdır; buna görə başqa xidmətlərə ehtiyac yoxdur. Daha çox təhlükəsizlik üçün lazımsız icazələri silin.",

    understood: "Başa düşdüm",
    previous: "Əvvəlki",
    connectTutorial: "Qoşulma təlimatı",
    invalidcode: "Yanlış kod",
    wearesorry: "Üzr istəyirik!",
    PaymentFailed: "Ödəniş uğursuz oldu!",
    thankyou: "Təşəkkürlər!",
    Paymentsuccess: "Ödəniş uğurla tamamlandı!",
    TransactionNumber: "Əməliyyat nömrəsi:",
    TransactiontrackingNumber: "Əməliyyat izləmə nömrəsi:",
    InvoiceNumber: "Faktura nömrəsi:",

    mainSubscriptionPlan: "Əsas abunə",
    Tokens: "Token",
    tokenExplain:
      "Token AI xidmətlərinin istifadə vahididir; təxminən 100 sorğunun işlənməsi üçün 1000 token tələb olunur.",
    ReserveToken: "Ehtiyat Token",
    packageTokenExplain:
      "Paketlə birlikdə aktivləşən və paket müddəti bitənə qədər istifadə oluna bilən pulsuz tokenlərdir; sonra etibarsız olur.",
    ReserveTokenExplain: "Zaman keçdikcə etibarlılığını itirməyən alınmış ehtiyat tokenlərdir.",

    pageTools_Months: "ay",
    subscriptionExpired: "Abunəniz bitdi, yeniləyin",
    subscriptionExpireSoon: "Abunəniz tezliklə bitəcək",
    subscriptionManagement: "Abunə idarəsi",
    subscription: "Abunə",
    AIAssisment: "AI köməkçisi",
    timeperiod: "Qalan zaman aralığı",
    domain: "Domen",
    winnerpickerexpired: "Artıq çəkiliş keçirə bilməzsiniz, zəhmət olmasa balansınızı doldurun",
    winnerpickerexpiresoon: "Çəkiliş sayınız bitmək üzrədir",
    Aiexpired: "Artıq Süni İntellektdən istifadə edə bilməzsiniz, zəhmət olmasa balansınızı artırın.",
    Aiexpiresoon: "Süni İntellekt tokenləriniz bitmək üzrədir.",

    followercount: "İzləyici sayı",
    yourCurrentSubscription: "Hazırki abunəniz",
    noItemsAvailableContactSupport: "Bu bölmə hazırda əlçatan deyil. Sifariş üçün Brancy dəstəyinə tiket göndərin.",

    // #region AIFlow Section
    AIAssismentexplain:
      "Brancy süni intellekt köməkçisi ilə Instagram mesajları və comment-lər üçün avtomatik cavab verən ağıllı danışıq flow-ları yarada bilərsiniz",
    livetest: "Canlı Test",
    testlab: "Test Laboratoriyası",
    promptmode: "Prompt Rejimi",
    promptanalysis: "Prompt Analizi",
    promptanalysisExplain:
      "Promptunuzu ətraflı daxil edin; Brancy onu xarakterinizə, tonunuza və qarşılıqlı əlaqə üslubunuza əsasən təhlil edəcək.",
    promptanalysisplaceholder: "Prompt analizi üçün ən azı 20 simvol daxil edin",
    reanalyze: "Yenidən Analiz Et",
    shouldFollowerexplain: "Cavablar yalnız sizi follow edən istifadəçilərə göndərilir",
    RenewForThread: "Danışıq Flow-unu Yenilə",
    RenewForThreadexplain: "Hər danışıqda, istifadəçi yeni mesaj göndərərsə, danışıq flow-u əvvəldən başlayır",
    prompt: "Prompt",
    promptanalysisexplain: "Brancy Prompt-unuzu analiz edir və ağıllı cavablar üçün ən yaxşı ayarları təklif edir",

    autosave: "Avtomatik Yadda Saxla",
    Restrictorzoom: "Zoom Məhdudiyyəti",
    snapGrid: "Şəbəkəyə Düzülmə",
    PanningBoundary: "Hərəkət Sərhədi",
    Flow: "Axın (Flow)",
    flowtitle: "Axın Başlığı",
    AIFlow_input: "Giriş",
    AIFlow_input_message_block: "İstifadəçi Giriş Mesajı",
    AIFlow_output: "Çıxış",
    AIFlow_output_title: "Çıxış Başlığı",
    AIFlow_text: "Mətn",
    AIFlow_item_text: "Element",
    AIFlow_block_title_required: "Zəhmət olmasa blok başlığını daxil edin (məcburi)",
    AIFlow_item_title: "Element Başlığı:",
    AIFlow_show_graph: "Axın Qrafikini Göstər",
    AIFlow_connect_post: "Paylaşıma qoş",
    AIFlow_connect_post_access:
      "Instagram şərh və mesaj icazələri, həmçinin Avtomatlaşdırma və Şərh girişləri tələb olunur.",
    AIFlow_connect_post_save_first: "Paylaşıma qoşmazdan əvvəl bu axını yadda saxlayın.",
    AIFlow_connect_post_confirm:
      "Bu axın paylaşımın cari avtomatik cavabını əvəz edir və aktivləşdirilir. Açar sözlər və uyğunlaşdırma ayarları saxlanılır; açar söz yoxdursa, axın bütün şərhlərə cavab verir.",
    AIFlow_connect_post_resume:
      "Axın bağlantısı yadda saxlanıldı, lakin aktivləşdirmə alınmadı. Yenidən aktivləşdirməyə cəhd edin.",
    AIFlow_connect_post_incompatible:
      "Bu axın şərhlərə şəxsi cavab verməklə uyğun deyil. Qoşmazdan əvvəl redaktə edib yadda saxlayın.",
    AIFlow_retry: "Yenidən cəhd et",
    AIPrompt_connect_post_access: "Instagram şərh icazəsi, həmçinin Avtomatlaşdırma və Şərh girişləri tələb olunur.",
    AIPrompt_connect_post_confirm:
      "Bu süni intellekt paylaşımın cari avtomatik cavabını əvəz edir və aktivləşdirilir. Açar sözlər və uyğunlaşdırma ayarları saxlanılır; açar söz yoxdursa, bütün şərhlər cavablandırılır. Şəxsi göndəriş yalnız mesaj icazəsi olduqda saxlanılır; əks halda cavablar şərh kimi göndərilir.",
    AIPrompt_connect_post_resume:
      "Süni intellekt bağlantısı yadda saxlanıldı, lakin aktivləşdirmə alınmadı. Yenidən aktivləşdirməyə cəhd edin.",
    messagesetting_PhoneNumbers: "Telefon nömrələri",
    messagesetting_PhoneNumbersExplain: "Axınlar vasitəsilə müştərilərinizdən toplanan telefon nömrələri",
    messagesetting_PhoneNumbersEmpty: "Hələ heç bir telefon nömrəsi toplanmayıb",
    AIFlow_item_subtitle: "Element Alt Başlığı:",
    AIFlow_option_title: "Seçim Başlığı",
    AIFlow_option_default: "Seçim",
    AIFlow_quick_reply: "Sürətli Cavab",
    AIFlow_quick_reply_validation_error: "Bütün sürətli cavab sahələri doldurulmalıdır!",
    AIFlow_quick_reply_block_title_empty: "Blok {label}\n Başlıq daxil edilməyib",
    AIFlow_quick_reply_option_title_empty: "Blok {label}\n Seçim {index} başlıqsızdır",
    AIFlow_delete_image: "🗑️ Şəkli Sil",
    AIFlow_delete_image_button_text: "🗑️ Şəkli Sil",
    AIFlow_delete_all_block: "🗑️ Bloku Sil",
    AIFlow_delete_all_blocks: "Bütün Axını Sil",
    AIFlow_save_all_blocks: "Bütün Axını Yadda Saxla",
    AIFlow_delete: "🗑️ Sil",
    AIFlow_upload_image: "📷 Şəkil Yüklə",
    AIFlow_image_uploaded: "Şəkil Yükləndi ✓",
    AIFlow_add_image: "📷 Şəkil Əlavə Et",
    AIFlow_voice_recorded: "🎵 Yazılmış Səs",
    AIFlow_record_voice: "🎤 Səs Yaz",
    AIFlow_record_voice_confirm: "Yazmağa hazırsınız? (ən azı 3 saniyə)",
    AIFlow_play_voice: "▶️ Səsi Dinlə",
    AIFlow_add_output: "Yeni Çıxış Əlavə Et",
    AIFlow_add_subtitle: "➕ Alt Başlıq Əlavə Et",
    AIFlow_subtitle_input: "Zəhmət olmasa alt başlığı daxil edin:",
    AIFlow_link: "Keçid:",
    AIFlow_general_block: "Ümumi Blok",
    AIFlow_text_block: "Mətn Bloku",
    AIFlow_image_block: "Şəkil Bloku",
    AIFlow_voice_block: "Səs Bloku",
    AIFlow_quick_reply_block: "Sürətli Cavab Bloku",
    AIFlow_weblink_block: "Keçid Bloku",
    AIFlow_add_text_block: " Mətn Bloku Əlavə Et",
    AIFlow_add_image_block: " Şəkil Bloku Əlavə Et",
    AIFlow_add_voice_block: " Səs Bloku Əlavə Et",
    AIFlow_add_quick_reply_block: " Sürətli Cavab Əlavə Et",
    AIFlow_add_general_block: " Ümumi Blok Əlavə Et",
    AIFlow_add_weblink_block: " Keçid Əlavə Et",
    AIFlow_generic_block: "Ümumi Alt Blok",
    AutoLayout_block: "Avtomatik Düzülüş",
    AIFlow_live_test_block: "Axının Canlı Testi",
    AIFlow_Deleteallblocks_alert: "Bütün axını silmək istədiyinizə əminsiniz?",
    AIFlow_add_output_error_alert: "Çıxış əlavə edilərkən xəta: {error}",
    AIFlow_unknown_block_type_alert: "Naməlum blok növü:",
    AIFlow_multiple_flow_for_private_reply_alert: "Şəxsi cavab üçün bir neçə axın tapıldı",
    AIFlow_empty_title_for_flow_alert: "Axının başlığı boşdur",
    AIFlow_weblink_has_hyphen_alert: "Blok {label}\n Keçiddə '-' olmamalıdır",
    AIFlow_min_output_required: "Ən azı bir çıxış qalmalıdır",
    AIFlow_max_quick_reply_outputs: "Maksimum 15 çıxış icazə verilir",
    AIFlow_max_generic_outputs: "Maksimum 10 çıxış icazə verilir",
    AIFlow_generic_item_connection_only: "Bu blok yalnız ümumi bloklara qoşulur",
    AIFlow_weblink_generic_item_only: "Bu blok yalnız ümumi alt elementlərə qoşulur",
    AIFlow_voice_record_failed: "❌ Səs yazısı uğursuz oldu (heç bir səs yazılmadı)",
    AIFlow_voice_upload_failed: "✅ Yazı uğurlu oldu amma yükləmə baş tutmadı",
    AIFlow_voice_record_empty: "❌ Səs yazısı boşdur",
    AIFlow_voice_record_start: "🎙️ Yazı başladı...",
    AIFlow_session_invalid: "İstifadəçi sessiyası etibarsızdır, zəhmət olmasa yenidən daxil olun",
    AIFlow_no_on_message_node: "Başlanğıc mesaj düyünü tapılmadı!",
    AIFlow_validation_warning: "⚠️ Doğrulama Xəbərdarlığı",
    AIFlow_generic_item_validation_error: "Zəhmət olmasa ümumi blokun bütün sahələrini doldurun",
    AIFlow_weblink_validation_error_alert: "Bütün keçid sahələri doldurulmalıdır",
    AIFlow_generic_item_title_empty_alert: "Element {label}\n Başlıq boşdur",
    AIFlow_generic_item_output_title_empty_alert: "Element {label}\n Çıxış {index} başlıqsızdır",
    AIFlow_weblink_empty_alert: "Blok {label}\n Keçid boşdur",

    AIFlow_weblink_incomplete_alert: "Blok {label}\n Keçid natamamdır (yalnız protokol daxil edilib)",
    AIFlow_weblink_invalid_format_alert: "Blok {label}\n Keçid formatı yanlışdır",
    AIFlow_weblink_non_english_alert: "Blok {label}\n Keçid İngiliscə olmalıdır",
    AIFlow_editor_init_error: "❌ Redaktorun işə salınmasında xəta",
    AIFlow_unexpected_error: "⚠️ Gözlənilməz xəta baş verdi",
    AIFlow_server_error: "❌ Server xətası",
    AIFlow_connection_error: "⚠️ Bağlantı problemi",
    AIFlow_generic_connection_error: "Ümumi blokun alt elementə qoşulmasında xəta",
    AIFlow_weblink_connection_error: "Düyümün qoşulmasında xəta",
    AIFlow_voice_fetch_error: "Səs faylı alınmadı",
    AIFlow_voice_record_error: "Səs yazma xətası",
    AIFlow_voice_play_error: "Səsi oynatma xətası",
    AIFlow_media_recorder_error: "Media qeyd cihazında xəta",
    AIFlow_upload_error: "❌ Yükləmə xətası",
    AIFlow_add_output_error: "❌ Çıxış əlavə xətası",
    AIFlow_json_parse_error: "JSON işləmə xətası",
    AIFlow_position_error: "Başlanğıc mesaj mövqeyini işləməkdə xəta",
    AIFlow_node_remove_error: "Düyümü silməkdə xəta",
    AIFlow_node_connection_warning: "Qoşulma mümkün deyil:",
    AIFlow_unknown_value_type: "Düymədə naməlum dəyər növü",
    AIFlow_success: "✅ Əməliyyat uğurla başa çatdı",
    AIFlow_subtitle_success: "✓ Alt başlıq uğurla əlavə edildi",
    AI_live_test: "AI əmrlərinizi real vaxtda sınaqdan keçirin",

    New_Flow_input_message_block: "İstifadəçi Giriş Mesajı",
    New_Flow_general_block: "Ümumi Blok",
    New_Flow_text_block: "Mətn Bloku",
    New_Flow_voice_block: "Səs Bloku",
    New_Flow_imageorvideo_block: "Şəkil / Video Bloku",
    New_Flow_quick_reply_block: "Sürətli Cavab Bloku",
    New_Flow_weblink_block: "Link Bloku",
    New_Flow_phonenumbergrabber_block: "Telefon nömrəsi toplayıcı",
    New_Flow_ai_block: "Süni intellekt",
    New_Flow_ai_select: "Süni intellekt seçin",
    New_Flow_ai_livetest: "Süni intellekt bloku burada icra olunur",
    New_Flow_masterflow_block: "Alt axın",
    New_Flow_masterflow_select: "Axın seçin",
    New_Flow_masterflow_livetest: "Seçilmiş alt axın buradan davam edir",
    New_Flow_Tutorials_buttongroup_title: "Düymə Qrupu Bloku",
    New_Flow_Tutorials_buttongroup_description:
      "Bu blok maksimum üç düyməli mesaj göndərir; hər düymənin ayrı çıxışı var, blokun isə axını davam etdirən adi çıxışı da var.",
    New_Flow_Tutorials_buttongroup_usageType:
      "Bir neçə aydın seçim təqdim etmək, menyu, sürətli naviqasiya və istifadəçini linkə və ya növbəti addıma yönləndirmək üçün uyğundur.",
    New_Flow_Tutorials_buttongroup_feature_1: "640 simvola qədər mesaj mətni",
    New_Flow_Tutorials_buttongroup_feature_2: "3 düyməyə qədər, hər birinin ayrı çıxışı var",
    New_Flow_Tutorials_buttongroup_feature_3: "Adi çıxış düymə klikini gözləmədən axını davam etdirir",
    New_Flow_Tutorials_buttongroup_tip_1: "Mesajı və düymə başlıqlarını aydın və qısa yazın",
    New_Flow_Tutorials_buttongroup_tip_2: "Hər düyməni seçimindən sonra gələcək bloka qoşun",
    New_Flow_Tutorials_buttongroup_tip_3: "Veb Link blokuna yalnız düymə çıxışları qoşula bilər",
    New_Flow_Tutorials_buttongroup_limitation_1: "Maksimum 3 düymə",
    New_Flow_Tutorials_buttongroup_limitation_2: "Mesaj mətni: maksimum 640 simvol",
    New_Flow_Tutorials_buttongroup_limitation_3: "Düymə başlığı: maksimum 20 simvol",
    New_Flow_Tutorials_buttongroup_limitation_4: "Son düymənin silinməsi bloku silir",
    New_Flow_Tutorials_ai_title: "Süni İntellekt Bloku",
    New_Flow_Tutorials_ai_description:
      "Bu blok söhbəti sizin yaratdığınız süni intellektlərdən birinə həvalə edir; süni intellekti blokun daxilindəki siyahıdan seçin.",
    New_Flow_Tutorials_ai_usageType:
      "Müştərilərin açıq suallarına, dəstəyə, məsləhətləşməyə və satış söhbətlərinə avtomatik cavab vermək üçün uyğundur.",
    New_Flow_Tutorials_ai_feature_1: "Yaratdığınız bütün süni intellektləri seçmək üçün siyahı şəklində göstərir",
    New_Flow_Tutorials_ai_feature_2: "Seçilmiş süni intellekt axının bu nöqtəsindən söhbəti öz üzərinə götürür",
    New_Flow_Tutorials_ai_tip_1: "Siyahıda görünməsi üçün əvvəlcə süni intellektinizi yaradın və tənzimləyin",
    New_Flow_Tutorials_ai_tip_2: "Söhbəti təqdim edən mesaj blokundan sonra yerləşdirin",
    New_Flow_Tutorials_ai_limitation_1: "Yalnız girişi var, çıxışı yoxdur, buna görə axını bitirir",
    New_Flow_Tutorials_ai_limitation_2: "Hər blokda yalnız bir süni intellekt seçilə bilər",
    New_Flow_Tutorials_ai_limitation_3: "Axının ilk bloku ola bilməz",
    New_Flow_Tutorials_masterflow_title: "Alt Axın Bloku",
    New_Flow_Tutorials_masterflow_description:
      "İstifadəçi düyməyə toxunduqda söhbəti əvvəlcədən yaratdığınız başqa axına yönləndirir.",
    New_Flow_Tutorials_masterflow_usageType: "Mövcud axını düymənin davamı kimi təkrar istifadə edin",
    New_Flow_Tutorials_masterflow_feature_1: "Yaratdığınız bütün axınları siyahılayır ki, birini seçəsiniz",
    New_Flow_Tutorials_masterflow_feature_2: "Seçilmiş axın söhbəti bu nöqtədən davam etdirir",
    New_Flow_Tutorials_masterflow_tip_1: "Siyahıda görünməsi üçün əvvəlcə hədəf axını yaradıb yadda saxlayın",
    New_Flow_Tutorials_masterflow_tip_2: "Axınlar arasında ümumi yollar (dəstək və ya qiymətlər kimi) üçün istifadə edin",
    New_Flow_Tutorials_masterflow_limitation_1: "Yalnız girişi var, çıxışı yoxdur, buna görə bu axını bitirir",
    New_Flow_Tutorials_masterflow_limitation_2: "Yalnız düymələrə qoşula bilər, adi çıxışlara yox",
    New_Flow_Tutorials_masterflow_limitation_3: "Redaktə etdiyiniz axın seçilə bilməz",
    New_Flow_Tutorials_masterflow_connection_1: "Sürətli cavab blokunun düymələri",
    New_Flow_Tutorials_masterflow_connection_2: "Düymə qrupu blokunun düymələri",
    New_Flow_Tutorials_masterflow_connection_3: "Qalereya alt blokunun düymələri",
    New_Flow_generic_block: "Qalereya Bloku (Karusel)",
    New_Flow_add_general_block: "Qalereya Bloku Əlavə Et",
    New_Flow_add_text_block: "Mətn Bloku Əlavə Et",
    New_Flow_add_image_block: "Şəkil Bloku Əlavə Et",
    New_Flow_add_voice_block: "Səs Bloku Əlavə Et",
    New_Flow_add_quick_reply_block: "Sürətli Cavab Əlavə Et",
    New_Flow_add_weblink_block: "Link Əlavə Et",
    New_Flow_upload_imageorvideo: "Şəkil və ya Video Yüklə",
    New_Flow_upload_image: "Şəkil Yüklə",
    New_Flow_upload_unsupported_media: "Dəstəklənməyən media formatı",
    New_Flow_uploadmaxsizeexceeded: "Fayl ölçüsü 50MB-dan çox olmamalıdır",
    New_Flow_uploadfilefailed: "Fayl yüklənmədi, yenidən cəhd edin",
    New_Flow_unsupportedbrowser: "Brauzeriniz video oynatmağı dəstəkləmir",
    New_Flow_micphoneaccessdenied: "Mikrofon icazəsini aktiv edin",
    New_Flow_upload_audio: "Audio Faylı Yüklə",
    New_Flow_record_voice: "Səs Yaz",
    New_Flow_stop_record_voice: "Yazını Dayandır",
    New_Flow_areyoureadytorecord: "Yazmağa hazırsınız?",
    New_Flow_voice_recording_started: "Səs yazılır...",
    New_Flow_add_generic_sub_block: "Alt Blok Əlavə Et",
    New_Flow_generic_sub: "Alt Blok",
    New_Flow_add_button: "Düymə Əlavə Et",
    New_Flow_quick_reply_title_placeholder: "Sürətli Cavab Seçimi Başlığı",
    New_Flow_buttongroup_block: "Düymə Qrupu Bloku",
    New_Flow_add_buttongroup_block: "Düymə Qrupu Əlavə Et",
    New_Flow_buttongroup_title_placeholder: "Düymə Qrupu Mesaj Mətni",
    New_Flow_imagegallery_block: "Şəkil Qalereyası Bloku",
    New_Flow_add_imagegallery_block: "Şəkil Qalereyası Əlavə Et",
    New_Flow_imagegallery_max_reached: "Bu bloka ən çox {{max}} şəkil əlavə edə bilərsiniz",
    New_Flow_Tutorials_imagegallery_title: "Şəkil Qalereyası Bloku",
    New_Flow_Tutorials_imagegallery_description:
      "Bu blok istifadəçilərə birbaşa mesajla bir neçə şəkil (ən çox {{max}}) yükləmək və göndərmək üçün istifadə olunur.",
    New_Flow_Tutorials_imagegallery_usageType:
      "Bir neçə məhsulu, foto albomlarını, əvvəl və sonra şəkillərini və şəkil kolleksiyalarını nümayiş etdirmək üçün uyğundur.",
    New_Flow_Tutorials_imagegallery_feature_1: "Bir blokda ən çox {{max}} şəkil qəbul edir",
    New_Flow_Tutorials_imagegallery_limitation_1:
      "Hər blokda maksimum {{max}} şəkil (bu limit gələcəkdə artırıla bilər)",
    New_Flow_message_title: "Mesaj Başlığı",
    New_Flow_message_description: "Mesaj Açıqlaması",
    New_Flow_live_test_block: "Canlı Axın Testi",
    New_Flow_delete_all_blocks: "Bütün Axını Sil",
    New_Flow_shortcuts_explain: "İş axınlarını idarə etmədə sürəti və nəzarəti artıran klaviatura qısayolları.",
    New_Flow_Tutorials_Not_Available: "Təlim mövcud deyil",
    New_Flow_Tutorials_Not_Available_Description: "Bu düyün üçün hər hansı təlim mövcud deyil.",
    New_Flow_Tutorials_Usage_Type: "İstifadə Növü",
    New_Flow_Tutorials_Features: "Xüsusiyyətlər",
    New_Flow_Tutorials_Tips: "Praktik Məsləhətlər",
    New_Flow_Tutorials_Limitations: "Məhdudiyyətlər",
    New_Flow_Tutorials_Connections: "Bağlantılar",
    New_Flow_unsavedChanges: "Yadda saxlanmamış dəyişiklikləriniz var",
    New_Flow_addedNodes: "Əlavə olunan nodlar",
    New_Flow_removedNodes: "Silinmiş nodlar",
    New_Flow_modifiedNodes: "Dəyişdirilmiş nodlar",
    New_Flow_invalidFlow_explain:
      "Flow etibarlı deyil. Xahiş olunur, yadda saxlamadan əvvəl nodları səhvlər üçün yoxlayın",
    sendsms: "İstifadəçiyə SMS göndər",
    sendtotelegram: "İstifadəçini Telegram-a yönləndir",
    senderusername: "İstifadəçinin adını səsləndir",
    addtools: "Alət əlavə et",
    generatebyai: "AI ilə yarat",

    //tutorials

    New_Flow_Tutorials_onmessage_title: "Axışınızın Başlanğıc Nöqtəsi",
    New_Flow_Tutorials_onmessage_description:
      "Bu blok axışınızın başlanğıc nöqtəsidir. İstifadəçi Instagram direktinizə mesaj göndərdikdə, bu blok aktivləşir və axış başlayır. Hər avtomatlaşdırmada həmişə ilk blokdur və silinə bilməz.",
    New_Flow_Tutorials_onmessage_feature_1: "Növbəti bloka qoşulmaq üçün tək çıxış",
    New_Flow_Tutorials_onmessage_tip_1:
      "Bu blokun çıxışını hər hansı digər bloka qoşun. İstifadəçi hər hansı mesaj göndərdikdə (mətn, şəkil, video, səs və s.) axış başlayır",
    New_Flow_Tutorials_onmessage_connection_1: "Aşağıdakı bloklara qoşula bilər:",
    New_Flow_Tutorials_onmessage_connection_2: "❌ Veb Link Bloku",
    New_Flow_Tutorials_onmessage_connection_3: "✅ Səsli Mesaj Bloku",
    New_Flow_Tutorials_onmessage_connection_4: "✅ Mətn Mesajı Bloku",
    New_Flow_Tutorials_onmessage_connection_5: "✅ Tez Cavab Bloku",
    New_Flow_Tutorials_onmessage_connection_6: "✅ Şəkil & Video Bloku",
    New_Flow_Tutorials_onmessage_connection_7: "✅ Qalereya Bloku",

    New_Flow_Tutorials_text_title: "Mətn Mesajı Bloku",
    New_Flow_Tutorials_text_description: "Bu blok istifadəçilərə mətn mesajları göndərmək üçün istifadə olunur.",
    New_Flow_Tutorials_text_usageType:
      "Xoş gəlmisiniz mesajları, məhsul açıqlamaları, FAQ, bildirişlər və istifadəçi rəhbərliyi üçün uyğundur.",
    New_Flow_Tutorials_text_feature_1: "Bütün dilləri dəstəkləyir",
    New_Flow_Tutorials_text_feature_2: "Emoji və xüsusi simvollar istifadə etmək imkanı",
    New_Flow_Tutorials_text_tip_1: "Mesajları qısa və aydın yazın",
    New_Flow_Tutorials_text_tip_2: "Emojiləri ölçülü istifadə edin",
    New_Flow_Tutorials_text_tip_3: "Uzun mətni bir neçə hissəyə bölün",
    New_Flow_Tutorials_text_tip_4: "Dostyana və səmimi ton saxlayın",
    New_Flow_Tutorials_text_tip_5: "Uyğun paraqraf formatlaması istifadə edin",
    New_Flow_Tutorials_text_limitation_1: "Maksimum 2200 simvol",
    New_Flow_Tutorials_text_limitation_2: "Yalnız mətn (fayl və media yoxdur)",
    New_Flow_Tutorials_text_limitation_3: "Formatlama yoxdur (Bold, Italic)",
    New_Flow_Tutorials_text_connection_1: "✅ Mesaj Giriş Bloku",
    New_Flow_Tutorials_text_connection_2: "❌ Veb Link Bloku",
    New_Flow_Tutorials_text_connection_3: "✅ Səsli Mesaj Bloku",
    New_Flow_Tutorials_text_connection_4: "✅ Mətn Mesajı Bloku",
    New_Flow_Tutorials_text_connection_5: "✅ Tez Cavab Bloku",
    New_Flow_Tutorials_text_connection_6: "✅ Şəkil & Video Bloku",
    New_Flow_Tutorials_text_connection_7: "❌ Qalereya Bloku",
    New_Flow_Tutorials_text_connection_8: "✅ Qalereya Alt-Bloqu",

    New_Flow_Tutorials_image_title: "Şəkil & Video Bloku",
    New_Flow_Tutorials_image_description:
      "Bu blok istifadəçilərə direct vasitəsilə şəkil və video göndərmək üçün istifadə olunur.",
    New_Flow_Tutorials_image_usageType:
      "Məhsul təqdimatı, şəkil qalereyaları, loqolar, reklam bannerləri, tədris və təqdimat videoları üçün uyğundur.",
    New_Flow_Tutorials_image_feature_1: "Şəkil dəstəyi: JPEG, PNG, GIF, WebP, SVG",
    New_Flow_Tutorials_image_feature_2: "Video dəstəyi: MP4, WebM, OGG, MOV, AVI, MKV",
    New_Flow_Tutorials_image_feature_3: "Fayl növünü avtomatik aşkar etmə",
    New_Flow_Tutorials_image_tip_1: "Yüksək keyfiyyətli şəkillər istifadə edin",
    New_Flow_Tutorials_image_tip_2: "Böyük faylları yükləməzdən əvvəl sıxın",
    New_Flow_Tutorials_image_tip_3: "Standart ölçülər: 1080×1080 və ya 1080×1350",
    New_Flow_Tutorials_image_tip_4: "Videoları 30 saniyədən aşağı saxlayın",
    New_Flow_Tutorials_image_tip_5: "Normal şəkillər üçün JPEG, şəffaf fon üçün PNG",
    New_Flow_Tutorials_image_limitation_1: "Maksimum həcm: 50 MB",
    New_Flow_Tutorials_image_limitation_2: "Hər blokda bir fayl",
    New_Flow_Tutorials_image_limitation_3: "Qeyri-adi formatlar dəstəklənməyə bilər",
    New_Flow_Tutorials_image_connection_1: "✅ Mesaj Giriş Bloku",
    New_Flow_Tutorials_image_connection_2: "❌ Veb Link Bloku",
    New_Flow_Tutorials_image_connection_3: "✅ Səsli Mesaj Bloku",
    New_Flow_Tutorials_image_connection_4: "✅ Mətn Mesaj Bloku",
    New_Flow_Tutorials_image_connection_5: "✅ Sürətli Cavab Bloku",
    New_Flow_Tutorials_image_connection_6: "✅ Şəkil & Video Bloku",
    New_Flow_Tutorials_image_connection_7: "❌ Qalereya Bloku",
    New_Flow_Tutorials_image_connection_8: "✅ Alt Qalereya Bloku",
    invalidFlowDetected: "Yanlış axın aşkarlandı! Bəzi blokların girişi yoxdur və ya mesaj bloku təkdir.",

    New_Flow_Tutorials_voice_title: "Səsli Mesaj Bloku",
    New_Flow_Tutorials_voice_description:
      "Bu blok istifadəçilərə səs faylları yükləmək və ya canlı səs göndərmək üçün istifadə olunur.",
    New_Flow_Tutorials_voice_usageType:
      "Şəxsi səsli mesajlar, audio dərslər, qısa podkastlar və səsli təlimatlar üçün uyğundur.",
    New_Flow_Tutorials_voice_feature_1: "Dəstəklənən formatlar: MP3, M4A, WAV, OGG, AAC",
    New_Flow_Tutorials_voice_feature_2: "Mikrofondan birbaşa qeyd",
    New_Flow_Tutorials_voice_feature_3: "Əvvəlcədən yazılmış səs faylını yükləmək",
    New_Flow_Tutorials_voice_tip_1: "Sakit mühitdə qeyd edin",
    New_Flow_Tutorials_voice_tip_2: "Qısa mesajlar (1 dəqiqədən az) daha yaxşıdır",
    New_Flow_Tutorials_voice_tip_3: "Göndərməzdən əvvəl səs keyfiyyətini yoxlayın",
    New_Flow_Tutorials_voice_tip_4: "Qeyd etmədən əvvəl mətninizi hazırlayın",
    New_Flow_Tutorials_voice_limitation_1: "Maksimum həcm: 50 MB",
    New_Flow_Tutorials_voice_limitation_2: "Qeyd üçün mikrofon girişi tələb olunur",
    New_Flow_Tutorials_voice_limitation_3: "Hər blokda bir fayl",
    New_Flow_Tutorials_voice_connection_1: "✅ Mesaj Giriş Bloku",
    New_Flow_Tutorials_voice_connection_2: "❌ Veb Link Bloku",
    New_Flow_Tutorials_voice_connection_3: "✅ Səsli Mesaj Bloku",
    New_Flow_Tutorials_voice_connection_4: "✅ Mətn Mesaj Bloku",
    New_Flow_Tutorials_voice_connection_5: "✅ Sürətli Cavab Bloku",
    New_Flow_Tutorials_voice_connection_6: "✅ Şəkil & Video Bloku",
    New_Flow_Tutorials_voice_connection_7: "❌ Qalereya Bloku",
    New_Flow_Tutorials_voice_connection_8: "✅ Alt Qalereya Bloku",

    New_Flow_Tutorials_quickreply_title: "Sürətli Cavab Bloku",
    New_Flow_Tutorials_quickreply_description:
      "Bu blok, istifadəçilər üçün bir dəfəlik seçilə bilən Sürətli Cavab düymələri yaratmaq üçün istifadə olunur, hər düymə istifadəçini müəyyən bir axın yolu üzrə yönləndirir.",
    New_Flow_Tutorials_quickreply_usageType:
      "Seçim menyuları, məhsul kateqoriyaları, çoxseçimli suallar, sorğular və axtarış filtrləri üçün uyğundur.",
    New_Flow_Tutorials_quickreply_feature_1: "Hər blokda maksimum 10 düymə",
    New_Flow_Tutorials_quickreply_feature_2: "Hər düymənin müstəqil çıxışı var",
    New_Flow_Tutorials_quickreply_feature_3: "Düymələri silmək və redaktə etmək imkanı",
    New_Flow_Tutorials_quickreply_tip_1: "Düymə mətnlərini aydın və praktik yazın",
    New_Flow_Tutorials_quickreply_tip_2: "Daha yaxşı təcrübə üçün 3–5 düymə",
    New_Flow_Tutorials_quickreply_tip_3: "Etiketləri qısa saxlayın (20 simvoldan az)",
    New_Flow_Tutorials_quickreply_tip_4: "Rəhbərlik üçün başlıq sahəsindən istifadə edin",
    New_Flow_Tutorials_quickreply_tip_5: "Düymələri əhəmiyyətinə görə prioritetləşdirin",
    New_Flow_Tutorials_quickreply_limitation_1: "Maksimum 10 düymə",
    New_Flow_Tutorials_quickreply_limitation_2: "Düymə başlığı: Maks 40 simvol",
    New_Flow_Tutorials_quickreply_limitation_3: "Təsvir: Maks 140 simvol",
    New_Flow_Tutorials_quickreply_limitation_4: "Ən azı bir düymə tələb olunur",
    New_Flow_Tutorials_quickreply_connection_1: "✅ Mesaj Giriş Bloku",
    New_Flow_Tutorials_quickreply_connection_2: "❌ Veb Link Bloku",
    New_Flow_Tutorials_quickreply_connection_3: "✅ Səsli Mesaj Bloku",
    New_Flow_Tutorials_quickreply_connection_4: "✅ Mətn Mesaj Bloku",
    New_Flow_Tutorials_quickreply_connection_5: "✅ Sürətli Cavab Bloku",
    New_Flow_Tutorials_quickreply_connection_6: "✅ Şəkil & Video Bloku",
    New_Flow_Tutorials_quickreply_connection_7: "❌ Qalereya Bloku",
    New_Flow_Tutorials_quickreply_connection_8: "✅ Alt-Qalereya Bloku",

    New_Flow_Tutorials_generic_title: "Qalereya (Karusel) Bloku",
    New_Flow_Tutorials_generic_description: "Elementlərin üfüqi sürüşdürülə bilən qalereyasını (karusel) yaradın",
    New_Flow_Tutorials_generic_usageType:
      "Məhsulları, xidmət menyularını, kateqoriyaları, komanda təqdimatını, portfeli və seçim müqayisələrini göstərmək üçün uyğundur.",
    New_Flow_Tutorials_generic_tip_1: "Eyni ölçüdə şəkillər istifadə edin (məsələn, 1:1)",
    New_Flow_Tutorials_generic_tip_2: "Element sayını 3–5 arasında saxlayın",
    New_Flow_Tutorials_generic_tip_3: "Başlıqları qısa və aydın yazın",
    New_Flow_Tutorials_generic_tip_4: "Oxşar məhsullar və müqayisələr üçün uyğundur",
    New_Flow_Tutorials_generic_limitation_1: "Hər karusel üçün maksimum 10 element",
    New_Flow_Tutorials_generic_connection_1: "✅ Mesaj Giriş Bloku",
    New_Flow_Tutorials_generic_connection_2: "✅ Alt-Qalereya Bloku",
    New_Flow_Tutorials_generic_connection_3: "❌ Veb Link Bloku",
    New_Flow_Tutorials_generic_connection_4: "❌ Səsli Mesaj Bloku",
    New_Flow_Tutorials_generic_connection_5: "❌ Mətn Mesaj Bloku",
    New_Flow_Tutorials_generic_connection_6: "❌ Sürətli Cavab Bloku",
    New_Flow_Tutorials_generic_connection_7: "❌ Şəkil & Video Bloku",

    New_Flow_Tutorials_genericitem_title: "Karusel Elementi",
    New_Flow_Tutorials_genericitem_description:
      "Karuseldə bir element: şəkil, başlıq, açıqlama, link və 3 düyməyə qədər",
    New_Flow_Tutorials_genericitem_usageType:
      "Məhsul detalları, xidmət təqdimatı, komanda göstərimi, portfel və qiymət paketləri üçün uyğundur.",
    New_Flow_Tutorials_genericitem_feature_1: "İsteğe bağlı web linki",
    New_Flow_Tutorials_genericitem_feature_2: "İsteğe bağlı şəkil: JPEG, PNG, GIF",
    New_Flow_Tutorials_genericitem_feature_3: "Video: MP4, WebM, OGG",
    New_Flow_Tutorials_genericitem_feature_4: "Müstəqil çıxışlara sahib 3 düyməyə qədər",
    New_Flow_Tutorials_genericitem_tip_1: "Hər element üçün cəlbedici şəkil əlavə edin",
    New_Flow_Tutorials_genericitem_tip_2: "Əsas mesaj üçün başlıq, detalları üçün açıqlama",
    New_Flow_Tutorials_genericitem_tip_3: "Linkləri göndərmədən əvvəl yoxlayın",
    New_Flow_Tutorials_genericitem_tip_4: "Düymə mətni qısa və aydın olsun",
    New_Flow_Tutorials_genericitem_tip_5: "Qısaldılmış link istifadə edin",
    New_Flow_Tutorials_genericitem_limitation_1: "Başlıq: maksimum 140 simvol",
    New_Flow_Tutorials_genericitem_limitation_2: "Açıqlama: maksimum 140 simvol",
    New_Flow_Tutorials_genericitem_limitation_3: "Maksimum 3 düymə",
    New_Flow_Tutorials_genericitem_limitation_4: "Düymə başlığı: maksimum 40 simvol",
    New_Flow_Tutorials_genericitem_limitation_5: "Fayl ölçüsü: maksimum 50 MB",
    New_Flow_Tutorials_genericitem_limitation_6: "Ən az bir düymə tələb olunur",
    New_Flow_Tutorials_genericitem_connection_1: "❌ Mesaj giriş bloku",
    New_Flow_Tutorials_genericitem_connection_2: "✅ Qalereya bloku",
    New_Flow_Tutorials_genericitem_connection_3: "✅ Web link bloku",
    New_Flow_Tutorials_genericitem_connection_4: "✅ Səsli mesaj bloku",
    New_Flow_Tutorials_genericitem_connection_5: "✅ Mətn mesajı bloku",
    New_Flow_Tutorials_genericitem_connection_6: "✅ Tez cavab bloku",
    New_Flow_Tutorials_genericitem_connection_7: "✅ Şəkil və video bloku",

    New_Flow_Tutorials_weblink_title: "Web Link Bloku",
    New_Flow_Tutorials_phonenumbergrabber_title: "Telefon Nömrəsi Toplayıcı Bloku",
    New_Flow_Tutorials_phonenumbergrabber_description:
      "Bu blok telefon nömrəsinin alınmasını gözləyir və nömrə alındıqda onu etibarlı nömrə kimi qeyd edir.",
    New_Flow_Tutorials_phonenumbergrabber_usageType:
      "Müştəri əlaqə nömrələrinin toplanması, qeydiyyat, sifariş izləməsi, məsləhət və satış əlaqəsi üçün uyğundur.",
    New_Flow_Tutorials_phonenumbergrabber_feature_1: "Telefon nömrəsi alınana qədər istifadəçinin cavabını gözləyir",
    New_Flow_Tutorials_phonenumbergrabber_feature_2: "Alınan nömrəni avtomatik yoxlayır və qeyd edir",
    New_Flow_Tutorials_phonenumbergrabber_tip_1: "Bu blokdan əvvəl mətn bloku ilə istifadəçidən nömrəsini istəyin",
    New_Flow_Tutorials_phonenumbergrabber_tip_2:
      "İstifadəçiyə gözlənilən nömrə formatını bildirin (məsələn, ölkə kodu ilə)",
    New_Flow_Tutorials_phonenumbergrabber_tip_3: "Bu blokdan sonra təsdiq və ya təşəkkür mesajı göndərin",
    New_Flow_Tutorials_phonenumbergrabber_limitation_1: "Axının ilk bloku ola bilməz",
    New_Flow_Tutorials_phonenumbergrabber_limitation_2: "Yalnız bir giriş və bir çıxışı var",
    New_Flow_Tutorials_phonenumbergrabber_limitation_3: "Yalnız etibarlı nömrələr qeyd olunur",
    New_Flow_Tutorials_phonenumbergrabber_connection_3: "❌ Qaleriya Alt-Şöbə Bloku",
    New_Flow_Tutorials_phonenumbergrabber_connection_2: "❌ Sürətli Cavab Bloku",
    New_Flow_Tutorials_phonenumbergrabber_connection_1: "❌ Mesaj Giriş Bloku (ilk blok ola bilməz)",
    New_Flow_Tutorials_weblink_description: "İstifadəçi brauzerində açılan kliklənə bilən web link göndərir",
    New_Flow_Tutorials_weblink_usageType:
      "Veb sayt, məhsul səhifəsi, mağaza, qeydiyyat formu, landing page və məqalələr üçün uyğundur.",
    New_Flow_Tutorials_weblink_feature_1: "URL avtomatik doğrulama",
    New_Flow_Tutorials_weblink_feature_2: "WWW ilə/olmadan link dəstəyi",
    New_Flow_Tutorials_weblink_tip_1: "Qısaldılmış link istifadə edin",
    New_Flow_Tutorials_weblink_tip_2: "Linkləri göndərmədən əvvəl test edin",
    New_Flow_Tutorials_weblink_tip_3: "Linklər mobil uyğun olmalıdır",
    New_Flow_Tutorials_weblink_tip_4: "Çox yönləndirmədən çəkinin",
    New_Flow_Tutorials_weblink_tip_5: "HTTPS istifadə edin",
    New_Flow_Tutorials_weblink_limitation_1: "Yalnız http:// və ya https:// etibarlıdır",
    New_Flow_Tutorials_weblink_limitation_2: "Açıqlama əlavə etmək mümkün deyil",
    New_Flow_Tutorials_weblink_limitation_3: "Daxili linklər (file://) dəstəklənmir",
    New_Flow_Tutorials_weblink_connection_1: "⬅️ Giriş: Alt qalereya bloku",
    New_Flow_Tutorials_weblink_connection_2: "❌ Çıxış yoxdur (Axın sonu)",

    // #region AIFlow Section

    // #region Notification Section
    Notify_Ok: "Əməliyyat uğurla tamamlandı",
    Notify_InternalException: "Sistemdə xəta baş verdi",
    Notify_CannotSendSmsNow: "Hazırda SMS göndərmək mümkün deyil",
    Notify_InvalidPhoneNumber: "Daxil edilən telefon nömrəsi etibarsızdır",
    Notify_InvalidCountryCode: "Daxil edilən ölkə kodu etibarsızdır",
    Notify_PhoneNumberNotAvailableInThisCountry: "Bu nömrə seçilmiş ölkədə istifadə oluna bilməz",
    Notify_InstagramerIdNotExist: "Instagram istifadəçisi tapılmadı",
    Notify_EmptyProductList: "Məhsul siyahısı boşdur",
    Notify_InvalidVerificationCode: "Daxil edilən təsdiq kodu düzgün deyil",
    Notify_LowQuality: "Məzmun keyfiyyəti aşağıdır",
    Notify_CannotEmptyChildren: "Alt elementləri silmək mümkün deyil",
    Notify_InvalidAspectRatio: "Daxil edilən ölçü nisbəti etibarsızdır",
    Notify_InvalidMediaCodec: "Media kodeki dəstəklənmir",
    Notify_InvalidMediaType: "Media növü dəstəklənmir",
    Notify_MediaUrlNotAccessible: "Media URL mövcud deyil",
    Notify_CannotCreatePrePostNow: "Hazırda ön göndəri yaratmaq mümkün deyil",
    Notify_InvalidMediaContent: "Media məzmunu etibarsızdır",
    Notify_Unexpected: "Gözlənilməz xəta baş verdi",
    Notify_TooManyRequestForImageHashtagGenerator: "Şəkil hashtag generatoru üçün çox sayda sorğu var",
    Notify_LoginFailed: "Giriş uğursuz oldu, zəhmət olmasa yenidən cəhd edin",
    Notify_NullUserId: "İstifadəçi ID daxil edilməyib",
    Notify_RealtimeSocketNotExist: "Serverə bağlantı yoxdur",
    Notify_PushSocketNotExist: "Bağlantı yoxdur",
    Notify_InstaApiNotFoundForConnect: "Instagram serverlərinə bağlantı yoxdur",
    Notify_EmptyHashtagList: "Hashtag siyahısı boşdur",
    Notify_InvalidHashtagListId: "Hashtag siyahısı ID-si etibarsızdır",
    Notify_DeleteHashtagFail: "Hashtag silinmədi",
    Notify_InvalidBase64Content: "Base64 məzmunu etibarsızdır",
    Notify_InvalidTermsAndConditionSvgType: "Qaydalar və şərtlər etibarsızdır",
    Notify_InvalidLotteryAnnouncementBannerId: "Lotereya elan banner ID-si etibarsızdır",
    Notify_InvalidLotteryAnnouncementBannerStr: "Lotereya elan banner mətn etibarsızdır",
    Notify_InvalidPostId: "Post ID etibarsızdır",
    Notify_TooSoonLotteryInfo: "Lotereya məlumatları çox tez göndərilib",
    Notify_InvalidDirectParams: "Direct parametrləri etibarsızdır",
    Notify_NoInstagramerExists: "Heç bir Instagram hesabı tapılmadı",
    Notify_PropertyNotFoundOrNull: "Element tapılmadı və ya boşdur",
    Notify_ReachNumberOfPinDirect: "Sabit mesajların maksimum sayı çatıb",
    Notify_InvalidStoryId: "Story ID etibarsızdır",
    Notify_MaxPrePostReach: "Maksimum ön paylaşımların sayı çatıb",
    Notify_InvalidDraftId: "Qaralama ID etibarsızdır",
    Notify_InvalidPrePostId: "Ön paylaşımların ID-si etibarsızdır",
    Notify_ReachHashtagListLimit: "Maksimum hashtag siyahısı sayı çatıb",
    Notify_EmptyUsername: "İstifadəçi adı daxil edilməyib",
    Notify_TooManyRequestForPageHashtagAnalysis: "Səhifə hashtag analizi üçün çox sayda sorğu var",
    Notify_PasswordRequired: "Şifrə tələb olunur",
    Notify_PackageRequiredInThisTime: "Aktiv paket tələb olunur",
    Notify_FeatureRequiredInThisTime: "Bu xüsusiyyət aktiv olmalıdır",
    Notify_NoShopperExist: "Heç bir satıcı tapılmadı",
    Notify_FollowerLotteryTypeRandomlyWithoutLoginForVerifiedOrPrivateAccount:
      "Giriş etmədən təsadüfi izləyici lotereyası xüsusi və ya təsdiqlənmiş hesablar üçün mümkün deyil",
    Notify_FollowerLotteryTypeEngagmentWithoutLoginForPrivateAccount:
      "Giriş etmədən izləyici qarşılıqlı lotereyası xüsusi hesablar üçün mümkün deyil",
    Notify_InvalidLinkId: "Link ID etibarsızdır",
    Notify_ReachMaxBioLink: "Biyografi linklərinin maksimum sayı çatıb",
    Notify_OnlyBusinessAccountHasThisAccess: "Bu giriş yalnız biznes hesablar üçün aktivdir",
    Notify_NoYoutubeChannelFound: "Heç bir YouTube kanalı tapılmadı",
    Notify_CannotGetYoutubeRightNow: "Hazırda YouTube məlumatı əldə etmək mümkün deyil",
    Notify_AparatUsernameNotFound: "Aparat istifadəçi adı tapılmadı",
    Notify_AparatChannelHasNotAnyVideo: "Aparat kanalı heç bir video ehtiva etmir",
    Notify_InvalidYoutubeChannelId: "YouTube kanal ID-si etibarsızdır",
    Notify_NoAparatChannelFound: "Heç bir Aparat kanalı tapılmadı",
    Notify_CannotGetAparatRightNow: "Hazırda Aparat məlumatı əldə etmək mümkün deyil",
    Notify_NotSettedCustomDomain: "Xüsusi domen təyin edilməyib",
    Notify_CannotStoryWithoutWinnerBanner: "Qalib banner olmadan Story yaradıla bilməz",
    Notify_ExceedMaxStoryWinnerLotteryBanner: "Story qalib banner sayı limiti aşdı",
    Notify_LotteryOnProcessingOrEnded: "Lotereya işlənir və ya bitib",
    Notify_CannotAbortLotteryOneHourBefore: "Lotereyanı icra etmədən bir saat əvvəl ləğv etmək mümkün deyil",
    Notify_CannotAbortFollowerLottery: "İzləyici lotereyasını ləğv etmək mümkün deyil",
    Notify_InvalidImageOrExceedMaxSize: "Şəkil etibarsızdır və ya maksimum ölçünü keçib",
    Notify_ExceedLoginAttempt: "Giriş cəhdlərinin maksimum sayı aşdı",
    Notify_NotExistComment: "Komment tapılmadı",
    Notify_UserNotFound: "İstifadəçi tapılmadı",
    Notify_ExistInstagramerBefore: "Bu Instagram hesabı artıq qeydiyyatdan keçib",
    Notify_CannotChangeBusinessAccountType:
      "Biznes hesabı növünü dəyişmək mümkün deyil, zəhmət olmasa dəstək ilə əlaqə saxlayın",
    Notify_InvalidProductId: "Daxil edilmiş məhsul ID-si etibarlı deyil",
    Notify_InvalidTrendHashtagPeriod: "Seçilmiş trend hashtag dövrü etibarlı deyil",
    Notify_InvalidLanguageId: "Dil ID-si etibarlı deyil",
    Notify_CannotStoryWithoutTermsBanner: "Şərtlər banneri olmadan Story yaradıla bilməz",
    Notify_ExceedMaxStoryTermsLotteryBanner: "Story lotereya şərtləri bannerlərinin sayı icazə verilən həddi keçib",
    Notify_LotteryTermsIsNull: "Lotereya şərtləri qeydə alınmayıb",
    Notify_CanShareTermsBefore6HoursOfStartLottery: "Şərtlər yalnız lotereya başlamazdan 6 saat əvvəl paylaşılabilir",
    Notify_CanShareTermForOnlyDefinedStatusLotteries:
      "Şərtlərin paylaşılması yalnız təyin edilmiş statusdakı lotereyalar üçün aktivdir",
    Notify_SharedRemainingTimeBefore: "Qalan vaxt artıq paylaşılmışdır",
    Notify_ShareRemainingTimeOnlyActiveForScoreLottery:
      "Qalan vaxtın paylaşılması yalnız xal lotereyaları üçün aktivdir",
    Notify_CanShareTermsBefore1HoursOfStartLottery: "Şərtlər yalnız lotereya başlamazdan 1 saat əvvəl paylaşılabilir",
    Notify_InvalidSubProductIds: "Alt məhsul ID-ləri etibarlı deyil",
    Notify_ReachMaxProductMedia: "Bu məhsul üçün maksimum media sayı çatılıb",
    Notify_InvalidMediaProductId: "Media məhsul ID-si etibarlı deyil",
    Notify_AccountNotABusiness: "Bu hesab biznes hesabı deyil",
    Notify_NotFoundProductWithThisTempId: "Bu müvəqqəti ID ilə məhsul tapılmadı",
    Notify_InvalidAvailabilityStatus: "Daxil edilmiş mövcudluq statusu etibarlı deyil",
    Notify_InvalidIbanNumber: "Daxil edilmiş IBAN nömrəsi etibarlı deyil",
    Notify_ExistedIbanNumber: "Bu IBAN nömrəsi artıq qeydiyyatdan keçib",
    Notify_IbanMethodNotAvailableForNotTomanPriceUser: "IBAN metodu, Toman olmayan istifadəçilər üçün aktiv deyil",
    Notify_SearchQueryIsEmpty: "Axtarış sorğusu boşdur",
    Notify_ExceedMaxInEachCard: "Hər kartdakı maddələrin sayı icazə verilən həddi keçib",
    Notify_ProductNotAlbumPost: "Bu məhsul albom Post olaraq qeydə alınmayıb",
    Notify_InvalidChildrenId: "Uşaq ID-si etibarlı deyil",
    Notify_NotAvailableProduct: "Məhsul hazırda mövcud deyil",
    Notify_ExceedStockCount: "Seçilmiş miqdar stokdan çoxdur",
    Notify_CannotUnloadAnInstanceProduct: "Məhsulun bir nüsxəsini boşaltmaq mümkün deyil",
    Notify_InvalidCategoryId: "Kateqoriya ID-si etibarlı deyil",
    Notify_NotFoundAnyProductOnThisCategory: "Bu kateqoriyada məhsul tapılmadı",
    Notify_NotFoundAnyNextProduct: "Növbəti məhsul tapılmadı",
    Notify_NotFoundAnyPreviousProduct: "Əvvəlki məhsul tapılmadı",
    Notify_InvalidItemId: "Maddə ID-si etibarlı deyil",
    Notify_IpInvalid: "Daxil edilmiş IP etibarlı deyil",
    Notify_InstagramRedirectInTenSeconds: "10 saniyə ərzində avtomatik olaraq Instagram-a yönləndiriləcəksiniz",
    Notify_InstagramRedirect: "Instagram-a yönləndirilir",
    Notify_InstagramRedirectExplain: "IP ünvanınız etibarlı olmadığı üçün VPN-in aktiv olduğundan əmin olun",
    Notify_ThisInstagramAccountAddedBefore: "Bu Instagram hesabı əvvəllər əlavə edilib",
    Notify_InvalidTicketId: "Bilet ID-si etibarlı deyil",
    Notify_ExpiredSignature: "İmza müddəti bitib",
    Notify_Forbidden: "İcazəsiz giriş",
    Notify_ConnectedInstagramPageNotFound: "Bağlı Instagram səhifəsi tapılmadı",
    Notify_AllInstagramAccountConnectedAddedBefore: "Bütün bağlı Instagram hesabları əvvəllər əlavə edilib",
    Notify_SelectInstagramPageToConnect: "Zəhmət olmasa qoşmaq istədiyiniz Instagram səhifəsini seçin",
    Notify_InstagramRedirectRoleNotFound: "Instagram yönləndirmə rolu tapılmadı",
    Notify_FacebookLoginNotFound: "Facebook giriş tapılmadı",
    Notify_SelectedPageNotFound: "Seçilmiş səhifə tapılmadı",
    Notify_ShouldConnectInstaPageAgain: "Instagram səhifəsini yenidən qoşmalısınız",
    Notify_InvalidProductSuggestionId: "Məhsul təklifi ID-si etibarlı deyil",
    Notify_NotSavedSuggestions: "Təkliflər yadda saxlanmayıb",
    Notify_ExistedSuggestedMedia: "Bu təklif olunan media artıq qeydiyyatdan keçib",
    Notify_InvalidUploadMediaUrl: "Media yükləmə URL-si etibarlı deyil",
    Notify_SuggestedPostAutoReplyKeyNotExist: "Təklif olunan Post avtomatik cavab açarı tapılmadı",
    Notify_UploadingTimeIsSoSoon: "Yükləmə vaxtı çox erkəndir",
    Notify_InvalidPreStoryId: "Pre-Story ID-si etibarlı deyil",
    Notify_NotProvidedInstagramerId: "Instagramer ID təqdim olunmayıb",
    Notify_InvalidInstagramerId: "Instagramer ID etibarlı deyil",
    Notify_InvalidThreadId: "Thread ID etibarlı deyil",
    Notify_InvalidLiveMediaId: "Canlı media ID-si etibarlı deyil",
    Notify_NotCreatedExportComment: "Comment çıxarışı yaradılmayıb",
    Notify_CreateExportAvailableWith24HourPeriod: "Çıxarış hər 24 saatda bir yaradılır",
    Notify_NotSetted: "Tənzimləmə edilməyib",
    Notify_ExceedGeneralAutoReplyCount: "Ümumi avtomatik cavab sayı limitdən çoxdur",
    Notify_InvalidTransactionId: "Əməliyyat ID-si etibarlı deyil",
    Notify_CannotRenewalPackageWith1MonthTimeExist: "1 aylıq paket hazırda yenilənə bilməz",
    Notify_CannotDeleteCurrentSession: "Cari sessiyanı silmək mümkün deyil",
    Notify_InvalidSessionId: "Sessiya ID-si etibarlı deyil",
    Notify_CannotDeleteCurrentSessionForNewSessionFor1Day:
      "Yeni sessiya yaratmaq üçün cari sessiya 1 gün ərzində silinə bilməz",
    Notify_UpgradedBefore: "Bu hesab əvvəllər yüksəldilib",
    Notify_PermissionNotExist: "İcazə mövcud deyil",
    Notify_NotExistUser: "İstifadəçi tapılmadı",
    Notify_UserAlreadyAsPartner: "İstifadəçi artıq partner admin kimi qeydiyyatdan keçib",
    Notify_ReachMaxPartnerCount: "Partner adminlərin maksimum sayı çatılıb",
    Notify_InvalidPartnerRoleProvided: "Təqdim olunan partner admin rolu etibarlı deyil",
    Notify_PartnerRolesLengthIsZero: "Partner admin üçün heç bir rol təyin edilməyib",
    Notify_PartnerNotExist: "Partner admin tapılmadı",
    Notify_CannotMakeYourSelfPartnerAsPartnerForYourSelf: "Özünüzü özünüzün partner admini olaraq seçə bilməzsiniz",
    Notify_PartnerExpireTimeMustBeBiggerThan1HourFromNow: "Partner adminin müddəti ən azı 1 saat sonra olmalıdır",
    Notify_PartnerNameCannotExceed100: "Partner admin adı 100 simvolu keçə bilməz",
    Notify_ProductIsMultiSubproducted: "Bu məhsul bir neçə alt məhsuldan ibarətdir",
    Notify_InvalidSubProductId: "Alt məhsul ID-si keçərli deyil",
    Notify_ProductIdOutOfStock: "Məhsul stokda yoxdur",
    Notify_SubProductIdRequired: "Alt məhsul ID-si tələb olunur",
    Notify_CardIsEmpty: "Kart boşdur",
    Notify_InvalidAddressId: "Ünvan ID-si keçərli deyil",
    Notify_ExceedTotalCreateAddress: "İcazə verilən maksimum ünvan sayı aşılmışdır",
    Notify_NotSupportedCountry: "Seçilmiş ölkə dəstəklənmir",
    Notify_CannotFetchAddressInThisEndpoint: "Bu endpointdə ünvan alınmır",
    Notify_InvalidPostalCode: "Poçt kodu keçərli deyil",
    Notify_NeedCompleteAddress: "Tam ünvan daxil etmək tələb olunur",
    Notify_CannotBuyFromYourSelf: "Özünüzdən ala bilməzsiniz",
    Notify_AllReadyIsBusiness: "Bu hesab artıq biznes kimi qeydiyyatdan keçib",
    Notify_InvalidBusinessType: "Biznes hesab növü keçərli deyil",
    Notify_UserAlreadyAuthorized: "İstifadəçi artıq təsdiqlənib",
    Notify_InstagramerNotInfluencer: "Instagramer influencer deyil",
    Notify_InstagramerNotShopper: "Instagramer satıcı deyil",
    Notify_AuthorizedInstagramerBefore: "Bu Instagramer artıq təsdiqlənib",
    Notify_UserNotAuthorizedYet: "İstifadəçi hələ təsdiqlənməyib",
    Notify_InstagramerNotAuthorized: "Instagramer təsdiqlənməyib",
    Notify_InvalidBankCardNumber: "Bank kartı nömrəsi keçərli deyil",
    Notify_TheOwnerOfPhoneNumberNotBlongsNationalNumber: "Telefon nömrəsinin sahibi milli nömrə ilə uyğun gəlmir",
    Notify_CouponCodeAlreadyExists: "Kupon kodu artıq mövcuddur",
    Notify_InvalidCouponId: "Kupon ID-si keçərli deyil",
    Notify_CannotChangeShowPrivateCouponInBio: "Bio-da xüsusi kuponun göstərilməsini dəyişmək mümkün deyil",
    Notify_InvalidCouponCode: "Kupon kodu keçərli deyil",
    Notify_CouponForAnotherPerson: "Kupon başqa birinə məxsusdur",
    Notify_CouponExpired: "Kuponun müddəti bitib",
    Notify_CouponDeleted: "Kupon silinib",
    Notify_CouponUsedUp: "Kupon istifadə olunub",
    Notify_InvalidUsernameSearchQuery: "İstifadəçi adı axtarış sorğusu keçərli deyil",
    Notify_PreviouslyAddedShopAddress: "Bu mağaza ünvanı əvvəllər əlavə olunub",
    Notify_NotSettedShopperAddress: "Alıcının ünvanı təyin olunmayıb",
    Notify_NotExistAnyLogesticInYourCountry: "Ölkənizdə heç bir loqistika sistemi yoxdur",
    Notify_InvalidLogesticIds: "Loqistika ID-ləri keçərli deyil",
    Notify_LogsticsNotSetted: "Loqistika təyin olunmayıb",
    Notify_NotCommpletedAllBusinessVerification: "Bütün biznes təsdiqləri tamamlanmayıb",
    Notify_ThisParcelNotSupportedByAnySelectedAvailableLogestic:
      "Bu paket seçilmiş mövcud loqistika tərəfindən dəstəklənmir",
    Notify_NotSupportedLogestic: "Seçilmiş loqistika dəstəklənmir",
    Notify_ExceedLogesticHeight: "Paketin hündürlüyü loqistika limitini aşır",
    Notify_ExceedLogesticWidth: "Paketin eni loqistika limitini aşır",
    Notify_ExceedLogesticLength: "Paketin uzunluğu loqistika limitini aşır",
    Notify_ExceedLogesticTotalLength: "Paketin ümumi uzunluğu loqistika limitini aşır",
    Notify_ExceedLogesticWeight: "Paketin çəkisi loqistika limitini aşır",
    Notify_UserAddressesIsEmptyOrNotSetDefaultAddress:
      "İstifadəçi ünvanları boşdur və ya standart ünvan təyin olunmayıb",
    Notify_NotSupportedBoxByThisDimensions: "Bu ölçüdə qutu dəstəklənmir",
    Notify_CannotAvailableOutOfStackProduct: "Məhsulu stokdan kənar etmək mümkün deyil",
    Notify_YouAreDeadInCivilRegistration: "Siz vətəndaş qeydiyyatında vəfat etmiş kimi qeyd olunmusunuz",
    Notify_InstagramerAlreadyAuthorized: "Instagramer artıq səlahiyyət verilib",
    Notify_ThreadShouldBeActiveForSendMessage: "Mesaj göndərmək üçün mövzu aktiv olmalıdır",
    Notify_PreviouslyClosedTicket: "Bilet əvvəllər bağlanıb",
    Notify_NotMatchedCart: "Səbət uyğun deyil",
    Notify_PhoneNumberNotBlongsNationalNumber: "Telefon nömrəsi milli nömrə ilə uyğun deyil",
    Notify_NotMatchedCardNumberAndIdentity: "Kart nömrəsi və şəxsiyyət məlumatları uyğun deyil",
    Notify_SuspendedShop: "Bu mağaza dayandırılıb, zəhmət olmasa dəstək ilə əlaqə saxlayın",
    Notify_LogesticIdNotSpecifiedForaPostParcel: "Poçt paketi üçün loqistika ID göstərilməyib",
    Notify_LogesticNotInAvailableLogestics: "Seçilmiş loqistika mövcud loqistika siyahısında yoxdur",
    Notify_ExceedProductReportForLast24Hour: "Son 24 saatda məhsul hesabatlarının sayı limiti aşır",
    Notify_PreviouslyReportedThisProduct: "Bu məhsulu əvvəllər bildirmisiniz",
    Notify_InvalidOrderId: "Sifariş ID keçərli deyil",
    Notify_NotPendingPayRequest: "Ödəniş tələbi gözləmədə deyil",
    Notify_NotExistShopAddress: "Mağaza ünvanı tapılmadı",
    Notify_InvalidOrderStatus: "Sifariş statusu keçərli deyil",
    Notify_CancelInvoiceFailed: "Fakturanı ləğv etmək alınmadı",
    Notify_PaymentSystemNotSupportedThisPriceType: "Ödəniş sistemi bu qiymət növünü dəstəkləmir",
    Notify_InvalidSentOrderType: "Göndərilən sifariş növü keçərli deyil",
    Notify_InvalidParcelId: "Paket ID keçərli deyil",
    Notify_AddedParcelIdBefore: "Paket ID əvvəllər əlavə olunub",
    Notify_InvoiceNotOnPaid: "Faktura hələ ödənilməyib",
    Notify_CreatedSystemTicketOnOrderBefore: "Bu sifariş üçün sistem bileti artıq yaradılıb",
    Notify_PaymentServiceNotResponding: "Ödəniş xidməti hazırda cavab vermir",
    Notify_YouAreNotAdmin: "Siz admin deyilsiniz",
    Notify_YouAreNotASubAdmin: "Siz sub-admin deyilsiniz",
    Notify_InvalidFbId: "Yanlış Facebook ID",
    Notify_InvalidFeatureId: "Yanlış xüsusiyyət ID",
    Notify_InActiveFeature: "Bu xüsusiyyət aktiv deyil",
    Notify_FeaturePaused: "Bu xüsusiyyət dayandırılıb",
    Notify_InvalidPromptInput: "Yanlış prompt girişi",
    Notify_PromptNotGenerated: "Prompt yaradılmayıb",
    Notify_AIGeneratorFailed: "AI generator xəta ilə qarşılaşıb",
    Notify_NotExecutedPromptForCommentYet: "Yorum üçün prompt hələ icra olunmayıb",

    Notify_InstagramPermissionNotExist: "Instagram icazəsi mövcud deyil",
    Notify_InvalidTimeZone: "Vaxt zonası etibarlı deyil",
    Notify_PromptCaptionExampleNotGenerated: "Prompt başlıq nümunəsi yaradılmayıb",
    Notify_InvalidMasterFlowId: "Ana axın ID-si etibarlı deyil",
    Notify_InvalidFlowId: "Axın ID-si etibarlı deyil",
    Notify_EmptySubFlows: "Alt axınlar boşdur",
    Notify_InvalidFlowObject: "Axın etibarlı deyil",
    Notify_InvalidMasterFlowTitle: "Ana axın başlığı etibarlı deyil",
    Notify_InvalidPromptId: "Prompt ID-si etibarlı deyil",
    Notify_ExceedThreadTokenLimit: "Bu söhbətin token limiti aşılıb",
    Notify_InvalidMediaId: "Media ID-si etibarlı deyil",
    Notify_InvalidLotteryId: "Lotereya ID-si etibarlı deyil",
    Notify_CannotAbortNonUpcomingLottery: "Gələcək olmayan lotereyaları ləğv etmək mümkün deyil",
    Notify_CommentCountExceedFreeExport: "Şərh sayı pulsuz lotereya üçün icazəli həddi aşır",
    Notify_InvalidReserveFeatureId: "Rezerv funksiya ID-si etibarlı deyil",
    Notify_CannotRenewalThisFeatureNow: "Bu funksiyanı indi yeniləmək mümkün deyil",
    Notify_InvalidLotteryStatus: "Lotereya statusu dəyişiklik üçün etibarlı deyil",
    Notify_PublishedLotteryBannerBefore: "Lotereya banneri əvvəllər nəşr olunub",
    Notify_LotteryWinnerBannerIsNull: "Lotereya qalibi banneri mövcud deyil",
    Notify_InvalidCustomPromptSigniture: "Fərdi sorğu imzası etibarsızdır",
    Notify_ServiceTemporarilyUnavailable: "Xidmət müvəqqəti olaraq əlçatmazdır",
    Notify_PageSummaryNotGenerated:
      "Brancy səhifənizi təhlil etmək üçün daha çox məlumata ehtiyac duyur.\nZəhmət olmasa, səbrli olun.",
    Notify_GenerateAIFail: "Süni intellekt generasiyası uğursuz oldu",
    Notify_InvalidPageAnalysis: "Yanlış səhifə təhlili",
    Notify_InvalidCustomPrompt: "Yanlış xüsusi istem",
    Notify_AIModelNotSupportImage: "SI modeli şəkilləri dəstəkləmir",
    Notify_PromptNotSupportImage: "İstem şəkilləri dəstəkləmir",
    Notify_AIModelNotSupportAudio: "SI modeli audio dəstəkləmir",
    Notify_PromptNotSupportVoice: "İstem sesi dəstəkləmir",
    Notify_AIModelNotSupportVideo: "SI modeli videonu dəstəkləmir",
    Notify_InvalidPrompt: "Yanlış istem",
    Notify_InvalidImageGeneratorInput: "Yanlış şəkil generatoru girişi",
    Notify_InSuffcientNumberOfImage: "Şəkillərin sayı kifayət deyil",
    Notify_CreateImageExceedLimit: "Şəkil yaratma limiti aşılıb",
    Notify_InvalidPromptType: "Yanlış istem növü",
    Notify_UnSupportedAIInputType: "Dəstəklənməyən SI giriş növü",
    Notify_UnSupportedOrientationType: "Dəstəklənməyən oriyentasiya növü",
    Notify_SoraFailedAiCall: "Sora SI çağırışı uğursuz oldu",
    Notify_AIVideoSecondNotSupported: "SI video müddəti dəstəklənmir",
    Notify_FailedToTraslateDescription: "Təsviri tərcümə etmək alınmadı",
    Notify_FailedToGenerateEmbedVector: "Yerləşdirmə vektoru yaratmaq alınmadı",
    Notify_NotGeneratedSummaryYet: "Xülasə hələ yaradılmayıb",
    Notify_NoEventsFoundForTheGivenTimeRange: "Verilmiş vaxt aralığı üçün hadisə tapılmadı",
    Notify_NoEventsFoundForThisPrompt: "Bu istem üçün hadisə tapılmadı",
    Notify_PageAnalysisNotExist: "Səhifə təhlili mövcud deyil",
    Notify_NoEventIdeaGenerated: "Heç bir hadisə ideyası yaradılmadı",
    Notify_PhoneNumberAddedBefore: "Bu telefon nömrəsi daha əvvəl əlavə edilib",
    Notify_WhatsAppCodeSendedBeforeAndWait1Day: "WhatsApp kodu daha əvvəl göndərilib. Zəhmət olmasa bir gün gözləyin",
    Notify_WhatsAppCodeNotRequested: "WhatsApp təsdiq kodu tələb edilməyib",
    Notify_WhatsAppCodeMaxInvalidCountReach: "Yanlış WhatsApp kodu cəhdlərinin maksimum sayına çatılıb",
    Notify_UserWithThisPhoneNumberAlreadyExist: "Bu telefon nömrəsi ilə istifadəçi artıq mövcuddur",
    Notify_InvalidAIToolId: "AI alətinin ID-si yanlışdır",
    Notify_AIToolParameterRequired: "AI alətinin parametri tələb olunur",
    Notify_AIToolParameterNotRequired: "Bu AI aləti parametr qəbul etmir",
    Notify_ExceedDailyLimit: "Gündəlik limit aşılıb",
    Notify_CannotGetTwitchRightNow: "Hazırda Twitch məlumatlarını əldə etmək mümkün deyil",
    Notify_InvalidTwitchChannelId: "Twitch kanal ID-si yanlışdır",
    Notify_PhoneNumberRequired: "Telefon nömrəsi tələb olunur",
    Notify_NotVerifiedHost: "Host təsdiqlənməyib",
    Notify_NotBusinesser: "Bu istifadəçi biznes sahibi deyil",
    Notify_NotFoundAnySuggestedCategory: "Heç bir təklif olunan kateqoriya tapılmadı",
    Notify_NoInvoiceExist: "Heç bir faktura mövcud deyil",
    Notify_InvalidMediaAiCreatorKey: "Süni intellekt modeli yanlışdır",
    Notify_InvalidMediaAiVersionKey: "Süni intellekt versiyası yanlışdır",
    Notify_InvalidMediaAiRequestModel: "Süni intellekt media sorğu modeli yanlışdır",
    Notify_MediaAIError: "Süni intellekt mediasının yaradılması zamanı xəta baş verdi",
    Notify_TwitchChannelDoestHaveAnyVideo: "Bu Twitch kanalında heç bir video yoxdur",
    Notify_CouponAlreadyDeleted: "Bu kupon artıq silinib",
    Notify_CouponNotDeleted: "Bu kupon silinməyib",
    Notify_ExceedSubFlowCount: "Alt axınların maksimum sayı aşılıb",
    Notify_ExceedFlowDepth: "Axının maksimum dərinliyi aşılıb",
    Notify_ExceedFlowItemCount: "Axın elementlərinin maksimum sayı aşılıb",
    Notify_ExceedFlowMediaAudioCount: "Axındakı media və səs fayllarının maksimum sayı aşılıb",
    Notify_OneFlowButtonHasEmptyItem: "Düymələrdən birinin axını yoxdur",
    InternalNotify_Ok: "Əməliyyat uğurla tamamlandı",
    InternalNotify_RepetitiveHashtagInput: "Daxil edilmiş hashtag təkrarlıdır",
    InternalNotify_NotFoundDevice: "Cihaz tapılmadı",
    InternalNotify_EmptyHashtagList: "Boş siyahı yaradıla bilməz",
    InternalNotify_CannotCreatePrePostNow: "Hazırda ön-post yarada bilməzsiniz",
    InternalNotify_PrivateAccountSelectedForCheckHashtag: "Analiz üçün xüsusi hesab seçilə bilməz",
    InternalNotify_InstagramLoginRequired: "Bu seçim Instagram girişini tələb edir",
    InternalNotify_InstagramLoginRequiredForVerifiedAccount:
      "Bu seçim təsdiqlənmiş hesablar üçün Instagram girişini tələb edir",
    InternalNotify_PrivateOrVerifiedSponsor: "Xüsusi və ya təsdiqlənmiş hesab sponsor kimi seçilə bilməz",
    InternalNotify_StartUploadingPost: "Post yüklənir",
    InternalNotify_UploadingPostError: "Post yüklənərkən xəta baş verdi",
    InternalNotify_PostUploaded: "Post yükləndi, görmək üçün səhifəni yeniləyin",
    InternalNotify_ExceededMedia: "Media sayı limiti keçdi",
    InternalNotify_More4IceBreaker: "4-dən çox sürətli söhbət edə bilməzsiniz",
    InternalNotify_CopyLink: "Linkiniz kopyalandı",
    InternalNotify_copy: "Məlumat uğurla kopyalandı",
    InternalNotify_CopyTrackingpost: "Paket izləmə kodunuz kopyalandı",
    InternalNotify_Network: "Şəbəkə bağlantısı xətası",
    InternalNotify_TimeExpire: "Qeydiyyat mümkün deyil, vaxt bitib",
    InternalNotify_ExceedPermittedHashtagNumber: "Hashtag sayı icazə verilən həddi keçib",
    InternalNotify_UnexpectedError: "Gözlənilməz xəta baş verdi",
    InternalNotify_CopyToClipboard: "Məlumatlarınız artıq panoya kopyalanıb",
    InternalNotify_ExceedPermittedUploadMedia: "Media sayı icazə verilən həddi aşır",
    InternalNotify_FillRedBorderFields: "Qırmızı çərçivəli sahələri doldurun",
    InternalNotify_RepeatedVariation: "Ən azı iki element təkrarlanıb",
    InternalNotify_NeedOneProduct: "Ən azı bir məhsul tələb olunur",
    InternalNotify_UploadMedia: "Media yüklənməsində problem var",
    InternalNotify_TurnOnProxy: "Etibarlı IP istifadə etməlisiniz",
    InternalNotify_ExceedPermittedLiveTime: "Canlı vaxt icazə verilən həddi keçib",
    InternalNotify_CommentDisabled: "Şərhlər deaktiv olduqda əməliyyat edə bilməzsiniz",
    InternalNotify_ExceedSelectedCollaboratorPage: "Seçilmiş əməkdaş səhifələrinin sayı icazə verilən həddi keçib",
    InternalNotify_RepetitiveCollaboratorPage: "Bu istifadəçi adı artıq seçilib",
    InternalNotify_ExceedPermittedSizeOfImage: "Şəklin ölçüsü icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedAspectRatioAlbum: "Albom video en-boy nisbəti icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedSizeOfVideoAlbum: "Albom video ölçüsü icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedDurationOfVideoAlbum: "Albom video müddəti icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedAspectRatioReels: "Reels en-boy nisbəti icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedSizeOfVideoReels: "Reels ölçüsü icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedDurationOfVideoReels: "Reels müddəti icazə verilən həddi keçib",
    InternalNotify_NotPermittedMediaType: "Media növü icazə verilən növ deyil",
    InternalNotify_InvalidMetaData: "Meta məlumatlar etibarlı deyil",
    InternalNotify_ExceedSelectedMaxTaggedPeople: "Etiketlenen insanların sayı icazə verilən həddi keçib",
    InternalNotify_ExceedSelectedMaxHashtags: "Seçilmiş hashtagların sayı icazə verilən həddi keçib",
    InternalNotify_ExistedInCollaborate:
      "Bu istifadəçi adı artıq əməkdaşlar arasında mövcuddur və ilk slaydda ola bilməz",
    InternalNotify_ExceedPermittedAspectRatioStory: "Story nisbəti icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedSizeOfVideoStory: "Story videonun ölçüsü icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedWidthOfVideo: "Videonun eni icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedDurationOfVideoStory: "Story videonun müddəti icazə verilən həddi keçib",
    InternalNotify_BelowMinimumDurationOfVideoStory: "Story videosu ən azı 3 saniyə olmalıdır",
    InternalNotify_ExceedPermittedSpecificWordForAutoreply:
      "Avtomatik cavab üçün xüsusi sözlərin sayı icazə verilən həddi keçib",
    InternalNotify_ExceedPermittedAspectRatioImage: "Şəklin nisbəti icazə verilən həddi keçib",
    InternalNotify_Success: "Əməliyyat uğurla tamamlandı",
    InternalNotify_CreateExportAvailableWith24HourPeriod: "24 saatlıq dövr ilə ixrac yaratmaq mümkündür",
    InternalNotify_SaveIceBreaker: "Uğurla əlavə edildi",
    InternalNotify_deleteIceBreaker: "Uğurla silindi",
    InternalNotify_SavePersistenceMenu: "Davamlı menyu uğurla əlavə edildi",
    InternalNotify_SelectLanguage: "Dil uğurla dəyişdirildi",
    InternalNotify_SaveFollowTemplate: "Follow şablonu uğurla yadda saxlanıldı",
    InternalNotify_AutoReplyOn: "Avtomatik cavab uğurla aktiv edildi",
    InternalNotify_AutoReplyOff: "Avtomatik cavab uğurla deaktiv edildi",
    InternalNotify_AutoGeneralOn: "Ümumi avtomatik cavab uğurla aktiv edildi",
    InternalNotify_AutoGeneralOff: "Ümumi avtomatik cavab uğurla deaktiv edildi",
    InternalNotify_MaxInEachCard: "Hər kartda maksimum",
    InternalNotify_ExceedStockCard: "Tələb olunan miqdar kart stokunu aşır",
    InternalNotify_DefaultAddress: "Varsayılan ünvanı silə bilməzsiniz",
    InternalNotify_FetchingYourData: "Məlumatlarınız alınır, zəhmət olmasa gözləyin...",
    InternalNotify_EmptyTitleInQuickReply: "Sürətli cavab başlığı boşdur",
    InternalNotify_EmptyTitleForOutputsInQuickReply: "Sürətli cavabdakı çıxış başlıqları boşdur",
    InternalNotify_EmptyTitleForFlow: "Axın başlığı boşdur",
    InternalNotify_MultipleFlowForPrivateReply: "Şəxsi cavab üçün birdən çox axın ola bilməz",
    InternalNotify_NotPermittedForDownload: "Bu məzmunu yükləməyə icazəniz yoxdur",
    InternalNotify_NotFeature: "Bu xüsusiyyət sizin paketinizdə mövcud deyil",
    InternalNotify_ExceedBasefeatureTime: "Əsas xüsusiyyətin müddəti icazə verilən həddi keçib",
    InternalNotify_ChannelIdNotStartedWithUC: "Channel ID 'UC' ilə başlamalıdır",
    InternalNotify_PageAnalysisNotCompleted: "Təəssüf ki, səhifəniz hələ süni intellekt tərəfindən analiz edilməyib",
    JustCreated: "Tiket qeyd olunub",
    AdminReplied: "Dəstək cavab verib",
    UserReplied: "İstifadəçi cavab verib",
    AdminClosed: "Tiket dəstək tərəfindən bağlanıb",
    UserClosed: "Tiket istifadəçi tərəfindən bağlanıb",
    TimerClosed: "Tiket avtomatik olaraq bağlanıb",
    closethisticket: "Bu bileti bağla",

    Create: "Yarat",
    image: "şəkil",
    video: "video",
    Images: "Şəkillər",
    Videos: "Videolar",
    "Generated artwork and visuals": "Yaradılmış sənət və vizuallar",
    "AI motion and clips": "Süni intellekt hərəkətləri və klipləri",
    "Media type": "Media növü",

    "Generated AI video preview": "Süni intellektlə yaradılmış video önizləməsi",

    Close: "Bağla",
    Prompt: "Prompt",
    Metadata: "Metaməlumat",
    Creator: "Yaradıcı",
    Version: "Versiya",
    Status: "Status",
    "Image ID": "Şəkil ID-si",
    "Video ID": "Video ID-si",
    "Job ID": "Tapşırıq ID-si",
    "Download image": "Şəkli endir",
    "Download video": "Videonu endir",
    "Your browser does not support video playback.": "Brauzeriniz video oynatmanı dəstəkləmir.",

    Uploading: "Yüklənir",
    "Add video": "Video əlavə et",
    "Add audio": "Audio əlavə et",
    "Add reference image": "İstinad şəkli əlavə et",
    model: "model",
    models: "modellər",
    "resize aspect ratio": "ölçünü dəyişdir",
    "Video models": "Video modelləri",
    "Image models": "Şəkil modelləri",
    "Cost level {level}": "Maliyyət səviyyəsi {level}",
    "Calculating...": "Hesablanır...",
    "Search from People or Keyword": "İnsan və ya açar söz axtar",
    "Create new Flow": "Yeni axın yarat",
    "Welcome illustration": "Xoş gəldiniz illüstrasiyası",
    "Untitled generation": "Adsız yaradılış",
    "No images yet": "Hələ şəkil yoxdur",
    "No videos yet": "Hələ video yoxdur",
    "Your successful image generations will appear here.": "Uğurlu şəkil yaradılışlarınız burada görünəcək.",
    "Your successful video generations will appear here.": "Uğurlu video yaradılışlarınız burada görünəcək.",
    "Create your first image": "İlk şəklinizi yaradın",
    "Create your first video": "İlk videonuzu yaradın",
    "Generating image": "Şəkil yaradılır",
    "Generating video": "Video yaradılır",
    "In progress": "Davam edir",
    "Just now": "İndicə",
    "Waiting for the result": "Nəticə gözlənilir",

    "Try again": "Yenidən cəhd edin",

    "AI provider": "Süni intellekt təminatçısı",

    "Choose a model": "Model seçin",

    "Describe the subject, setting, light, composition, and style...":
      "Mövzunu, mühiti, işığı, kompozisiyanı və üslubu təsvir edin...",
    "Use at least {count} characters.": "Ən azı {count} simvoldan istifadə edin.",
    "Video creator is unavailable": "Video yaradıcısı mövcud deyil",
    "Image creator is unavailable": "Şəkil yaradıcısı mövcud deyil",
    "No video models found": "Video modeli tapılmadı",
    "No image models found": "Şəkil modeli tapılmadı",
    "There are no video generation models available for this account.":
      "Bu hesab üçün video yaratma modeli mövcud deyil.",
    "There are no image generation models available for this account.":
      "Bu hesab üçün şəkil yaratma modeli mövcud deyil.",
    "Not available": "Mövcud deyil",
    // #endregion Notification Section
    Statistics_Replies_down_summary: "Auditoriyanız uzaqlaşmış kimi görünür; daha şəxsi məzmunla yenidən əlaqə qurun.",
    Statistics_Replies_down_action_1: "Bir neçə şəxsi, təcrübəyə əsaslanan və ya emosional Story paylaşın.",
    Statistics_Replies_down_action_2: "Cavab vermək üçün şəxsi təcrübə tələb edən suallar verin.",
    Statistics_Replies_down_action_3: "İlk cavabları prioritetləşdirin; onlara reaksiya verin və ya cavab yazın.",
    Statistics_Replies_down_urgency: "Yüksək",
    Statistics_Replies_zero_title: "Sıfır Cavab 💡 Direct Dəvəti Lazımdır",
    Statistics_Replies_zero_summary: "Heç kim cavab vermədikdə, cəlbedici və Direct suallar vermək lazımdır.",
    Statistics_Replies_zero_action_1: "İki seçim arasında seçim etmək kimi çox sadə və interaktiv suallar paylaşın.",
    Statistics_Replies_zero_action_2: "Aldığınız cavabları önə çıxararaq digərlərini iştirak etməyə təşviq edin.",
    Statistics_Replies_zero_action_3: "Hər gün yüngül və interaktiv Story paylaşın.",
    Statistics_Replies_zero_urgency: "Yüksək",
    how: "Necə",
    ConnectProduct: "Məhsula Birbaşa Bağlantı",
    messagesetting_ConnectProductResponseExplain: "Məhsulunuzu Story və ya Live-a qoşun.",
    biolinkProperties_Connect: "Qoşul",
    economy: "İqtisadi",
    Retry: "Yenidən cəhd et",
    messagesetting_SpecifyProductResponseExplain: "İstifadəçilərə avtomatik göndərilməsi üçün bir məhsul seçin",
    messagesetting_ProductResponseExplain: "Cari məhsulu istifadəçiyə bağlayın",

    // #region wallet
    createdtime: "Yaradılma vaxtı",
    BankCards: "Bank kartları",
    Transactions: "Əməliyyatlar",
    Settlements: "Hesablaşmalar",
    AddNewBankCard: "Yeni bank kartı əlavə et",
    RegisterANewCard: "Yeni kartı qeydiyyatdan keçir",
    CardBankNumber: "Bank kartı nömrəsi",
    CardNumberExplain: "Kart nömrənizi daxil edin. Bank kartı qeydiyyatdan keçən şəxsin adına olmalıdır.",
    RegisterBankCard: "Bank kartını qeydiyyatdan keçir",
    CardNumber: "Kart nömrəsi",
    DefaultBankCard: "Defolt bank kartı",
    SetAsDefaultBankCard: "Defolt bank kartı kimi təyin et",
    Type: "Növ",
    Suspended: "Dayandırılıb",
    Amount: "Məbləğ",
    Time: "Vaxt",
    Order: "Sifariş",
    User: "İstifadəçi",
    NotAvailable: "Mövcud deyil",
    Unsettled: "Hesablaşılmayıb",
    AwaitingSettled: "Hesablaşma gözlənilir",
    Settled: "Hesablaşma tamamlanıb",
    SettlementFailed: "Hesablaşma uğursuz oldu",
    SettleRequest: "Hesablaşma sorğusu",
    emptyInvoice: "Hələ heç bir hesab-faktura qeydiyyatdan keçirilməyib.",
    InvoiceID: "Hesab-faktura ID-si",
    InvoiceType: "Hesab-faktura növü",
    InvoiceHistory: "Hesab-faktura tarixçəsi",
    OrderDetails: "Sifariş detalları",
    InvoiceDetails: "Hesab-faktura detalları",
    Paid: "Ödənilib",
    Success: "Uğurlu",
    RefundRequest: "Geri ödəniş sorğusu",
    Refunding: "Geri ödəniş edilir",
    Refunded: "Geri ödənilib",
    RefundFailed: "Geri ödəniş uğursuz oldu",
    Failed: "Uğursuz",
    Package: "Paket",
    Product: "Məhsul",
    Feature: "Funksiya",
    Custom: "Fərdi",
    Invoice: "Hesab-faktura",
    UnknownStatus: "Naməlum status",
    NoSettlementsRegisteredYet: "Hələ heç bir hesablaşma qeydiyyatdan keçirilməyib.",
    LogesticPayment: "Logistika ödənişi",
    ProductIncome: "Məhsul gəliri",
    BrancyFeatureIncome: "Brancy funksiya gəliri",
    BrancyLogesticPayment: "Brancy logistika ödənişi",
    BrancyPackageIncome: "Brancy paket gəliri",
    BrancyProductIncome: "Brancy məhsul gəliri",
    BrancyTransferPayment: "Brancy köçürmə haqqı",
    WalletBalance: "Pul kisəsi balansı",
    TotalWithdrawn: "Ümumi çıxarılan məbləğ",
    FailedTransactions: "Uğursuz əməliyyatlar",
    PendingSettlement: "Hesablaşma gözlənilir",
    OrderInProgress: "Sifariş emal olunur",
    OrderPickup: "Sifarişin götürülməsi",
    OrderDelivery: "Sifarişin çatdırılması",
    SubInvoiceHistory: "Alt hesab-fakturaların tarixçəsi",
    history: "Tarixçə",
    // #endregion wallet
  },
};
